<template>
  <div class="personalServer" id="personalServer">
    <!-- <div class="isShowDeleteBox"> -->
    <div
      class="btn_isInvalid"
      @click="isShowInvalid = !isShowInvalid"
      v-if="!isSelect"
    >
      <i :class="`icon_${isShowInvalid ? 'hide' : 'show'}Invalid`" />{{
        isShowInvalid ? "隐藏" : "显示"
      }}已失效的数据
    </div>
    <!-- <div><i class="icon_hideDelete"/>隐藏已失效的数据</div> -->
    <!-- </div> -->
    <div class="mainTitle">
      {{ isSelect ? "生成个人信息报告" : "数据档案" }}
    </div>
    <div class="topTip" v-if="!isSelect">
      <img
        src="https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/pi1.png"
        alt=""
        class="pi1"
      />
      <div class="description">
        <div v-if="userInfo.status !== '3' && userInfo.status !== '4'">
          您的账号尚未进行实名认证，完成实名认证后您可以查看数据档案详情、补充自填信息、申请勘误、生成个人信息报告。
          <!-- {{
            userInfo.status !== "3" && userInfo.status !== "4"
              ? "您的账号尚未进行实名认证，完成实名认证后您可以查看数据档案详情、补充自填信息、申请勘误、生成个人信息报告。"
              : "数据档案中收录并展示您的全部数据档案数据，数据来源包括自填、国家公信力权威部门、学校/企业/社会机构。您可在此页面查看和自填信息，完善数据档案后可去生成您的个人信息报告"
          }} -->
        </div>
        <div v-else>
          数据档案中展示的所有数据均通过全国人力资源信息数据验证平台收录，数据来源包括自填、国家公信力权威部门、学校/企业/社会机构。您可在此页面查看和自填信息，请您务必仔细核实您自填的各类数据内容，平台再次告知，您对您自填的数据内容负真实可靠性的法律责任，<span
            >填写/修改记录将永久保留。</span
          >
        </div>
        <div v-if="userInfo.status !== '3' && userInfo.status !== '4'">
          <!-- <Btn
            v-if="userInfo.status === '3' || userInfo.status === '4'"
            btnText="生成个人信息报告"
            className="primary"
            :fontSize="16"
            :width="168"
            @handleClick="handleGenerateReport"
          /> -->
          <!-- v-if="userInfo.status !== '3' && userInfo.status !== '4'" -->
          <Btn
            style="margin-top:25px"
            @handleClick="handleCertification"
            btnText="进行实名认证"
            :width="142"
            :height="41"
            className="primary"
          />
        </div>
      </div>
    </div>

    <div v-else class="selectTip">
      <i class="icon_tip"></i
      >生成的个人信息报告可通过授权允许他人查看，您可根据您的需求选择性勾选报告生成内容，该份报告生成后不可再次修改。
    </div>

    <QA v-if="!isSelect" :showToggle="true" />

    <Anchor v-if="!Array.isArray(list)" />
    <div
      id="warning"
      class="warning"
      v-if="!isSelect && (userInfo.status === '3' || userInfo.status === '4')"
    >
      <TipText
        id="tipText"
        text="请完善您的数据档案，未经本人授权，任何第三方（包括溯源优才平台管理方）均无法查看，请放心填写。"
        color="#FF8D65"
      />
    </div>
    <UnVerified
      v-if="userInfo.status !== '3' && userInfo.status !== '4'"
      :idCard="userInfo.idCard || ''"
    />
    <div v-else-if="JSON.stringify(list) !== '[]'">
      <div class="piList">
        <div id="baseInfo" class="piItem">
          <div class="piTitle">
            <div class="titleName">
              <el-checkbox
                v-if="isSelect"
                v-model="checkList['基础信息'].checkAll"
                :indeterminate="checkList['基础信息'].indeterminate"
                @change="handleCheckAll($event, '基础信息')"
              ></el-checkbox
              >基础信息<Guide />
            </div>
            <!-- <i
              :class="`${toggle['基础信息'] ? 'toggled' : 'toggle'}`"
              @click="toggle['基础信息'] = !toggle['基础信息']"
            ></i> -->
            <Toggle
              :flag="toggle['基础信息']"
              @handleClick="toggle['基础信息'] = !toggle['基础信息']"
            />
          </div>

          <div class="infoList" v-if="toggle['基础信息']">
            <div class="infoItem">
              <div class="name">
                <el-checkbox
                  v-if="isSelect"
                  v-model="checkList['基础信息']['姓名'].checkAll"
                  :indeterminate="checkList['基础信息']['姓名'].indeterminate"
                  @change="handleCheckAll($event, '基础信息', '姓名')"
                ></el-checkbox
                >姓名：
              </div>

              <div class="valueBox">
                <div>
                  <div class="value">
                    <el-checkbox
                      v-if="isSelect"
                      v-model="
                        checkList['基础信息']['姓名'][
                          list['基础信息']['姓名'].dataId
                        ]
                      "
                      @change="handleCheckedChange($event, '基础信息', '姓名')"
                    >
                    </el-checkbox
                    >{{ list["基础信息"]["姓名"].dataValue }}
                  </div>
                  <div class="source">
                    {{
                      list["基础信息"]["姓名"].createDate
                        | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                    }}
                    实名认证
                  </div>
                </div>
                <!-- <div class="operations" v-if="!isSelect">
                  <span @click="handleRecords(list['基础信息']['姓名'].dataId)"
                    >数据记录</span
                  >
                </div> -->
                <OperationList
                  :data="list['基础信息']['姓名']"
                  @updateRedDotMark="
                    list['基础信息']['姓名'].redDotMark = false
                  "
                />
              </div>
            </div>

            <div class="infoItem">
              <div class="name">
                <el-checkbox
                  v-if="isSelect"
                  v-model="checkList['基础信息']['性别'].checkAll"
                  :indeterminate="checkList['基础信息']['性别'].indeterminate"
                  @change="handleCheckAll($event, '基础信息', '性别')"
                ></el-checkbox
                >性别：
              </div>

              <div class="valueBox">
                <div>
                  <div class="value">
                    <el-checkbox
                      v-if="isSelect"
                      v-model="
                        checkList['基础信息']['性别'][
                          list['基础信息']['性别'].dataId
                        ]
                      "
                      @change="handleCheckedChange($event, '基础信息', '性别')"
                    >
                    </el-checkbox
                    >{{ list["基础信息"]["性别"].dataValue }}
                  </div>
                  <div class="source">
                    {{
                      list["基础信息"]["性别"].createDate
                        | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                    }}
                    实名认证
                  </div>
                </div>
                <!-- <div class="operations" v-if="!isSelect">
                  <span @click="handleRecords(list['基础信息']['性别'].dataId)"
                    >数据记录</span
                  >
                </div> -->
                <OperationList
                  :data="list['基础信息']['性别']"
                  @handleGetList="getList"
                />
              </div>
            </div>

            <div class="infoItem">
              <div class="name">
                <el-checkbox
                  v-if="isSelect"
                  v-model="checkList['基础信息']['身份证号'].checkAll"
                  :indeterminate="
                    checkList['基础信息']['身份证号'].indeterminate
                  "
                  @change="handleCheckAll($event, '基础信息', '身份证号')"
                ></el-checkbox
                >身份证号：
              </div>

              <div class="valueBox">
                <div>
                  <div class="value">
                    <el-checkbox
                      v-if="isSelect"
                      v-model="
                        checkList['基础信息']['身份证号'][
                          list['基础信息']['身份证号'].dataId
                        ]
                      "
                      @change="
                        handleCheckedChange($event, '基础信息', '身份证号')
                      "
                    >
                    </el-checkbox
                    >{{ list["基础信息"]["身份证号"].dataValue }}
                  </div>
                  <div class="source">
                    {{
                      list["基础信息"]["身份证号"].createDate
                        | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                    }}
                    实名认证
                  </div>
                </div>
                <!-- <div class="operations" v-if="!isSelect">
                  <span
                    @click="handleRecords(list['基础信息']['身份证号'].dataId)"
                    >数据记录</span
                  >
                </div> -->
                <OperationList
                  :data="list['基础信息']['身份证号']"
                  @handleGetList="getList"
                />
              </div>
            </div>

            <div class="infoItem">
              <div class="name">
                <el-checkbox
                  v-if="isSelect"
                  v-model="checkList['基础信息']['出生日期'].checkAll"
                  :indeterminate="
                    checkList['基础信息']['出生日期'].indeterminate
                  "
                  @change="handleCheckAll($event, '基础信息', '出生日期')"
                ></el-checkbox
                >出生日期：
              </div>

              <div class="valueBox">
                <div>
                  <div class="value">
                    <el-checkbox
                      v-if="isSelect"
                      v-model="
                        checkList['基础信息']['出生日期'][
                          list['基础信息']['出生日期'].dataId
                        ]
                      "
                      @change="
                        handleCheckedChange($event, '基础信息', '出生日期')
                      "
                    >
                    </el-checkbox
                    >{{ list["基础信息"]["出生日期"].dataValue }}
                  </div>
                  <div class="source">
                    {{
                      list["基础信息"]["出生日期"].createDate
                        | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                    }}
                    实名认证
                  </div>
                </div>
                <!-- <div class="operations" v-if="!isSelect">
                  <span
                    @click="handleRecords(list['基础信息']['出生日期'].dataId)"
                    >数据记录</span
                  >
                </div> -->
                <OperationList
                  :data="list['基础信息']['出生日期']"
                  @handleGetList="getList"
                />
              </div>
            </div>

            <div
              class="infoItem"
              v-if="!(list['基础信息']['民族'] === undefined && isSelect)"
            >
              <div class="name">
                <el-checkbox
                  v-if="isSelect"
                  v-model="checkList['基础信息']['民族'].checkAll"
                  :indeterminate="checkList['基础信息']['民族'].indeterminate"
                  @change="handleCheckAll($event, '基础信息', '民族')"
                ></el-checkbox
                >民族：<Btn
                  v-if="!list['基础信息']['民族']"
                  btnText="民族"
                  className="default"
                  :width="116"
                  :height="39"
                  :radius="19.5"
                  :fontSize="14"
                  style="margin-left:19px"
                  :plus="true"
                  @handleClick="handleAdd('基础信息', '民族')"
                />
              </div>

              <div
                class="valueBox"
                v-if="list['基础信息']['民族'] && !formIsEdit['民族']"
              >
                <div>
                  <div class="value">
                    <el-checkbox
                      v-if="isSelect"
                      v-model="
                        checkList['基础信息']['民族'][
                          list['基础信息']['民族'].dataId
                        ]
                      "
                      @change="handleCheckedChange($event, '基础信息', '民族')"
                    >
                    </el-checkbox
                    >{{ list["基础信息"]["民族"].dataValue }}
                  </div>
                  <div class="source">
                    <template v-if="list['基础信息']['民族'].deleteTag">{{
                      list["基础信息"]["民族"].lastUpdateDate
                        | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                    }}</template>
                    <template v-else>{{
                      list["基础信息"]["民族"].createDate
                        | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                    }}</template>
                    由{{
                      list["基础信息"]["民族"].dataSourceType === "CONSUMER"
                        ? list["基础信息"]["民族"].dataSourceName +
                          (list["基础信息"]["民族"].deleteTag ? "删除" : "自填")
                        : list["基础信息"]["民族"].dataSourceName +
                          (list["基础信息"]["民族"].deleteTag ? "删除" : "填写")
                    }}
                  </div>
                </div>
                <!-- <div class="operations" v-if="!isSelect">
                  <span
                    v-if="list['基础信息']['民族'].modifiable"
                    @click="handleEdit('基础信息', '民族', index)"
                    >修改</span
                  >
                  <span @click="handleRecords(list['基础信息']['民族'].dataId)"
                    >数据记录</span
                  >
                </div> -->
                <OperationList
                  :data="list['基础信息']['民族']"
                  :isEdit="true"
                  @handleEdit="handleEdit('基础信息', '民族', index)"
                  @handleGetList="getList"
                />
              </div>

              <div
                class="valueBox"
                :name="form['基础信息']['民族']"
                v-if="
                  (form &&
                    form['基础信息'] &&
                    form['基础信息']['民族'] !== undefined) ||
                    formIsEdit['民族']
                "
              >
                <div class="inputDiv">
                  <!-- <el-input v-model="form['基础信息']['民族'].value"></el-input> -->
                  <el-select v-model="form['基础信息']['民族'].value">
                    <el-option
                      :label="item.name"
                      v-for="item in nationList"
                      :key="item.id"
                      :value="item.name"
                      >{{ item.name }}</el-option
                    >
                  </el-select>
                  <div class="btns">
                    <Btn
                      btnText="提交"
                      className="primary"
                      :fontSize="14"
                      :width="69"
                      :height="30"
                      style="margin-right:14px"
                      @handleClick="handleSubmitForm('基础信息', '民族')"
                    />
                    <Btn
                      btnText="取消"
                      className="primary_plain"
                      :fontSize="14"
                      :width="69"
                      :height="30"
                      @handleClick="handleCancelForm('基础信息', '民族')"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="infoItem">
              <div class="name">
                <el-checkbox
                  v-if="isSelect"
                  v-model="checkList['基础信息']['身份证注册地'].checkAll"
                  :indeterminate="
                    checkList['基础信息']['身份证注册地'].indeterminate
                  "
                  @change="handleCheckAll($event, '基础信息', '身份证注册地')"
                ></el-checkbox
                >身份证注册地：
              </div>

              <div class="valueBox">
                <div>
                  <div class="value">
                    <el-checkbox
                      v-if="isSelect"
                      v-model="
                        checkList['基础信息']['身份证注册地'][
                          list['基础信息']['身份证注册地'].dataId
                        ]
                      "
                      @change="
                        handleCheckedChange($event, '基础信息', '身份证注册地')
                      "
                    >
                    </el-checkbox
                    >{{ list["基础信息"]["身份证注册地"].dataValue }}
                  </div>
                  <div class="source">
                    {{
                      list["基础信息"]["身份证注册地"].createDate
                        | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                    }}
                    实名认证
                  </div>
                </div>
                <!-- <div class="operations" v-if="!isSelect">
                  <span
                    @click="
                      handleRecords(list['基础信息']['身份证注册地'].dataId)
                    "
                    >数据记录</span
                  >
                </div> -->
                <OperationList
                  :data="list['基础信息']['身份证注册地']"
                  @handleGetList="getList"
                />
              </div>
            </div>

            <div class="infoItem">
              <div class="name">
                <el-checkbox
                  v-if="isSelect"
                  v-model="checkList['基础信息']['手机号码'].checkAll"
                  :indeterminate="
                    checkList['基础信息']['手机号码'].indeterminate
                  "
                  @change="handleCheckAll($event, '基础信息', '手机号码')"
                ></el-checkbox
                >手机号码：
                <Btn
                  v-if="!isSelect"
                  btnText="手机号码"
                  className="default"
                  :width="116"
                  :height="39"
                  :radius="19.5"
                  :fontSize="14"
                  style="margin-left:19px"
                  :plus="true"
                  @handleClick="handleAdd('基础信息', '手机号码')"
                />
              </div>

              <div
                :class="`valueBox ${item['值'].deleteTag ? 'deleteTag' : ''}`"
                v-for="(item, index) in list['基础信息']['手机号码']"
                :key="index"
                v-if="
                  isSelect
                    ? item['值'].phoneExpireTag
                      ? false
                      : true
                    : list['基础信息']['手机号码']
                "
              >
                <div>
                  <div class="value">
                    <span class="value1"
                      ><el-checkbox
                        v-if="isSelect"
                        v-model="
                          checkList['基础信息']['手机号码'].value[index][
                            list['基础信息']['手机号码'][index]['值'].dataId
                          ]
                        "
                        @change="
                          handleCheckedChange($event, '基础信息', '手机号码')
                        "
                      >
                      </el-checkbox
                      >{{ item["值"].dataValue }}
                    </span>
                    <span
                      style="color:#FF4C4C;margin-left:20px"
                      v-if="item['值'].deleteTag"
                      >已删除</span
                    >
                    <span
                      style="color:#FF4C4C;margin-left:20px"
                      v-if="item['值'].phoneExpireTag"
                      >已过期</span
                    >
                  </div>

                  <div class="source">
                    <template v-if="item['值'].deleteTag">{{
                      item["值"].lastUpdateDate
                        | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                    }}</template>
                    <template v-else>{{
                      item["值"].createDate
                        | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                    }}</template>
                    实名认证
                  </div>
                </div>
                <div class="operations" v-if="!isSelect">
                  <!-- <span
                    v-if="item['值'].modifiable && !item['值'].deleteTag"
                    @click="handleEdit('基础信息', '手机号码', index)"
                    >修改</span
                  >
                  <span
                    v-if="item['值'].modifiable && !item['值'].deleteTag"
                    @click="handleDelete('基础信息', '手机号码', item)"
                    >删除</span
                  > -->
                  <span
                    v-if="item['值'].phoneExpireTag"
                    @click="handleOpenDialogAddPhone(item['值'].dataValue)"
                    >重新认证</span
                  >
                  <!-- <span @click="handleRecords(item['值'].dataId)"
                    >数据记录</span
                  > -->
                </div>
              </div>

              <!-- <div
                class="valueBox"
                v-if="
                  form['基础信息']['手机号码'] &&
                    form['基础信息']['手机号码'].type
                "
              >
                <div class="inputDiv">
                  <el-input
                    v-model="form['基础信息']['手机号码'].value"
                  ></el-input>
                  <div class="btns">
                    <Btn
                      btnText="提交"
                      className="primary"
                      :fontSize="14"
                      :width="69"
                      :height="30"
                      style="margin-right:14px"
                      @handleClick="handleSubmitForm('基础信息', '手机号码')"
                    />
                    <Btn
                      btnText="取消"
                      className="primary_plain"
                      :fontSize="14"
                      :width="69"
                      :height="30"
                      @handleClick="handleCancelForm('基础信息', '手机号码')"
                    />
                  </div>
                </div>
              </div> -->
            </div>
            <!-- v-if="!(list['基础信息']['座机号码'] === undefined && isSelect )" -->
            <!-- v-if="isSelect?list['基础信息']['座机号码'].filter(item=>!item['值'].deleteTag).length>0:list['基础信息']['座机号码'] !== undefined" -->
            <div
              class="infoItem"
              v-if="
                isSelect
                  ? list['基础信息']['座机号码'] !== undefined &&
                    list['基础信息']['座机号码'].filter(
                      item => !item['值'].deleteTag
                    ).length > 0
                  : true
              "
            >
              <div class="name">
                <el-checkbox
                  v-if="isSelect"
                  v-model="checkList['基础信息']['座机号码'].checkAll"
                  :indeterminate="
                    checkList['基础信息']['座机号码'].indeterminate
                  "
                  @change="handleCheckAll($event, '基础信息', '座机号码')"
                ></el-checkbox>
                座机号码：<Btn
                  v-if="!isSelect"
                  btnText="座机号码"
                  className="default"
                  :width="116"
                  :height="39"
                  :radius="19.5"
                  :fontSize="14"
                  style="margin-left:19px"
                  :plus="true"
                  @handleClick="handleAdd('基础信息', '座机号码')"
                />
              </div>

              <div
                :class="`valueBox ${item['值'].deleteTag ? 'deleteTag' : ''}`"
                v-for="(item, index) in list['基础信息']['座机号码']"
                :key="index"
                v-if="
                  isSelect
                    ? item['值'].deleteTag
                      ? false
                      : true
                    : list['基础信息']['座机号码']
                    ? item['值'].deleteTag
                      ? isShowInvalid
                        ? true
                        : false
                      : true
                    : false
                "
              >
                <div>
                  <div class="value">
                    <span class="value1"
                      ><el-checkbox
                        v-if="isSelect"
                        v-model="
                          checkList['基础信息']['座机号码'].value[index][
                            list['基础信息']['座机号码'][index]['值'].dataId
                          ]
                        "
                        @change="
                          handleCheckedChange($event, '基础信息', '座机号码')
                        "
                      >
                      </el-checkbox>
                      {{ item["值"].dataValue }}
                    </span>
                    <span
                      style="color:#FF4C4C;margin-left:20px"
                      v-if="item['值'].deleteTag"
                      >已删除</span
                    >
                  </div>
                  <div class="source">
                    <template v-if="item['值'].deleteTag">{{
                      item["值"].lastUpdateDate
                        | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                    }}</template>
                    <template v-else>{{
                      item["值"].createDate
                        | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                    }}</template>
                    由{{
                      item["值"].dataSourceType === "CONSUMER"
                        ? item["值"].dataSourceName +
                          (item["值"].deleteTag ? "删除" : "自填")
                        : item["值"].dataSourceName +
                          (item["值"].deleteTag ? "删除" : "填写")
                    }}
                  </div>
                </div>
                <!-- <div class="operations" v-if="!isSelect">
                  <span
                    v-if="!item['值'].deleteTag"
                    @click="handleEdit('基础信息', '座机号码', index)"
                    >修改</span
                  >
                  <span
                    v-if="!item['值'].deleteTag"
                    @click="handleDelete('基础信息', '座机号码', item)"
                    >删除</span
                  >
                  <span @click="handleRecords(item['值'].dataId)"
                    >数据记录</span
                  >
                </div> -->
                <OperationList
                  :data="item['值']"
                  :isEdit="true"
                  @handleEdit="handleEdit('基础信息', '座机号码', index)"
                  :isDelete="true"
                  @handleDelete="handleDelete('基础信息', '座机号码', item)"
                  @handleGetList="getList"
                />
              </div>

              <div
                class="valueBox"
                :name="form['基础信息']['座机号码']"
                v-if="
                  form &&
                    form['基础信息'] &&
                    form['基础信息']['座机号码'] !== undefined
                "
              >
                <div class="inputDiv">
                  <el-input
                    v-model="form['基础信息']['座机号码'].value"
                  ></el-input>
                  <div class="btns">
                    <Btn
                      btnText="提交"
                      className="primary"
                      :fontSize="14"
                      :width="69"
                      :height="30"
                      style="margin-right:14px"
                      @handleClick="handleSubmitForm('基础信息', '座机号码')"
                    />
                    <Btn
                      btnText="取消"
                      className="primary_plain"
                      :fontSize="14"
                      :width="69"
                      :height="30"
                      @handleClick="handleCancelForm('基础信息', '座机号码')"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- v-if="!(list['基础信息']['通信地址'] === undefined && isSelect)" -->
            <!-- v-if="isSelect?list['基础信息']['通信地址'].filter(item=>!item['值'].deleteTag).length>0:list['基础信息']['通信地址'] !== undefined" -->
            <div
              class="infoItem"
              v-if="
                isSelect
                  ? list['基础信息']['通信地址'] !== undefined &&
                    list['基础信息']['通信地址'].filter(
                      item => !item['值'].deleteTag
                    ).length > 0
                  : true
              "
            >
              <div class="name">
                <el-checkbox
                  v-if="isSelect"
                  v-model="checkList['基础信息']['通信地址'].checkAll"
                  :indeterminate="
                    checkList['基础信息']['通信地址'].indeterminate
                  "
                  @change="handleCheckAll($event, '基础信息', '通信地址')"
                ></el-checkbox
                >通信地址：<Btn
                  v-if="!isSelect"
                  btnText="通信地址"
                  className="default"
                  :width="116"
                  :height="39"
                  :radius="19.5"
                  :fontSize="14"
                  style="margin-left:19px"
                  :plus="true"
                  @handleClick="handleAdd('基础信息', '通信地址')"
                />
              </div>

              <div
                :class="`valueBox ${item['值'].deleteTag ? 'deleteTag' : ''}`"
                v-for="(item, index) in list['基础信息']['通信地址']"
                :key="index"
                v-if="
                  isSelect
                    ? item['值'].deleteTag
                      ? false
                      : true
                    : list['基础信息']['通信地址']
                    ? item['值'].deleteTag
                      ? isShowInvalid
                        ? true
                        : false
                      : true
                    : false
                "
              >
                <div>
                  <div class="value mw500">
                    <span class="value1"
                      ><el-checkbox
                        v-if="isSelect"
                        v-model="
                          checkList['基础信息']['通信地址'].value[index][
                            list['基础信息']['通信地址'][index]['值'].dataId
                          ]
                        "
                        @change="
                          handleCheckedChange($event, '基础信息', '通信地址')
                        "
                      >
                      </el-checkbox
                      >{{ item["值"].dataValue }}
                    </span>
                    <span
                      style="color:#FF4C4C;margin-left:20px"
                      v-if="item['值'].deleteTag"
                      >已删除</span
                    >
                  </div>
                  <div class="source">
                    <template v-if="item['值'].deleteTag">{{
                      item["值"].lastUpdateDate
                        | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                    }}</template>
                    <template v-else>{{
                      item["值"].createDate
                        | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                    }}</template>
                    由{{
                      item["值"].dataSourceType === "CONSUMER"
                        ? item["值"].dataSourceName +
                          (item["值"].deleteTag ? "删除" : "自填")
                        : item["值"].dataSourceName +
                          (item["值"].deleteTag ? "删除" : "填写")
                    }}
                  </div>
                </div>
                <!-- <div class="operations" v-if="!isSelect">
                  <span
                    v-if="!item['值'].deleteTag"
                    @click="handleEdit('基础信息', '通信地址', index)"
                    >修改</span
                  >
                  <span
                    v-if="!item['值'].deleteTag"
                    @click="handleDelete('基础信息', '通信地址', item)"
                    >删除</span
                  >
                  <span @click="handleRecords(item['值'].dataId)"
                    >数据记录</span
                  >
                </div> -->
                <OperationList
                  :data="item['值']"
                  :isEdit="true"
                  @handleEdit="handleEdit('基础信息', '通信地址', index)"
                  :isDelete="true"
                  @handleDelete="handleDelete('基础信息', '通信地址', item)"
                  @handleGetList="getList"
                />
              </div>

              <div
                class="valueBox"
                :name="form['基础信息']['通信地址']"
                v-if="
                  form &&
                    form['基础信息'] &&
                    form['基础信息']['通信地址'] !== undefined
                "
              >
                <div class="inputDiv">
                  <el-input
                    v-model="form['基础信息']['通信地址'].value"
                  ></el-input>
                  <div class="btns">
                    <Btn
                      btnText="提交"
                      className="primary"
                      :fontSize="14"
                      :width="69"
                      :height="30"
                      style="margin-right:14px"
                      @handleClick="handleSubmitForm('基础信息', '通信地址')"
                    />
                    <Btn
                      btnText="取消"
                      className="primary_plain"
                      :fontSize="14"
                      :width="69"
                      :height="30"
                      @handleClick="handleCancelForm('基础信息', '通信地址')"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- v-if="!(list['基础信息']['电子邮箱'] === undefined && isSelect)" -->
            <!-- !(list['基础信息']['电子邮箱'] === undefined && (isSelect && list['基础信息']['电子邮箱'].filter(item=>!item['值'].deleteTag).length>0)) -->
            <!-- v-if="isSelect?list['基础信息']['电子邮箱'].filter(item=>!item['值'].deleteTag).length>0:list['基础信息']['电子邮箱'] !== undefined" -->
            <div
              class="infoItem"
              v-if="
                isSelect
                  ? list['基础信息']['电子邮箱'] !== undefined &&
                    list['基础信息']['电子邮箱'].filter(
                      item => !item['值'].deleteTag
                    ).length > 0
                  : true
              "
            >
              <div class="name">
                <el-checkbox
                  v-if="isSelect"
                  v-model="checkList['基础信息']['电子邮箱'].checkAll"
                  :indeterminate="
                    checkList['基础信息']['电子邮箱'].indeterminate
                  "
                  @change="handleCheckAll($event, '基础信息', '电子邮箱')"
                ></el-checkbox
                >电子邮箱：<Btn
                  v-if="!isSelect"
                  btnText="电子邮箱"
                  className="default"
                  :width="116"
                  :height="39"
                  :radius="19.5"
                  :fontSize="14"
                  style="margin-left:19px"
                  :plus="true"
                  @handleClick="handleAdd('基础信息', '电子邮箱')"
                />
              </div>

              <div
                :class="`valueBox ${item['值'].deleteTag ? 'deleteTag' : ''}`"
                v-for="(item, index) in list['基础信息']['电子邮箱']"
                :key="index"
                v-if="
                  isSelect
                    ? item['值'].deleteTag
                      ? false
                      : true
                    : list['基础信息']['电子邮箱']
                    ? item['值'].deleteTag
                      ? isShowInvalid
                        ? true
                        : false
                      : true
                    : false
                "
              >
                <div>
                  <div class="value">
                    <span class="value1"
                      ><el-checkbox
                        v-if="isSelect"
                        v-model="
                          checkList['基础信息']['电子邮箱'].value[index][
                            list['基础信息']['电子邮箱'][index]['值'].dataId
                          ]
                        "
                        @change="
                          handleCheckedChange($event, '基础信息', '电子邮箱')
                        "
                      >
                      </el-checkbox
                      >{{ item["值"].dataValue }}
                    </span>
                    <span
                      style="color:#FF4C4C;margin-left:20px"
                      v-if="item['值'].deleteTag"
                      >已删除</span
                    >
                  </div>
                  <div class="source">
                    <template v-if="item['值'].deleteTag">{{
                      item["值"].lastUpdateDate
                        | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                    }}</template>
                    <template v-else>{{
                      item["值"].createDate
                        | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                    }}</template>
                    由{{
                      item["值"].dataSourceType === "CONSUMER"
                        ? item["值"].dataSourceName +
                          (item["值"].deleteTag ? "删除" : "自填")
                        : item["值"].dataSourceName +
                          (item["值"].deleteTag ? "删除" : "填写")
                    }}
                  </div>
                </div>
                <!-- <div class="operations" v-if="!isSelect">
                  <span
                    v-if="!item['值'].deleteTag"
                    @click="handleEdit('基础信息', '电子邮箱', index)"
                    >修改</span
                  >
                  <span
                    v-if="!item['值'].deleteTag"
                    @click="handleDelete('基础信息', '电子邮箱', item)"
                    >删除</span
                  >
                  <span @click="handleRecords(item['值'].dataId)"
                    >数据记录</span
                  >
                </div> -->
                <OperationList
                  :data="item['值']"
                  :isEdit="true"
                  @handleEdit="handleEdit('基础信息', '电子邮箱', index)"
                  :isDelete="true"
                  @handleDelete="handleDelete('基础信息', '电子邮箱', item)"
                  @handleGetList="getList"
                />
              </div>

              <div
                class="valueBox"
                :name="form['基础信息']['电子邮箱']"
                v-if="
                  form &&
                    form['基础信息'] &&
                    form['基础信息']['电子邮箱'] !== undefined
                "
              >
                <div class="inputDiv">
                  <el-input
                    v-model="form['基础信息']['电子邮箱'].value"
                  ></el-input>
                  <div class="btns">
                    <Btn
                      btnText="提交"
                      className="primary"
                      :fontSize="14"
                      :width="69"
                      :height="30"
                      style="margin-right:14px"
                      @handleClick="handleSubmitForm('基础信息', '电子邮箱')"
                    />
                    <Btn
                      btnText="取消"
                      className="primary_plain"
                      :fontSize="14"
                      :width="69"
                      :height="30"
                      @handleClick="handleCancelForm('基础信息', '电子邮箱')"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              class="infoItem"
              v-if="!(list['基础信息']['婚姻状况'] === undefined && isSelect)"
            >
              <div class="name">
                <el-checkbox
                  v-if="isSelect"
                  v-model="checkList['基础信息']['婚姻状况'].checkAll"
                  :indeterminate="
                    checkList['基础信息']['婚姻状况'].indeterminate
                  "
                  @change="handleCheckAll($event, '基础信息', '婚姻状况')"
                ></el-checkbox
                >婚姻状况：<Btn
                  v-if="!isSelect && !list['基础信息']['婚姻状况']"
                  btnText="婚姻状况"
                  className="default"
                  :width="116"
                  :height="39"
                  :radius="19.5"
                  :fontSize="14"
                  style="margin-left:19px"
                  :plus="true"
                  @handleClick="handleAdd('基础信息', '婚姻状况')"
                />
              </div>
              <div
                :class="
                  `valueBox ${
                    list['基础信息']['婚姻状况'].deleteTag ? 'deleteTag' : ''
                  }`
                "
                v-if="
                  list['基础信息']['婚姻状况'] //true
                    ? isSelect //false
                      ? list['基础信息']['婚姻状况'].deleteTag
                        ? false
                        : !formIsEdit['婚姻状况']
                        ? true
                        : false
                      : !formIsEdit['婚姻状况']
                      ? true
                      : false
                    : false
                "
              >
                <div>
                  <div class="value">
                    <span class="value1"
                      ><el-checkbox
                        v-if="isSelect"
                        v-model="
                          checkList['基础信息']['婚姻状况'][
                            list['基础信息']['婚姻状况'].dataId
                          ]
                        "
                        @change="
                          handleCheckedChange($event, '基础信息', '婚姻状况')
                        "
                      >
                      </el-checkbox
                      >{{ list["基础信息"]["婚姻状况"].dataValue }}</span
                    >
                    <span
                      style="color:#FF4C4C;margin-left:20px"
                      v-if="list['基础信息']['婚姻状况'].deleteTag"
                      >已删除</span
                    >
                  </div>
                  <div class="source">
                    <template v-if="list['基础信息']['婚姻状况'].deleteTag">{{
                      list["基础信息"]["婚姻状况"].lastUpdateDate
                        | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                    }}</template>
                    <template v-else>{{
                      list["基础信息"]["婚姻状况"].createDate
                        | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                    }}</template>
                    由{{
                      list["基础信息"]["婚姻状况"].dataSourceType === "CONSUMER"
                        ? list["基础信息"]["婚姻状况"].dataSourceName +
                          (list["基础信息"]["婚姻状况"].deleteTag
                            ? "删除"
                            : "自填")
                        : list["基础信息"]["婚姻状况"].dataSourceName +
                          (list["基础信息"]["婚姻状况"].deleteTag
                            ? "删除"
                            : "填写")
                    }}
                  </div>
                </div>
                <!-- <div class="operations" v-if="!isSelect">
                  <span @click="handleEdit('基础信息', '婚姻状况', index)"
                    >修改</span
                  >
                  <span
                    @click="handleRecords(list['基础信息']['婚姻状况'].dataId)"
                    >数据记录</span
                  >
                </div> -->
                <OperationList
                  :data="list['基础信息']['婚姻状况']"
                  :isEdit="true"
                  @handleEdit="handleEdit('基础信息', '婚姻状况', index)"
                  @handleGetList="getList"
                />
              </div>

              <div
                class="valueBox"
                :name="form['基础信息']['婚姻状况']"
                v-if="
                  form &&
                    form['基础信息'] &&
                    form['基础信息']['婚姻状况'] !== undefined
                "
              >
                <div class="inputDiv">
                  <!-- <el-input
                    v-model="form['基础信息']['婚姻状况'].value"
                  ></el-input> -->
                  <el-select v-model="form['基础信息']['婚姻状况'].value">
                    <el-option label="已婚" value="已婚">已婚</el-option>
                    <el-option label="未婚" value="未婚">未婚</el-option>
                    <el-option label="离异" value="离异">离异</el-option>
                  </el-select>
                  <div class="btns">
                    <Btn
                      btnText="提交"
                      className="primary"
                      :fontSize="14"
                      :width="69"
                      :height="30"
                      style="margin-right:14px"
                      @handleClick="handleSubmitForm('基础信息', '婚姻状况')"
                    />
                    <Btn
                      btnText="取消"
                      className="primary_plain"
                      :fontSize="14"
                      :width="69"
                      :height="30"
                      @handleClick="handleCancelForm('基础信息', '婚姻状况')"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="infoItem"
              v-if="!(list['基础信息']['政治面貌'] === undefined && isSelect)"
            >
              <div class="name">
                <el-checkbox
                  v-if="isSelect"
                  v-model="checkList['基础信息']['政治面貌'].checkAll"
                  :indeterminate="
                    checkList['基础信息']['政治面貌'].indeterminate
                  "
                  @change="handleCheckAll($event, '基础信息', '政治面貌')"
                ></el-checkbox
                >政治面貌：<Btn
                  v-if="!list['基础信息']['政治面貌']"
                  btnText="政治面貌"
                  className="default"
                  :width="116"
                  :height="39"
                  :radius="19.5"
                  :fontSize="14"
                  style="margin-left:19px"
                  :plus="true"
                  @handleClick="handleAdd('基础信息', '政治面貌')"
                />
              </div>
              <div
                :class="
                  `valueBox ${
                    list['基础信息']['政治面貌'].deleteTag ? 'deleteTag' : ''
                  }`
                "
                v-if="
                  list['基础信息']['政治面貌'] //true
                    ? isSelect //false
                      ? list['基础信息']['政治面貌'].deleteTag
                        ? false
                        : !formIsEdit['政治面貌']
                        ? true
                        : false
                      : !formIsEdit['政治面貌']
                      ? true
                      : false
                    : false
                "
              >
                <div>
                  <div class="value">
                    <span class="value1"
                      ><el-checkbox
                        v-if="isSelect"
                        v-model="
                          checkList['基础信息']['政治面貌'][
                            list['基础信息']['政治面貌'].dataId
                          ]
                        "
                        @change="
                          handleCheckedChange($event, '基础信息', '政治面貌')
                        "
                      >
                      </el-checkbox
                      >{{ list["基础信息"]["政治面貌"].dataValue }}</span
                    >
                    <span
                      style="color:#FF4C4C;margin-left:20px"
                      v-if="list['基础信息']['政治面貌'].deleteTag"
                      >已删除</span
                    >
                  </div>
                  <div class="source">
                    <template v-if="list['基础信息']['政治面貌'].deleteTag">{{
                      list["基础信息"]["政治面貌"].lastUpdateDate
                        | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                    }}</template>
                    <template v-else>{{
                      list["基础信息"]["政治面貌"].createDate
                        | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                    }}</template>
                    由{{
                      list["基础信息"]["政治面貌"].dataSourceType === "CONSUMER"
                        ? list["基础信息"]["政治面貌"].dataSourceName +
                          (list["基础信息"]["政治面貌"].deleteTag
                            ? "删除"
                            : "自填")
                        : list["基础信息"]["政治面貌"].dataSourceName +
                          (list["基础信息"]["政治面貌"].deleteTag
                            ? "删除"
                            : "填写")
                    }}
                  </div>
                </div>
                <!-- <div class="operations" v-if="!isSelect">
                  <span @click="handleEdit('基础信息', '政治面貌', index)"
                    >修改</span
                  >
                  <span
                    @click="handleRecords(list['基础信息']['政治面貌'].dataId)"
                    >数据记录</span
                  >
                  {{list['基础信息']['政治面貌'].redDotMark}}
                </div> -->
                <OperationList
                  :data="list['基础信息']['政治面貌']"
                  :isEdit="true"
                  @handleEdit="handleEdit('基础信息', '政治面貌', index)"
                  @handleGetList="getList"
                />
              </div>

              <div
                class="valueBox"
                :name="form['基础信息']['政治面貌']"
                v-if="
                  form &&
                    form['基础信息'] &&
                    form['基础信息']['政治面貌'] !== undefined
                "
              >
                <div class="inputDiv">
                  <!-- <el-input
                    v-model="form['基础信息']['政治面貌'].value"
                  ></el-input> -->
                  <el-select
                    v-model="form['基础信息']['政治面貌'].value"
                    style="width:100%"
                  >
                    <el-option label="中共党员" value="中共党员"></el-option>
                    <el-option
                      label="中共预备党员"
                      value="中共预备党员"
                    ></el-option>
                    <el-option label="共青团员" value="共青团员"></el-option>
                    <el-option label="民革党员" value="民革党员"></el-option>
                    <el-option label="民盟盟员" value="民盟盟员"></el-option>
                    <el-option label="民建会员" value="民建会员"></el-option>
                    <el-option label="民进会员" value="民进会员"></el-option>
                    <el-option
                      label="农工党党员"
                      value="农工党党员"
                    ></el-option>
                    <el-option
                      label="致公党党员"
                      value="致公党党员"
                    ></el-option>
                    <el-option
                      label="九三学社社员"
                      value="九三学社社员"
                    ></el-option>
                    <el-option label="台盟盟员" value="台盟盟员"></el-option>
                    <el-option
                      label="无党派人士"
                      value="无党派人士"
                    ></el-option>
                    <el-option label="群众" value="群众"></el-option>
                  </el-select>
                  <!-- zzmmOptions: [ { name: '农工党党员' }, { name: '致公党党员' }, { name: '九三学社社员' }, { name: '台盟盟员' }, { name: '无党派人士' }, { name: '群众' }] -->
                  <div class="btns">
                    <Btn
                      btnText="提交"
                      className="primary"
                      :fontSize="14"
                      :width="69"
                      :height="30"
                      style="margin-right:14px"
                      @handleClick="handleSubmitForm('基础信息', '政治面貌')"
                    />
                    <Btn
                      btnText="取消"
                      className="primary_plain"
                      :fontSize="14"
                      :width="69"
                      :height="30"
                      @handleClick="handleCancelForm('基础信息', '政治面貌')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="eduInfo" class="piItem">
          <div class="piTitle">
            <div class="titleName">
              <el-checkbox
                v-if="isSelect"
                v-model="checkList['学历教育'].checkAll"
                :indeterminate="checkList['学历教育'].indeterminate"
                @change="handleCheckAll($event, '学历教育')"
              ></el-checkbox
              >学历教育<Btn
                v-if="!isSelect"
                btnText="学历教育"
                :width="116"
                className="default"
                :height="39"
                style="margin-left:14px"
                :plus="true"
                @handleClick="handleAddEduForm('add', '学历教育')"
              />
            </div>
            <Toggle
              :flag="toggle['学历教育']"
              @handleClick="toggle['学历教育'] = !toggle['学历教育']"
            />
          </div>

          <div
            class="eduList"
            v-if="toggle['学历教育'] && (list['学历教育'] || isAddEdu)"
          >
            <div
              :class="`eduItem ${item['时间'].deleteTag ? 'deleteTag' : ''}`"
              v-for="(item, index) in list['学历教育']"
              :key="index"
              v-if="
                isSelect
                  ? !item['时间'].deleteTag
                  : item['时间'].deleteTag
                  ? isShowInvalid
                    ? true
                    : false
                  : true
              "
            >
              <div class="eduItemPanel">
                <div class="panel_top">
                  <div class="panel_top_left">
                    <div class="panel_top_left_top">
                      <el-checkbox
                        v-if="isSelect"
                        v-model="checkList['学历教育'].value[index].checkAll"
                        :indeterminate="
                          checkList['学历教育'].value[index].indeterminate
                        "
                        @change="
                          handleCheckAll($event, '学历教育', undefined, index)
                        "
                      ></el-checkbox>
                      <span class="date">{{
                        `${item["时间"].dataValue.split(",")[0]}~${
                          item["时间"].dataValue.split(",")[1]
                        }`
                      }}</span>
                      <span
                        v-if="item['时间'].deleteTag"
                        style="color: rgb(255, 76, 76); margin-left: 20px;"
                        >已删除</span
                      >
                    </div>
                    <div class="panel_top_left_bottom">
                      <!-- {{ item["时间"].createDate | parseTime("{y}-{m}-{d}") }}
                      {{
                        `由 ${item["时间"].dataSourceName}${
                          item["时间"].deleteTag
                            ? "删除"
                            : item["时间"].dataSourceType === "CONSUMER"
                            ? "自填"
                            : "添加"
                        }`
                      }} -->
                    </div>
                  </div>
                  <div class="panel_top_right">
                    {{ item["教育机构"].dataValue
                    }}<RedDot
                      v-if="redDotMakStr.indexOf(item['上级Id']) > -1"
                    />
                    <!-- superiorIdAttachInfoResponseVoMap[item['上级Id']].businessNameAuthenticationTag -->
                    <span
                      class="jigourenzheng"
                      v-if="
                        !isSelect
                          ? superiorIdAttachInfoResponseVoMap[item['上级Id']]
                            ? superiorIdAttachInfoResponseVoMap[item['上级Id']]
                                .businessNameAuthenticationTag
                              ? false
                              : superiorIdAttachInfoResponseVoMap[
                                  item['上级Id']
                                ].businessNameAuthenticationApply
                              ? false
                              : true
                            : true
                          : false
                      "
                      @click="
                        handleAgencyApply(
                          item['教育机构'].dataValue,
                          item['上级Id']
                        )
                      "
                      >机构认证>></span
                    >
                    <span
                      v-if="
                        superiorIdAttachInfoResponseVoMap[item['上级Id']] &&
                          superiorIdAttachInfoResponseVoMap[item['上级Id']]
                            .businessNameAuthenticationTag
                      "
                      ><i class="icon_renzheng" />已认证</span
                    >
                  </div>
                </div>
                <div class="panel_bottom">
                  <div class="panel_bottom_left">
                    <!-- <div class="renzhengBox">
                      <i class="icon_yirenzheng" />
                      <span class="renzhengText">
                        有<span class="renzhengNum">2568</span>人认证
                        |&nbsp;</span
                      ><span class="inviteText"> 邀请认证>></span>
                    </div> -->
                    {{ item["时间"].createDate | parseTime("{y}-{m}-{d}") }}
                    {{
                      `由 ${item["时间"].dataSourceName}${
                        item["时间"].deleteTag
                          ? "删除"
                          : item["时间"].dataSourceType === "CONSUMER"
                          ? "自填"
                          : "添加"
                      }`
                    }}
                  </div>
                  <div class="panel_bottom_right">
                    <span
                      v-if="item['教育机构'].modifiable"
                      @click="handleAddEduForm('edit', '学历教育', index)"
                      ><i class="icon_edit" />修改</span
                    >
                    <span
                      v-if="
                        item['教育机构'].dataSourceType !== 'CONSUMER' &&
                          !item['教育机构'].deleteTag
                      "
                      @click="handleCorrigendum(item['教育机构'].dataId)"
                      ><i class="icon_corrigendum" />勘误</span
                    >
                    <span
                      v-if="item['教育机构'].modifiable"
                      @click="handleDeleteAll(item['上级Id'], '学历教育')"
                      ><i class="icon_delete" />删除</span
                    >
                    <span @click="handleRecords(item['教育机构'].dataId)"
                      ><i class="icon_dataSource" />数据记录</span
                    >
                  </div>
                </div>
                <div class="eduItemDetails" v-if="eduToggles[index]">
                  <div class="eduItemDetail" v-if="item['教育机构']">
                    <div class="value">
                      <el-checkbox
                        v-if="isSelect"
                        v-model="
                          checkList['学历教育'].value[index]['教育机构'][
                            item['教育机构'].dataId
                          ]
                        "
                        @change="
                          handleCheckedChange(
                            $event,
                            '学历教育',
                            '教育机构',
                            index
                          )
                        "
                      >
                      </el-checkbox
                      >教育机构：{{ item["教育机构"].dataValue }}
                    </div>
                    <div class="valueInfo">
                      <div class="updateDate">
                        数据更新于{{
                          list["学历教育"][index]["教育机构"].createDate
                            | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                        }}
                      </div>
                      <div class="operation">
                        <span
                          v-if="
                            !item['教育机构'].deleteTag &&
                              item['教育机构'].dataSourceType !== 'CONSUMER'
                          "
                          @click="handleCorrigendum(item['教育机构'].dataId)"
                          ><i class="icon_corrigendum" />勘误</span
                        >
                        <span @click="handleRecords(item['教育机构'].dataId)"
                          ><i class="icon_dataSource" />数据记录</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="eduItemDetail" v-if="item['时间']">
                    <div class="value">
                      <el-checkbox
                        v-if="isSelect"
                        v-model="
                          checkList['学历教育'].value[index]['时间'][
                            item['时间'].dataId
                          ]
                        "
                        @change="
                          handleCheckedChange($event, '学历教育', '时间', index)
                        "
                      >
                      </el-checkbox
                      >时间段：{{
                        item["时间"].dataValue.split(",").length > 1
                          ? `${item["时间"].dataValue.split(",")[0]}~${
                              item["时间"].dataValue.split(",")[1]
                            }`
                          : `${item["时间"].dataValue.split(",")[0]}至今`
                      }}
                    </div>
                    <div class="valueInfo">
                      <div class="updateDate">
                        数据更新于{{
                          list["学历教育"][index]["时间"].createDate
                            | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                        }}
                      </div>
                      <div class="operation">
                        <span
                          v-if="
                            !item['时间'].deleteTag &&
                              item['时间'].dataSourceType !== 'CONSUMER'
                          "
                          @click="handleCorrigendum(item['时间'].dataId)"
                          ><i class="icon_corrigendum" />勘误</span
                        >
                        <span @click="handleRecords(item['时间'].dataId)"
                          ><i class="icon_dataSource" />数据记录</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="eduItemDetail" v-if="item['专业名称']">
                    <div class="value">
                      <el-checkbox
                        v-if="isSelect"
                        v-model="
                          checkList['学历教育'].value[index]['专业名称'][
                            item['专业名称'].dataId
                          ]
                        "
                        @change="
                          handleCheckedChange(
                            $event,
                            '学历教育',
                            '专业名称',
                            index
                          )
                        "
                      >
                      </el-checkbox
                      >专业名称：{{
                        list["学历教育"][index]["专业名称"].dataValue
                      }}
                    </div>
                    <div class="valueInfo">
                      <div class="updateDate">
                        数据更新于{{
                          list["学历教育"][index]["专业名称"].createDate
                            | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                        }}
                      </div>
                      <div class="operation">
                        <span
                          v-if="
                            !item['专业名称'].deleteTag &&
                              item['专业名称'].dataSourceType !== 'CONSUMER'
                          "
                          @click="handleCorrigendum(item['专业名称'].dataId)"
                          ><i class="icon_corrigendum" />勘误</span
                        >
                        <span @click="handleRecords(item['专业名称'].dataId)"
                          ><i class="icon_dataSource" />数据记录</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="eduItemDetail" v-if="item['专业描述']">
                    <div class="value">
                      <div>
                        <el-checkbox
                          v-if="isSelect"
                          v-model="
                            checkList['学历教育'].value[index]['专业描述'][
                              item['专业描述'].dataId
                            ]
                          "
                          @change="
                            handleCheckedChange(
                              $event,
                              '学历教育',
                              '专业描述',
                              index
                            )
                          "
                        >
                        </el-checkbox
                        >专业描述：
                      </div>
                      <div class="textareaText">
                        {{ list["学历教育"][index]["专业描述"].dataValue }}
                      </div>
                    </div>
                    <div class="valueInfo">
                      <div class="updateDate">
                        数据更新于{{
                          list["学历教育"][index]["专业描述"].createDate
                            | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                        }}
                      </div>
                      <div class="operation">
                        <span
                          v-if="
                            !item['专业描述'].deleteTag &&
                              item['专业描述'].dataSourceType !== 'CONSUMER'
                          "
                          @click="handleCorrigendum(item['专业描述'].dataId)"
                          ><i class="icon_corrigendum" />勘误</span
                        >
                        <span @click="handleRecords(item['专业描述'].dataId)"
                          ><i class="icon_dataSource" />数据记录</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="eduItemDetail" v-if="item['专业层次']">
                    <div class="value">
                      <el-checkbox
                        v-if="isSelect"
                        v-model="
                          checkList['学历教育'].value[index]['专业层次'][
                            item['专业层次'].dataId
                          ]
                        "
                        @change="
                          handleCheckedChange(
                            $event,
                            '学历教育',
                            '专业层次',
                            index
                          )
                        "
                      >
                      </el-checkbox
                      >专业层次：{{
                        list["学历教育"][index]["专业层次"].dataValue
                      }}
                    </div>
                    <div class="valueInfo">
                      <div class="updateDate">
                        数据更新于{{
                          list["学历教育"][index]["专业层次"].createDate
                            | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                        }}
                      </div>
                      <div class="operation">
                        <span
                          v-if="
                            !item['专业层次'].deleteTag &&
                              item['专业层次'].dataSourceType !== 'CONSUMER'
                          "
                          @click="handleCorrigendum(item['专业层次'].dataId)"
                          ><i class="icon_corrigendum" />勘误</span
                        >
                        <span @click="handleRecords(item['专业层次'].dataId)"
                          ><i class="icon_dataSource" />数据记录</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="eduItemDetail" v-if="item['学制']">
                    <div class="value">
                      <el-checkbox
                        v-if="isSelect"
                        v-model="
                          checkList['学历教育'].value[index]['学制'][
                            item['学制'].dataId
                          ]
                        "
                        @change="
                          handleCheckedChange($event, '学历教育', '学制', index)
                        "
                      >
                      </el-checkbox
                      >学制：{{ list["学历教育"][index]["学制"].dataValue }}
                    </div>
                    <div class="valueInfo">
                      <div class="updateDate">
                        数据更新于{{
                          list["学历教育"][index]["学制"].createDate
                            | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                        }}
                      </div>
                      <div class="operation">
                        <span
                          v-if="
                            !item['学制'].deleteTag &&
                              item['学制'].dataSourceType !== 'CONSUMER'
                          "
                          @click="handleCorrigendum(item['学制'].dataId)"
                          ><i class="icon_corrigendum" />勘误</span
                        >
                        <span @click="handleRecords(item['学制'].dataId)"
                          ><i class="icon_dataSource" />数据记录</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="eduItemDetail" v-if="item['是否全日制']">
                    <div class="value">
                      <el-checkbox
                        v-if="isSelect"
                        v-model="
                          checkList['学历教育'].value[index]['是否全日制'][
                            item['是否全日制'].dataId
                          ]
                        "
                        @change="
                          handleCheckedChange(
                            $event,
                            '学历教育',
                            '是否全日制',
                            index
                          )
                        "
                      >
                      </el-checkbox
                      >是否全日制：{{
                        list["学历教育"][index]["是否全日制"].dataValue
                      }}
                    </div>
                    <div class="valueInfo">
                      <div class="updateDate">
                        数据更新于{{
                          list["学历教育"][index]["是否全日制"].createDate
                            | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                        }}
                      </div>
                      <div class="operation">
                        <span
                          v-if="
                            !item['是否全日制'].deleteTag &&
                              item['是否全日制'].dataSourceType !== 'CONSUMER'
                          "
                          @click="handleCorrigendum(item['是否全日制'].dataId)"
                          ><i class="icon_corrigendum" />勘误</span
                        >
                        <span @click="handleRecords(item['是否全日制'].dataId)"
                          ><i class="icon_dataSource" />数据记录</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="eduItemDetail" v-if="item['班期']">
                    <div class="value">
                      <el-checkbox
                        v-if="isSelect"
                        v-model="
                          checkList['学历教育'].value[index]['班期'][
                            item['班期'].dataId
                          ]
                        "
                        @change="
                          handleCheckedChange($event, '学历教育', '班期', index)
                        "
                      >
                      </el-checkbox
                      >班期：{{ item["班期"].dataValue }}
                    </div>
                    <div class="valueInfo">
                      <div class="updateDate">
                        数据更新于{{
                          list["学历教育"][index]["班期"].createDate
                            | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                        }}
                      </div>
                      <div class="operation">
                        <span
                          v-if="
                            !item['班期'].deleteTag &&
                              item['班期'].dataSourceType !== 'CONSUMER'
                          "
                          @click="handleCorrigendum(item['班期'].dataId)"
                          ><i class="icon_corrigendum" />勘误</span
                        >
                        <span @click="handleRecords(item['班期'].dataId)"
                          ><i class="icon_dataSource" />数据记录</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="eduItemDetail" v-if="item['教育结果']">
                    <div class="value">
                      <el-checkbox
                        v-if="isSelect"
                        v-model="
                          checkList['学历教育'].value[index]['教育结果'][
                            item['教育结果'].dataId
                          ]
                        "
                        @change="
                          handleCheckedChange(
                            $event,
                            '学历教育',
                            '教育结果',
                            index
                          )
                        "
                      >
                      </el-checkbox
                      >教育结果：{{
                        list["学历教育"][index]["教育结果"].dataValue
                      }}
                    </div>
                    <div class="valueInfo">
                      <div class="updateDate">
                        数据更新于{{
                          list["学历教育"][index]["教育结果"].createDate
                            | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                        }}
                      </div>
                      <div class="operation">
                        <span
                          v-if="
                            !item['教育结果'].deleteTag &&
                              item['教育结果'].dataSourceType !== 'CONSUMER'
                          "
                          @click="handleCorrigendum(item['教育结果'].dataId)"
                          ><i class="icon_corrigendum" />勘误</span
                        >
                        <span @click="handleRecords(item['教育结果'].dataId)"
                          ><i class="icon_dataSource" />数据记录</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="eduItemDetail" v-if="item['附件']">
                    <div class="value">
                      <el-checkbox
                        v-if="isSelect"
                        v-model="
                          checkList['学历教育'].value[index]['附件'][
                            item['附件'].dataId
                          ]
                        "
                        @change="
                          handleCheckedChange($event, '学历教育', '附件', index)
                        "
                      >
                      </el-checkbox
                      >附件：
                    </div>
                    <div class="files">
                      <div
                        class="file"
                        v-for="(file, fileIndex) in item[
                          '附件'
                        ].dataValue.split(',')"
                        :key="fileIndex"
                      >
                        <div style="line-height: 30px;">
                          <div class="fileName" @click="handlePreviewImg(file)">
                            {{ file.split(":")[2] }}
                          </div>
                          <div class="updateDate">
                            {{
                              item["附件"].createDate
                                | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                            }}
                          </div>
                        </div>
                        <div class="operation">
                          <span
                            v-if="
                              !item['附件'].deleteTag &&
                                item['附件'].dataSourceType !== 'CONSUMER'
                            "
                            @click="handleCorrigendum(item['附件'].dataId)"
                            ><i class="icon_corrigendum" />勘误</span
                          >
                          <span @click="handleRecords(item['附件'].dataId)"
                            ><i class="icon_dataSource" />数据记录</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- <EventList :event="item['事件/活动记录']"/> -->
                  <!-- v-if="item['事件/活动记录']" -->
                  <div class="eduItemDetail">
                    <div
                      class="value"
                      v-if="
                        item['事件/活动记录'] === undefined
                          ? item['时间'].dataSourceType === 'CONSUMER'
                          : true
                      "
                    >
                      <div
                        v-if="
                          item['时间'].dataSourceType === 'CONSUMER' ||
                            item['事件/活动记录']
                        "
                      >
                        <el-checkbox
                          v-if="
                            isSelect &&
                              checkList['学历教育'].value[index][
                                '事件/活动记录'
                              ]
                          "
                          v-model="
                            checkList['学历教育'].value[index]['事件/活动记录']
                              .checkAll
                          "
                          :indeterminate="
                            checkList['学历教育'].value[index]['事件/活动记录']
                              .indeterminate
                          "
                          @change="
                            handleCheckAll(
                              $event,
                              '学历教育',
                              '事件/活动记录',
                              index
                            )
                          "
                        ></el-checkbox
                        >事件/活动记录：
                      </div>
                      <div class="timeLine">
                        <el-timeline>
                          <el-timeline-item
                            v-if="
                              isSelect
                                ? !eItem['时间'].deleteTag
                                : eItem['时间'].deleteTag
                                ? isShowInvalid
                                  ? true
                                  : false
                                : true
                            "
                            v-for="(eItem, eventIndex) in item['事件/活动记录']"
                            :key="eventIndex"
                            :hide-timestamp="true"
                          >
                            <div style="line-height: 26px;">
                              <div style="display:flex">
                                <el-checkbox
                                  v-if="isSelect"
                                  v-model="
                                    checkList['学历教育'].value[index][
                                      '事件/活动记录'
                                    ].value[eventIndex][
                                      Object.keys(eItem)
                                        .filter(e => e !== '上级Id')
                                        .map(r => eItem[r].dataId.toString())
                                    ]
                                  "
                                  @change="
                                    handleCheckedChange(
                                      $event,
                                      '学历教育',
                                      '事件/活动记录',
                                      index
                                    )
                                  "
                                >
                                </el-checkbox>
                                <div class="eventItem">
                                  <div class="eventDate" v-if="eItem['时间']">
                                    <div>
                                      <div style="display:flex">
                                        <div
                                          :class="
                                            `${eItem['时间'].deleteTag &&
                                              'deleteLine'}`
                                          "
                                        >
                                          {{
                                            eItem["时间"].dataValue.split(",")
                                              .length > 1
                                              ? eItem["时间"].dataValue.split(
                                                  ","
                                                )[0] +
                                                "~" +
                                                eItem["时间"].dataValue.split(
                                                  ","
                                                )[1]
                                              : eItem["时间"].dataValue
                                          }}
                                        </div>
                                        <span
                                          v-if="eItem['时间'].deleteTag"
                                          style="color:#FF4C4C;margin-left:15px"
                                          >已删除</span
                                        >
                                      </div>
                                      <div class="eventUpdateDate">
                                        数据更新于{{
                                          eItem["时间"].lastUpdateDate
                                            | parseTime(
                                              "{y}-{m}-{d} {h}:{i}:{s}"
                                            )
                                        }}
                                      </div>
                                    </div>
                                    <div class="operations" v-if="!isSelect">
                                      <span
                                        v-if="
                                          eItem['时间'].dataSourceType ===
                                            'CONSUMER' &&
                                            !eItem['时间'].deleteTag
                                        "
                                        @click="
                                          handleEditEvent(
                                            eItem,
                                            eItem['上级Id'],
                                            index
                                          )
                                        "
                                        ><i class="icon_edit" />修改</span
                                      >
                                      <span
                                        v-if="
                                          eItem['时间'].dataSourceType ===
                                            'CONSUMER' &&
                                            !eItem['时间'].deleteTag
                                        "
                                        @click="
                                          handleDeleteAll(
                                            eItem['上级Id'],
                                            '事件/活动记录'
                                          )
                                        "
                                        ><i class="icon_delete" />删除</span
                                      >
                                      <span
                                        @click="
                                          handleCorrigendum(
                                            eItem['时间'].dataId
                                          )
                                        "
                                        v-if="
                                          !eItem['时间'].deleteTag &&
                                            eItem['时间'].dataSourceType !==
                                              'CONSUMER'
                                        "
                                      >
                                        <i class="icon_corrigendum" />勘误
                                      </span>
                                      <span
                                        @click="
                                          handleRecords(eItem['时间'].dataId)
                                        "
                                        ><i
                                          class="icon_dataSource"
                                        />数据记录</span
                                      >
                                    </div>
                                  </div>

                                  <div
                                    class="eventContent"
                                    v-if="eItem['内容']"
                                  >
                                    <div>
                                      <div style="display:flex">
                                        <div
                                          :class="
                                            `eContent ${eItem['内容']
                                              .deleteTag && 'deleteLine'}`
                                          "
                                        >
                                          {{ eItem["内容"].dataValue }}
                                        </div>
                                        <span
                                          v-if="eItem['内容'].deleteTag"
                                          style="color:#FF4C4C;margin-left:15px"
                                          >已删除</span
                                        >
                                      </div>
                                      <div class="eventUpdateDate">
                                        数据更新于{{
                                          eItem["内容"].lastUpdateDate
                                            | parseTime(
                                              "{y}-{m}-{d} {h}:{i}:{s}"
                                            )
                                        }}
                                      </div>
                                    </div>
                                    <div class="operations" v-if="!isSelect">
                                      <span
                                        @click="
                                          handleCorrigendum(
                                            eItem['内容'].dataId
                                          )
                                        "
                                        v-if="
                                          !eItem['内容'].deleteTag &&
                                            eItem['内容'].dataSourceType !==
                                              'CONSUMER'
                                        "
                                      >
                                        <i class="icon_corrigendum" />勘误
                                      </span>
                                      <span
                                        @click="
                                          handleRecords(eItem['内容'].dataId)
                                        "
                                        ><i
                                          class="icon_dataSource"
                                        />数据记录</span
                                      >
                                    </div>
                                  </div>
                                  <div v-if="eItem['附件']">附件：</div>
                                  <div class="eventFile" v-if="eItem['附件']">
                                    <div class="eventFileLayout">
                                      <div></div>
                                      <div class="eventFileList">
                                        <div
                                          @click="handlePreviewImg(file)"
                                          class="eventFileItem"
                                          v-for="(file, fileIndex) in eItem[
                                            '附件'
                                          ].dataValue.split(',')"
                                          :key="fileIndex"
                                        >
                                          {{ file.split(":")[2] }}
                                        </div>
                                      </div>
                                      <div class="operations" v-if="!isSelect">
                                        <span
                                          @click="
                                            handleCorrigendum(
                                              eItem['附件'].dataId
                                            )
                                          "
                                          v-if="
                                            !eItem['附件'].deleteTag &&
                                              eItem['附件'].dataSourceType !==
                                                'CONSUMER'
                                          "
                                        >
                                          <i class="icon_corrigendum" />勘误
                                        </span>
                                        <span
                                          @click="
                                            handleRecords(eItem['附件'].dataId)
                                          "
                                          ><i
                                            class="icon_dataSource"
                                          />数据记录</span
                                        >
                                      </div>
                                    </div>
                                    <div class="eventUpdateDate">
                                      数据更新于{{
                                        eItem["附件"].lastUpdateDate
                                          | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                                      }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </el-timeline-item>

                          <el-timeline-item
                            v-if="eduEventForm && eduIndex === index"
                            id="eduEventForm"
                          >
                            <!-- <div style="margin-bottom:23px">
                            <el-radio
                              v-model="eduEventForm.eventRadio"
                              :label="0"
                              @change="handleEventRadioChange"
                              >时间段</el-radio
                            >
                            <el-radio
                              v-model="eduEventForm.eventRadio"
                              :label="1"
                              @change="handleEventRadioChange"
                              >时间点</el-radio
                            >
                          </div> -->
                            <el-form
                              :model="eduEventForm"
                              v-if="eduEventForm"
                              label-position="left"
                              label-width="85px"
                            >
                              <!-- <el-form-item
                              label="时间："
                              v-if="eduEventForm.eventRadio === 0"
                            >
                              <div style="display:flex">
                                <el-date-picker
                                  :editable="false"
                                  v-model="eduEventForm['时间'].startDate"
                                  value-format="yyyy-MM-dd"
                                  style="width: 289px;"
                                  placeholder="请选择开始时间"
                                ></el-date-picker>
                                <span style="margin-left:10px;margin-right:10px"
                                  >至</span
                                >
                                <el-date-picker
                                  :editable="false"
                                  value-format="yyyy-MM-dd"
                                  v-model="eduEventForm['时间'].endDate"
                                  style="width: 289px;"
                                  placeholder="请选择结束时间"
                                ></el-date-picker>
                              </div>
                            </el-form-item> 
                            <el-form-item v-else label="时间：">
                              <div style="display:flex">
                                <el-date-picker
                                  :editable="false"
                                  v-model="eduEventForm['时间'].startDate"
                                  value-format="yyyy-MM-dd"
                                  style="width: 289px;"
                                  placeholder="请选择时间"
                                ></el-date-picker>
                              </div>
                            </el-form-item>-->
                              <el-form-item label="开始时间">
                                <el-date-picker
                                  :editable="false"
                                  v-model="eduEventForm['时间'].startDate"
                                  value-format="yyyy-MM-dd"
                                  style="width: 289px;"
                                  placeholder="请选择开始时间"
                                ></el-date-picker>
                              </el-form-item>
                              <el-form-item label="结束时间">
                                <el-radio-group
                                  v-model="eduEventForm.eventRadio"
                                  @change="
                                    eventEndDateTypeChange($event, eduEventForm)
                                  "
                                >
                                  <el-radio :label="0">当天</el-radio>
                                  <el-radio :label="1">至今</el-radio>
                                  <el-radio :label="2">时间选择</el-radio>
                                </el-radio-group>
                                <br />
                                <el-date-picker
                                  v-if="eduEventForm.eventRadio === 2"
                                  :editable="false"
                                  value-format="yyyy-MM-dd"
                                  v-model="eduEventForm['时间'].endDate"
                                  style="width: 289px;"
                                  placeholder="请选择结束时间"
                                ></el-date-picker>
                              </el-form-item>
                              <el-form-item label="事件描述：">
                                <el-input
                                  type="textarea"
                                  v-model="eduEventForm['内容'].dataValue"
                                  placeholder="请输入事件描述"
                                ></el-input>
                              </el-form-item>
                              <el-form-item label="附件：">
                                <div class="fileList">
                                  <div
                                    class="fileItem"
                                    v-for="(fItem, fIndex) in fileList"
                                    :key="fItem.uid"
                                  >
                                    {{ fItem.name
                                    }}<i
                                      @click="handleRemoveFile(fIndex)"
                                      class="icon_fileRemove"
                                    ></i>
                                  </div>
                                </div>
                                <el-upload
                                  ref="upload"
                                  class="upload"
                                  action=""
                                  :auto-upload="false"
                                  multiple
                                  :show-file-list="false"
                                  :on-change="
                                    event =>
                                      handleEventUploadChange(
                                        event,
                                        index,
                                        eventIndex
                                      )
                                  "
                                >
                                  <span
                                    style="color:#3A61B1;text-decoration: underline;"
                                    >+选择附件</span
                                  >
                                  <div slot="tip" class="el-upload__tip">
                                    <TipText
                                      text="您可以添加多个图片附件作为信息证明文件上传"
                                    />
                                  </div>
                                </el-upload>
                              </el-form-item>

                              <el-form-item>
                                <Btn
                                  btnText="提交"
                                  :width="69"
                                  :height="30"
                                  :radius="15"
                                  @handleClick="handleSubmitEduEventForm"
                                />
                                <Btn
                                  btnText="取消"
                                  className="primary_plain"
                                  :width="69"
                                  :height="30"
                                  :radius="15"
                                  style="margin-left:13px"
                                  @handleClick="handleCloseEventForm"
                                />
                              </el-form-item>
                            </el-form>
                          </el-timeline-item>
                        </el-timeline>
                      </div>

                      <span
                        v-if="
                          item['教育机构'].modifiable &&
                            !eduEventForm &&
                            !isSelect
                        "
                        class="btn_addEvent"
                        @click="handleAddEduEvent(index)"
                        >+事件/活动记录</span
                      >
                      <!-- <div></div> -->
                      <TipText
                        text="您可以添加在读期间事件/活动记录。如“2022年 参与全国大学生数学建模竞赛获得一等奖”"
                      />
                    </div>
                  </div>
                  <!-- <EventList
                  :event="item['事件/活动记录']"
                  :checkList="checkList"
                  :list="list"
                  :isSelect="isSelect"
                  :index="index"
                  key1="学历教育"
                  key2="事件/活动记录"
                  @handleCheckAll="handleCheckAll1"
                  @handleCheckedChange="handleCheckedChange1"
                  @handleGetList="getList"
                  @handlePreviewImg="handlePreviewImg"
                ></EventList> -->
                </div>
                <div class="panel_toggle" v-if="!item['时间'].deleteTag">
                  <Toggle
                    :flag="eduToggles[index]"
                    @handleClick="handleEduItemToggle(index)"
                  />
                </div>
                <!-- <div class="eduItem_l">
                  <div
                    class="
                      eduItem_l_t
                    "
                  >
                    <el-checkbox
                      v-if="isSelect"
                      v-model="checkList['学历教育'].value[index].checkAll"
                      :indeterminate="
                        checkList['学历教育'].value[index].indeterminate
                      "
                      @change="
                        handleCheckAll($event, '学历教育', undefined, index)
                      "
                    ></el-checkbox>
                    
                    <span class="date">{{
                      `${item["时间"].dataValue.split(",")[0]}~${
                        item["时间"].dataValue.split(",")[1]
                      }`
                    }}</span>
                    <span
                      v-if="item['时间'].deleteTag"
                      style="color: rgb(255, 76, 76); margin-left: 20px;"
                      >已删除</span
                    >
                    
                  </div>
                  <div class="eduItem_l_b">
                    {{ item["时间"].createDate | parseTime("{y}-{m}-{d}") }}
                    {{
                      `由 ${item["时间"].dataSourceName}${
                        item["时间"].deleteTag
                          ? "删除"
                          : item["时间"].dataSourceType === "CONSUMER"
                          ? "自填"
                          : "添加"
                      }`
                    }}
                  </div>
                </div>
                <div class="eduItem_r" v-if="item['教育机构']">
                  <div class="eduItem_r_t">
                    <div>
                      {{ item["教育机构"].dataValue
                      }}<RedDot
                        v-if="redDotMakStr.indexOf(item['上级Id']) > -1"
                      />
                    </div>
                    

                    <Toggle
                      :flag="eduToggles[index]"
                      @handleClick="handleEduItemToggle(index)"
                    />
                  </div>
                  <div class="eduItem_r_b" v-if="!isSelect">
                    <span
                      v-if="item['教育机构'].modifiable"
                      @click="handleAddEduForm('edit', '学历教育', index)"
                      ><i class="icon_edit"/>修改</span
                    >
                    <span
                      v-if="
                        item['教育机构'].dataSourceType !== 'CONSUMER' &&
                          !item['教育机构'].deleteTag
                      "
                      @click="handleCorrigendum(item['教育机构'].dataId)"
                      ><i class="icon_corrigendum"/>勘误</span
                    >
                    <span
                      v-if="item['教育机构'].modifiable"
                      @click="handleDeleteAll(item['上级Id'], '学历教育')"
                      ><i class="icon_delete"/>删除</span
                    >
                    <span @click="handleRecords(item['教育机构'].dataId)"
                      ><i class="icon_dataSource"/>数据记录</span
                    >
                  </div>
                </div> -->
              </div>
              <!-- <div class="eduItemDetails" v-if="eduToggles[index]">
                <div class="eduItemDetail" v-if="item['教育机构']">
                  <div class="value">
                    <el-checkbox
                      v-if="isSelect"
                      v-model="
                        checkList['学历教育'].value[index]['教育机构'][
                          item['教育机构'].dataId
                        ]
                      "
                      @change="
                        handleCheckedChange(
                          $event,
                          '学历教育',
                          '教育机构',
                          index
                        )
                      "
                    >
                    </el-checkbox
                    >教育机构：{{ item["教育机构"].dataValue }}
                  </div>
                  <div class="valueInfo">
                    <div class="updateDate">
                      数据更新于{{
                        list["学历教育"][index]["教育机构"].createDate
                          | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                      }}
                    </div>
                    <div class="operation">
                      <span
                        v-if="
                          !item['教育机构'].deleteTag &&
                            item['教育机构'].dataSourceType !== 'CONSUMER'
                        "
                        @click="handleCorrigendum(item['教育机构'].dataId)"
                        ><i class="icon_corrigendum" />勘误</span
                      >
                      <span @click="handleRecords(item['教育机构'].dataId)"
                        ><i class="icon_dataSource" />数据记录</span
                      >
                    </div>
                  </div>
                </div>

                <div class="eduItemDetail" v-if="item['时间']">
                  <div class="value">
                    <el-checkbox
                      v-if="isSelect"
                      v-model="
                        checkList['学历教育'].value[index]['时间'][
                          item['时间'].dataId
                        ]
                      "
                      @change="
                        handleCheckedChange($event, '学历教育', '时间', index)
                      "
                    >
                    </el-checkbox
                    >时间段：{{
                      item["时间"].dataValue.split(",").length > 1
                        ? `${item["时间"].dataValue.split(",")[0]}~${
                            item["时间"].dataValue.split(",")[1]
                          }`
                        : `${item["时间"].dataValue.split(",")[0]}至今`
                    }}
                  </div>
                  <div class="valueInfo">
                    <div class="updateDate">
                      数据更新于{{
                        list["学历教育"][index]["时间"].createDate
                          | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                      }}
                    </div>
                    <div class="operation">
                      <span
                        v-if="
                          !item['时间'].deleteTag &&
                            item['时间'].dataSourceType !== 'CONSUMER'
                        "
                        @click="handleCorrigendum(item['时间'].dataId)"
                        ><i class="icon_corrigendum" />勘误</span
                      >
                      <span @click="handleRecords(item['时间'].dataId)"
                        ><i class="icon_dataSource" />数据记录</span
                      >
                    </div>
                  </div>
                </div>

                <div class="eduItemDetail" v-if="item['专业名称']">
                  <div class="value">
                    <el-checkbox
                      v-if="isSelect"
                      v-model="
                        checkList['学历教育'].value[index]['专业名称'][
                          item['专业名称'].dataId
                        ]
                      "
                      @change="
                        handleCheckedChange(
                          $event,
                          '学历教育',
                          '专业名称',
                          index
                        )
                      "
                    >
                    </el-checkbox
                    >专业名称：{{
                      list["学历教育"][index]["专业名称"].dataValue
                    }}
                  </div>
                  <div class="valueInfo">
                    <div class="updateDate">
                      数据更新于{{
                        list["学历教育"][index]["专业名称"].createDate
                          | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                      }}
                    </div>
                    <div class="operation">
                      <span
                        v-if="
                          !item['专业名称'].deleteTag &&
                            item['专业名称'].dataSourceType !== 'CONSUMER'
                        "
                        @click="handleCorrigendum(item['专业名称'].dataId)"
                        ><i class="icon_corrigendum" />勘误</span
                      >
                      <span @click="handleRecords(item['专业名称'].dataId)"
                        ><i class="icon_dataSource" />数据记录</span
                      >
                    </div>
                  </div>
                </div>

                <div class="eduItemDetail" v-if="item['专业描述']">
                  <div class="value">
                    <div>
                      <el-checkbox
                        v-if="isSelect"
                        v-model="
                          checkList['学历教育'].value[index]['专业描述'][
                            item['专业描述'].dataId
                          ]
                        "
                        @change="
                          handleCheckedChange(
                            $event,
                            '学历教育',
                            '专业描述',
                            index
                          )
                        "
                      >
                      </el-checkbox
                      >专业描述：
                    </div>
                    <div class="textareaText">
                      {{ list["学历教育"][index]["专业描述"].dataValue }}
                    </div>
                  </div>
                  <div class="valueInfo">
                    <div class="updateDate">
                      数据更新于{{
                        list["学历教育"][index]["专业描述"].createDate
                          | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                      }}
                    </div>
                    <div class="operation">
                      <span
                        v-if="
                          !item['专业描述'].deleteTag &&
                            item['专业描述'].dataSourceType !== 'CONSUMER'
                        "
                        @click="handleCorrigendum(item['专业描述'].dataId)"
                        ><i class="icon_corrigendum" />勘误</span
                      >
                      <span @click="handleRecords(item['专业描述'].dataId)"
                        ><i class="icon_dataSource" />数据记录</span
                      >
                    </div>
                  </div>
                </div>

                <div class="eduItemDetail" v-if="item['专业层次']">
                  <div class="value">
                    <el-checkbox
                      v-if="isSelect"
                      v-model="
                        checkList['学历教育'].value[index]['专业层次'][
                          item['专业层次'].dataId
                        ]
                      "
                      @change="
                        handleCheckedChange(
                          $event,
                          '学历教育',
                          '专业层次',
                          index
                        )
                      "
                    >
                    </el-checkbox
                    >专业层次：{{
                      list["学历教育"][index]["专业层次"].dataValue
                    }}
                  </div>
                  <div class="valueInfo">
                    <div class="updateDate">
                      数据更新于{{
                        list["学历教育"][index]["专业层次"].createDate
                          | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                      }}
                    </div>
                    <div class="operation">
                      <span
                        v-if="
                          !item['专业层次'].deleteTag &&
                            item['专业层次'].dataSourceType !== 'CONSUMER'
                        "
                        @click="handleCorrigendum(item['专业层次'].dataId)"
                        ><i class="icon_corrigendum" />勘误</span
                      >
                      <span @click="handleRecords(item['专业层次'].dataId)"
                        ><i class="icon_dataSource" />数据记录</span
                      >
                    </div>
                  </div>
                </div>

                <div class="eduItemDetail" v-if="item['学制']">
                  <div class="value">
                    <el-checkbox
                      v-if="isSelect"
                      v-model="
                        checkList['学历教育'].value[index]['学制'][
                          item['学制'].dataId
                        ]
                      "
                      @change="
                        handleCheckedChange($event, '学历教育', '学制', index)
                      "
                    >
                    </el-checkbox
                    >学制：{{ list["学历教育"][index]["学制"].dataValue }}
                  </div>
                  <div class="valueInfo">
                    <div class="updateDate">
                      数据更新于{{
                        list["学历教育"][index]["学制"].createDate
                          | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                      }}
                    </div>
                    <div class="operation">
                      <span
                        v-if="
                          !item['学制'].deleteTag &&
                            item['学制'].dataSourceType !== 'CONSUMER'
                        "
                        @click="handleCorrigendum(item['学制'].dataId)"
                        ><i class="icon_corrigendum" />勘误</span
                      >
                      <span @click="handleRecords(item['学制'].dataId)"
                        ><i class="icon_dataSource" />数据记录</span
                      >
                    </div>
                  </div>
                </div>

                <div class="eduItemDetail" v-if="item['是否全日制']">
                  <div class="value">
                    <el-checkbox
                      v-if="isSelect"
                      v-model="
                        checkList['学历教育'].value[index]['是否全日制'][
                          item['是否全日制'].dataId
                        ]
                      "
                      @change="
                        handleCheckedChange(
                          $event,
                          '学历教育',
                          '是否全日制',
                          index
                        )
                      "
                    >
                    </el-checkbox
                    >是否全日制：{{
                      list["学历教育"][index]["是否全日制"].dataValue
                    }}
                  </div>
                  <div class="valueInfo">
                    <div class="updateDate">
                      数据更新于{{
                        list["学历教育"][index]["是否全日制"].createDate
                          | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                      }}
                    </div>
                    <div class="operation">
                      <span
                        v-if="
                          !item['是否全日制'].deleteTag &&
                            item['是否全日制'].dataSourceType !== 'CONSUMER'
                        "
                        @click="handleCorrigendum(item['是否全日制'].dataId)"
                        ><i class="icon_corrigendum" />勘误</span
                      >
                      <span @click="handleRecords(item['是否全日制'].dataId)"
                        ><i class="icon_dataSource" />数据记录</span
                      >
                    </div>
                  </div>
                </div>

                <div class="eduItemDetail" v-if="item['班期']">
                  <div class="value">
                    <el-checkbox
                      v-if="isSelect"
                      v-model="
                        checkList['学历教育'].value[index]['班期'][
                          item['班期'].dataId
                        ]
                      "
                      @change="
                        handleCheckedChange($event, '学历教育', '班期', index)
                      "
                    >
                    </el-checkbox
                    >班期：{{ item["班期"].dataValue }}
                  </div>
                  <div class="valueInfo">
                    <div class="updateDate">
                      数据更新于{{
                        list["学历教育"][index]["班期"].createDate
                          | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                      }}
                    </div>
                    <div class="operation">
                      <span
                        v-if="
                          !item['班期'].deleteTag &&
                            item['班期'].dataSourceType !== 'CONSUMER'
                        "
                        @click="handleCorrigendum(item['班期'].dataId)"
                        ><i class="icon_corrigendum" />勘误</span
                      >
                      <span @click="handleRecords(item['班期'].dataId)"
                        ><i class="icon_dataSource" />数据记录</span
                      >
                    </div>
                  </div>
                </div>

                <div class="eduItemDetail" v-if="item['教育结果']">
                  <div class="value">
                    <el-checkbox
                      v-if="isSelect"
                      v-model="
                        checkList['学历教育'].value[index]['教育结果'][
                          item['教育结果'].dataId
                        ]
                      "
                      @change="
                        handleCheckedChange(
                          $event,
                          '学历教育',
                          '教育结果',
                          index
                        )
                      "
                    >
                    </el-checkbox
                    >教育结果：{{
                      list["学历教育"][index]["教育结果"].dataValue
                    }}
                  </div>
                  <div class="valueInfo">
                    <div class="updateDate">
                      数据更新于{{
                        list["学历教育"][index]["教育结果"].createDate
                          | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                      }}
                    </div>
                    <div class="operation">
                      <span
                        v-if="
                          !item['教育结果'].deleteTag &&
                            item['教育结果'].dataSourceType !== 'CONSUMER'
                        "
                        @click="handleCorrigendum(item['教育结果'].dataId)"
                        ><i class="icon_corrigendum" />勘误</span
                      >
                      <span @click="handleRecords(item['教育结果'].dataId)"
                        ><i class="icon_dataSource" />数据记录</span
                      >
                    </div>
                  </div>
                </div>

                <div class="eduItemDetail" v-if="item['附件']">
                  <div class="value">
                    <el-checkbox
                      v-if="isSelect"
                      v-model="
                        checkList['学历教育'].value[index]['附件'][
                          item['附件'].dataId
                        ]
                      "
                      @change="
                        handleCheckedChange($event, '学历教育', '附件', index)
                      "
                    >
                    </el-checkbox
                    >附件：
                  </div>
                  <div class="files">
                    <div
                      class="file"
                      v-for="(file, fileIndex) in item['附件'].dataValue.split(
                        ','
                      )"
                      :key="fileIndex"
                    >
                      <div style="line-height: 30px;">
                        <div class="fileName" @click="handlePreviewImg(file)">
                          {{ file.split(":")[2] }}
                        </div>
                        <div class="updateDate">
                          {{
                            item["附件"].createDate
                              | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                          }}
                        </div>
                      </div>
                      <div class="operation">
                        <span
                          v-if="
                            !item['附件'].deleteTag &&
                              item['附件'].dataSourceType !== 'CONSUMER'
                          "
                          @click="handleCorrigendum(item['附件'].dataId)"
                          ><i class="icon_corrigendum" />勘误</span
                        >
                        <span @click="handleRecords(item['附件'].dataId)"
                          ><i class="icon_dataSource" />数据记录</span
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <div class="eduItemDetail">
                  <div
                    class="value"
                    v-if="
                      item['事件/活动记录'] === undefined
                        ? item['时间'].dataSourceType === 'CONSUMER'
                        : true
                    "
                  >
                    <div
                      v-if="
                        item['时间'].dataSourceType === 'CONSUMER' ||
                          item['事件/活动记录']
                      "
                    >
                      <el-checkbox
                        v-if="
                          isSelect &&
                            checkList['学历教育'].value[index]['事件/活动记录']
                        "
                        v-model="
                          checkList['学历教育'].value[index]['事件/活动记录']
                            .checkAll
                        "
                        :indeterminate="
                          checkList['学历教育'].value[index]['事件/活动记录']
                            .indeterminate
                        "
                        @change="
                          handleCheckAll(
                            $event,
                            '学历教育',
                            '事件/活动记录',
                            index
                          )
                        "
                      ></el-checkbox
                      >事件/活动记录：
                    </div>
                    <div class="timeLine">
                      <el-timeline>
                        <el-timeline-item
                          v-if="
                            isSelect
                              ? !eItem['时间'].deleteTag
                              : eItem['时间'].deleteTag
                              ? isShowInvalid
                                ? true
                                : false
                              : true
                          "
                          v-for="(eItem, eventIndex) in item['事件/活动记录']"
                          :key="eventIndex"
                          :hide-timestamp="true"
                        >
                          <div style="line-height: 26px;">
                            <div style="display:flex">
                              <el-checkbox
                                v-if="isSelect"
                                v-model="
                                  checkList['学历教育'].value[index][
                                    '事件/活动记录'
                                  ].value[eventIndex][
                                    Object.keys(eItem)
                                      .filter(e => e !== '上级Id')
                                      .map(r => eItem[r].dataId.toString())
                                  ]
                                "
                                @change="
                                  handleCheckedChange(
                                    $event,
                                    '学历教育',
                                    '事件/活动记录',
                                    index
                                  )
                                "
                              >
                              </el-checkbox>
                              <div class="eventItem">
                                <div class="eventDate" v-if="eItem['时间']">
                                  <div>
                                    <div style="display:flex">
                                      <div
                                        :class="
                                          `${eItem['时间'].deleteTag &&
                                            'deleteLine'}`
                                        "
                                      >
                                        {{
                                          eItem["时间"].dataValue.split(",")
                                            .length > 1
                                            ? eItem["时间"].dataValue.split(
                                                ","
                                              )[0] +
                                              "~" +
                                              eItem["时间"].dataValue.split(
                                                ","
                                              )[1]
                                            : eItem["时间"].dataValue
                                        }}
                                      </div>
                                      <span
                                        v-if="eItem['时间'].deleteTag"
                                        style="color:#FF4C4C;margin-left:15px"
                                        >已删除</span
                                      >
                                    </div>
                                    <div class="eventUpdateDate">
                                      数据更新于{{
                                        eItem["时间"].lastUpdateDate
                                          | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                                      }}
                                    </div>
                                  </div>
                                  <div class="operations" v-if="!isSelect">
                                    <span
                                      v-if="
                                        eItem['时间'].dataSourceType ===
                                          'CONSUMER' && !eItem['时间'].deleteTag
                                      "
                                      @click="
                                        handleEditEvent(
                                          eItem,
                                          eItem['上级Id'],
                                          index
                                        )
                                      "
                                      ><i class="icon_edit" />修改</span
                                    >
                                    <span
                                      v-if="
                                        eItem['时间'].dataSourceType ===
                                          'CONSUMER' && !eItem['时间'].deleteTag
                                      "
                                      @click="
                                        handleDeleteAll(
                                          eItem['上级Id'],
                                          '事件/活动记录'
                                        )
                                      "
                                      ><i class="icon_delete" />删除</span
                                    >
                                    <span
                                      @click="
                                        handleCorrigendum(eItem['时间'].dataId)
                                      "
                                      v-if="
                                        !eItem['时间'].deleteTag &&
                                          eItem['时间'].dataSourceType !==
                                            'CONSUMER'
                                      "
                                    >
                                      <i class="icon_corrigendum" />勘误
                                    </span>
                                    <span
                                      @click="
                                        handleRecords(eItem['时间'].dataId)
                                      "
                                      ><i
                                        class="icon_dataSource"
                                      />数据记录</span
                                    >
                                  </div>
                                </div>

                                <div class="eventContent" v-if="eItem['内容']">
                                  <div>
                                    <div style="display:flex">
                                      <div
                                        :class="
                                          `eContent ${eItem['内容'].deleteTag &&
                                            'deleteLine'}`
                                        "
                                      >
                                        {{ eItem["内容"].dataValue }}
                                      </div>
                                      <span
                                        v-if="eItem['内容'].deleteTag"
                                        style="color:#FF4C4C;margin-left:15px"
                                        >已删除</span
                                      >
                                    </div>
                                    <div class="eventUpdateDate">
                                      数据更新于{{
                                        eItem["内容"].lastUpdateDate
                                          | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                                      }}
                                    </div>
                                  </div>
                                  <div class="operations" v-if="!isSelect">
                                    <span
                                      @click="
                                        handleCorrigendum(eItem['内容'].dataId)
                                      "
                                      v-if="
                                        !eItem['内容'].deleteTag &&
                                          eItem['内容'].dataSourceType !==
                                            'CONSUMER'
                                      "
                                    >
                                      <i class="icon_corrigendum" />勘误
                                    </span>
                                    <span
                                      @click="
                                        handleRecords(eItem['内容'].dataId)
                                      "
                                      ><i
                                        class="icon_dataSource"
                                      />数据记录</span
                                    >
                                  </div>
                                </div>
                                <div v-if="eItem['附件']">附件：</div>
                                <div class="eventFile" v-if="eItem['附件']">
                                  <div class="eventFileLayout">
                                    <div></div>
                                    <div class="eventFileList">
                                      <div
                                        @click="handlePreviewImg(file)"
                                        class="eventFileItem"
                                        v-for="(file, fileIndex) in eItem[
                                          '附件'
                                        ].dataValue.split(',')"
                                        :key="fileIndex"
                                      >
                                        {{ file.split(":")[2] }}
                                      </div>
                                    </div>
                                    <div class="operations" v-if="!isSelect">
                                      <span
                                        @click="
                                          handleCorrigendum(
                                            eItem['附件'].dataId
                                          )
                                        "
                                        v-if="
                                          !eItem['附件'].deleteTag &&
                                            eItem['附件'].dataSourceType !==
                                              'CONSUMER'
                                        "
                                      >
                                        <i class="icon_corrigendum" />勘误
                                      </span>
                                      <span
                                        @click="
                                          handleRecords(eItem['附件'].dataId)
                                        "
                                        ><i
                                          class="icon_dataSource"
                                        />数据记录</span
                                      >
                                    </div>
                                  </div>
                                  <div class="eventUpdateDate">
                                    数据更新于{{
                                      eItem["附件"].lastUpdateDate
                                        | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                                    }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </el-timeline-item>

                        <el-timeline-item
                          v-if="eduEventForm && eduIndex === index"
                          id="eduEventForm"
                        >
                          
                          <el-form
                            :model="eduEventForm"
                            v-if="eduEventForm"
                            label-position="left"
                            label-width="85px"
                          >
                            <el-form-item label="开始时间">
                              <el-date-picker
                                :editable="false"
                                v-model="eduEventForm['时间'].startDate"
                                value-format="yyyy-MM-dd"
                                style="width: 289px;"
                                placeholder="请选择开始时间"
                              ></el-date-picker>
                            </el-form-item>
                            <el-form-item label="结束时间">
                              <el-radio-group
                                v-model="eduEventForm.eventRadio"
                                @change="
                                  eventEndDateTypeChange($event, eduEventForm)
                                "
                              >
                                <el-radio :label="0">当天</el-radio>
                                <el-radio :label="1">至今</el-radio>
                                <el-radio :label="2">时间选择</el-radio>
                              </el-radio-group>
                              <br />
                              <el-date-picker
                                v-if="eduEventForm.eventRadio === 2"
                                :editable="false"
                                value-format="yyyy-MM-dd"
                                v-model="eduEventForm['时间'].endDate"
                                style="width: 289px;"
                                placeholder="请选择结束时间"
                              ></el-date-picker>
                            </el-form-item>
                            <el-form-item label="事件描述：">
                              <el-input
                                type="textarea"
                                v-model="eduEventForm['内容'].dataValue"
                                placeholder="请输入事件描述"
                              ></el-input>
                            </el-form-item>
                            <el-form-item label="附件：">
                              <div class="fileList">
                                <div
                                  class="fileItem"
                                  v-for="(fItem, fIndex) in fileList"
                                  :key="fItem.uid"
                                >
                                  {{ fItem.name
                                  }}<i
                                    @click="handleRemoveFile(fIndex)"
                                    class="icon_fileRemove"
                                  ></i>
                                </div>
                              </div>
                              <el-upload
                                ref="upload"
                                class="upload"
                                action=""
                                :auto-upload="false"
                                multiple
                                :show-file-list="false"
                                :on-change="
                                  event =>
                                    handleEventUploadChange(
                                      event,
                                      index,
                                      eventIndex
                                    )
                                "
                              >
                                <span
                                  style="color:#3A61B1;text-decoration: underline;"
                                  >+选择附件</span
                                >
                                <div slot="tip" class="el-upload__tip">
                                  <TipText
                                    text="您可以添加多个图片附件作为信息证明文件上传"
                                  />
                                </div>
                              </el-upload>
                            </el-form-item>

                            <el-form-item>
                              <Btn
                                btnText="提交"
                                :width="69"
                                :height="30"
                                :radius="15"
                                @handleClick="handleSubmitEduEventForm"
                              />
                              <Btn
                                btnText="取消"
                                className="primary_plain"
                                :width="69"
                                :height="30"
                                :radius="15"
                                style="margin-left:13px"
                                @handleClick="handleCloseEventForm"
                              />
                            </el-form-item>
                          </el-form>
                        </el-timeline-item>
                      </el-timeline>
                    </div>

                    <span
                      v-if="
                        item['教育机构'].modifiable &&
                          !eduEventForm &&
                          !isSelect
                      "
                      class="btn_addEvent"
                      @click="handleAddEduEvent(index)"
                      >+事件/活动记录</span
                    >
                    <TipText
                      text="您可以添加在读期间事件/活动记录。如“2022年 参与全国大学生数学建模竞赛获得一等奖”"
                    />
                  </div>
                </div>
                
              </div> -->
            </div>

            <div id="eduForm" class="eduForm" v-if="isAddEdu">
              <el-form
                :model="eduForm"
                label-width="120px"
                label-position="left"
              >
                <el-form-item label="教育阶段：">
                  <el-select
                    v-model="educationStage"
                    style="width:100%"
                    @change="handleStageChange"
                  >
                    <el-option label="高等教育" :value="4"></el-option>
                    <el-option label="高中" :value="5"></el-option>
                    <el-option label="职高" :value="6"></el-option>
                    <el-option label="初中" :value="7"></el-option>
                    <el-option label="中专" :value="8"></el-option>
                    <el-option label="小学" :value="9"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="教育机构：" v-if="educationStage">
                  <!-- <el-input v-model="eduForm['教育机构']"></el-input> -->
                  <el-autocomplete
                    popper-class="my-autocomplete"
                    clearable
                    style="width:100%"
                    v-model="eduForm['教育机构']"
                    :fetch-suggestions="queryEduSearch"
                    :trigger-on-focus="false"
                    placeholder="请输入教育机构名称"
                    @select="val => handleSelectAuto(val, '学历教育')"
                  >
                    <template slot-scope="scope">
                      <div class="autoName">
                        <span>{{ scope.item.name }}</span>
                        <i
                          v-if="scope.item.authentication"
                          class="icon_renzheng"
                        ></i>
                      </div>
                      <!-- <span class="autoTag">{{item.item.authentication}}</span> -->
                    </template>
                  </el-autocomplete>
                </el-form-item>

                <el-form-item label="开始时间：" v-if="educationStage">
                  <el-date-picker
                    :editable="false"
                    v-model="eduForm['时间'][0]"
                    value-format="yyyy-MM-dd"
                    style="width: 286px;"
                    placeholder="请选择开始时间"
                  ></el-date-picker>
                </el-form-item>

                <el-form-item label="结束时间" v-if="educationStage">
                  <el-radio-group
                    v-model="eduForm.endDateType"
                    @change="endDateTypeChange($event, eduForm)"
                  >
                    <el-radio :label="0">当天</el-radio>
                    <el-radio :label="1">至今</el-radio>
                    <el-radio :label="2">时间选择</el-radio>
                  </el-radio-group>
                  <br />
                  <el-date-picker
                    v-if="eduForm.endDateType === 2"
                    :editable="false"
                    value-format="yyyy-MM-dd"
                    v-model="eduForm['时间'][1]"
                    style="width: 286px;"
                    placeholder="请选择结束时间"
                  ></el-date-picker>
                </el-form-item>

                <el-form-item
                  label="专业名称："
                  v-if="
                    educationStage &&
                      (educationStage === 4 ||
                        educationStage === 6 ||
                        educationStage === 8)
                  "
                >
                  <el-input
                    v-model="eduForm['专业名称']"
                    placeholder="请输入专业名称"
                  ></el-input>
                </el-form-item>

                <el-form-item
                  label="专业描述："
                  v-if="
                    educationStage &&
                      (educationStage === 4 ||
                        educationStage === 6 ||
                        educationStage === 8)
                  "
                >
                  <el-input
                    v-model="eduForm['专业描述']"
                    type="textarea"
                    :autosize="{ minRows: 5, maxRows: 5 }"
                    placeholder="请简单描述专业信息。如“通信技术专业主要学习通信技术、通信系统和通信网等方面的知识，能在通信领域中从事研究、设计、制造、应用通信技术与设备。”"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="专业层次："
                  v-if="educationStage && educationStage === 4"
                >
                  <el-select v-model="eduForm['专业层次']" style="width:100%">
                    <el-option label="专科" value="专科"></el-option>
                    <el-option label="本科" value="本科"></el-option>
                    <el-option
                      label="硕士研究生"
                      value="硕士研究生"
                    ></el-option>
                    <el-option
                      label="博士研究生"
                      value="博士研究生"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item
                  label="学制："
                  v-if="educationStage && educationStage === 4"
                >
                  <el-select v-model="eduForm['学制']" style="width:100%">
                    <el-option label="二年制" value="二年制"></el-option>
                    <el-option label="三年制" value="三年制"></el-option>
                    <el-option label="四年制" value="四年制"></el-option>
                    <el-option label="五年制" value="五年制"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item
                  label="是否全日制："
                  v-if="educationStage && educationStage === 4"
                >
                  <el-select v-model="eduForm['是否全日制']" style="width:100%">
                    <el-option label="全日制" value="全日制"></el-option>
                    <el-option label="非全日制" value="非全日制"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="班期：" v-if="educationStage">
                  <el-input
                    v-model="eduForm['班期']"
                    placeholder="请输入班期信息。如“2022届新闻1班、2022级实验3班”"
                  ></el-input>
                </el-form-item>

                <el-form-item label="教育结果：" v-if="educationStage">
                  <el-select v-model="eduForm['教育结果']" style="width:100%">
                    <el-option label="在读" value="在读"></el-option>
                    <el-option label="结业" value="结业"></el-option>
                    <el-option label="毕业" value="毕业"></el-option>
                    <el-option label="肄业" value="肄业"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="添加附件：" v-if="educationStage">
                  <div class="fileList">
                    <div
                      class="fileItem"
                      v-for="(item, index) in fileList"
                      :key="item.uid"
                    >
                      {{ item.name
                      }}<i
                        @click="handleRemoveFile(index)"
                        class="icon_fileRemove"
                      ></i>
                    </div>
                  </div>
                  <el-upload
                    ref="upload"
                    class="upload"
                    action=""
                    :auto-upload="false"
                    multiple
                    :show-file-list="false"
                    :on-change="handleUploadChange"
                  >
                    <span style="color:#3A61B1;text-decoration: underline;"
                      >+选择附件</span
                    >
                    <div slot="tip" class="el-upload__tip">
                      <TipText
                        text="您可以添加多个图片附件作为信息证明文件上传"
                      />
                    </div>
                  </el-upload>
                </el-form-item>

                <el-form-item>
                  <Btn
                    btnText="提交"
                    className="primary"
                    :height="30"
                    :width="69"
                    style="margin-right:13px"
                    @handleClick="handleSubmitEduForm"
                  />
                  <Btn
                    btnText="取消"
                    className="primary_plain"
                    :height="30"
                    :width="69"
                    @handleClick="handleCloseAddEdu"
                  />
                </el-form-item>
                <el-form-item>
                  <TipText
                    text="教育经历信息提交成功后，可添加事件/活动记录信息。"
                  />
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div id="noEduInfo" class="piItem">
          <div class="piTitle">
            <div class="titleName">
              <el-checkbox
                v-if="isSelect"
                v-model="checkList['非学历教育'].checkAll"
                :indeterminate="checkList['非学历教育'].indeterminate"
                @change="handleCheckAll($event, '非学历教育')"
              ></el-checkbox
              >非学历教育<Btn
                v-if="!isSelect"
                btnText="非学历教育"
                :width="128"
                className="default"
                :height="39"
                style="margin-left:14px"
                :plus="true"
                @handleClick="handleAddNoEduForm('add')"
              />
            </div>
            <Toggle
              :flag="toggle['非学历教育']"
              @handleClick="toggle['非学历教育'] = !toggle['非学历教育']"
            />
          </div>
          <div
            class="eduList"
            v-if="toggle['非学历教育'] && (list['非学历教育'] || isAddNoEdu)"
          >
            <div
              :class="`eduItem ${item['时间'].deleteTag ? 'deleteTag' : ''}`"
              v-for="(item, index) in list['非学历教育']"
              v-if="
                isSelect
                  ? !item['时间'].deleteTag
                  : item['时间'].deleteTag
                  ? isShowInvalid
                    ? true
                    : false
                  : true
              "
              :key="index"
            >
              <div class="eduItemPanel">
                <div class="panel_top">
                  <div class="panel_top_left">
                    <div class="panel_top_left_top">
                      <el-checkbox
                        v-if="isSelect"
                        v-model="checkList['非学历教育'].value[index].checkAll"
                        :indeterminate="
                          checkList['非学历教育'].value[index].indeterminate
                        "
                        @change="
                          handleCheckAll($event, '非学历教育', undefined, index)
                        "
                      ></el-checkbox>
                      <span class="date">{{
                        `${item["时间"].dataValue.split(",")[0]}~${
                          item["时间"].dataValue.split(",")[1]
                        }`
                      }}</span>
                      <span
                        v-if="item['时间'].deleteTag"
                        style="color: rgb(255, 76, 76); margin-left: 20px;"
                        >已删除</span
                      >
                    </div>
                    <div class="panel_top_left_bottom">
                      <!-- {{ item["时间"].createDate | parseTime("{y}-{m}-{d}") }}
                      {{
                        `由 ${item["时间"].dataSourceName}${
                          item["时间"].deleteTag
                            ? "删除"
                            : item["时间"].dataSourceType === "CONSUMER"
                            ? "自填"
                            : "添加"
                        }`
                      }} -->
                    </div>
                  </div>
                  <div class="panel_top_right">
                    {{ item["教育机构"].dataValue
                    }}<RedDot
                      v-if="redDotMakStr.indexOf(item['上级Id']) > -1"
                    />
                    <span
                      class="jigourenzheng"
                      v-if="
                        !isSelect
                          ? superiorIdAttachInfoResponseVoMap[item['上级Id']]
                            ? superiorIdAttachInfoResponseVoMap[item['上级Id']]
                                .businessNameAuthenticationTag
                              ? false
                              : superiorIdAttachInfoResponseVoMap[
                                  item['上级Id']
                                ].businessNameAuthenticationApply
                              ? false
                              : true
                            : true
                          : false
                      "
                      @click="
                        handleAgencyApply(
                          item['教育机构'].dataValue,
                          item['上级Id']
                        )
                      "
                      >机构认证>></span
                    >
                    <span
                      v-if="
                        superiorIdAttachInfoResponseVoMap[item['上级Id']] &&
                          superiorIdAttachInfoResponseVoMap[item['上级Id']]
                            .businessNameAuthenticationTag
                      "
                      ><i class="icon_renzheng" />已认证</span
                    >
                  </div>
                </div>
                <div class="panel_bottom">
                  <div class="panel_bottom_left">
                    <!-- <div class="renzhengBox">
                      <i class="icon_yirenzheng" />
                      <span class="renzhengText">
                        有<span class="renzhengNum">2568</span>人认证
                        |&nbsp;</span
                      ><span class="inviteText"> 邀请认证>></span>
                    </div> -->
                    {{ item["时间"].createDate | parseTime("{y}-{m}-{d}") }}
                    {{
                      `由 ${item["时间"].dataSourceName}${
                        item["时间"].deleteTag
                          ? "删除"
                          : item["时间"].dataSourceType === "CONSUMER"
                          ? "自填"
                          : "添加"
                      }`
                    }}
                  </div>
                  <div class="panel_bottom_right">
                    <span
                      v-if="item['教育机构'].modifiable"
                      @click="handleAddNoEduForm('edit', '非学历教育', index)"
                      ><i class="icon_edit" />修改</span
                    >
                    <span
                      v-if="
                        item['教育机构'].dataSourceType !== 'CONSUMER' &&
                          !item['教育机构'].deleteTag
                      "
                      @click="handleCorrigendum(item['教育机构'].dataId)"
                      ><i class="icon_corrigendum" />勘误</span
                    >
                    <span
                      v-if="item['教育机构'].modifiable"
                      @click="handleDeleteAll(item['上级Id'], '学历教育')"
                      ><i class="icon_delete" />删除</span
                    >
                    <span @click="handleRecords(item['教育机构'].dataId)"
                      ><i class="icon_dataSource" />数据记录</span
                    >
                  </div>
                </div>
                <div class="eduItemDetails" v-if="noEduToggles[index]">
                  <div class="eduItemDetail" v-if="item['教育机构']">
                    <div class="value">
                      <el-checkbox
                        v-if="isSelect"
                        v-model="
                          checkList['非学历教育'].value[index]['教育机构'][
                            item['教育机构'].dataId
                          ]
                        "
                        @change="
                          handleCheckedChange(
                            $event,
                            '非学历教育',
                            '教育机构',
                            index
                          )
                        "
                      >
                      </el-checkbox
                      >教育机构:{{
                        list["非学历教育"][index]["教育机构"].dataValue
                      }}
                    </div>
                    <div class="valueInfo">
                      <div class="updateDate">
                        数据更新于{{
                          list["非学历教育"][index]["教育机构"].createDate
                            | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                        }}
                      </div>
                      <div class="operation">
                        <span
                          @click="handleCorrigendum(item['教育机构'].dataId)"
                          v-if="
                            !item['教育机构'].deleteTag &&
                              item['教育机构'].dataSourceType !== 'CONSUMER'
                          "
                          ><i class="icon_corrigendum" />勘误</span
                        >
                        <span @click="handleRecords(item['教育机构'].dataId)"
                          ><i class="icon_dataSource" />数据记录</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="eduItemDetail" v-if="item['机构描述']">
                    <div class="value">
                      <div>
                        <el-checkbox
                          v-if="isSelect"
                          v-model="
                            checkList['非学历教育'].value[index]['机构描述'][
                              item['机构描述'].dataId
                            ]
                          "
                          @change="
                            handleCheckedChange(
                              $event,
                              '非学历教育',
                              '机构描述',
                              index
                            )
                          "
                        >
                        </el-checkbox
                        >机构描述：
                      </div>
                      <div class="textareaText">
                        {{ list["非学历教育"][index]["机构描述"].dataValue }}
                      </div>
                    </div>
                    <div class="valueInfo">
                      <div class="updateDate">
                        数据更新于{{
                          list["非学历教育"][index]["机构描述"].createDate
                            | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                        }}
                      </div>
                      <div class="operation">
                        <span
                          @click="handleCorrigendum(item['机构描述'].dataId)"
                          v-if="
                            !item['机构描述'].deleteTag &&
                              item['机构描述'].dataSourceType !== 'CONSUMER'
                          "
                          ><i class="icon_corrigendum" />勘误</span
                        >
                        <span @click="handleRecords(item['机构描述'].dataId)"
                          ><i class="icon_dataSource" />数据记录</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="eduItemDetail">
                    <div class="value">
                      <el-checkbox
                        v-if="isSelect"
                        v-model="
                          checkList['非学历教育'].value[index]['时间'][
                            item['时间'].dataId
                          ]
                        "
                        @change="
                          handleCheckedChange(
                            $event,
                            '非学历教育',
                            '时间',
                            index
                          )
                        "
                      >
                      </el-checkbox
                      >时间段：{{
                        item["时间"].dataValue.split(",").length > 1
                          ? `${item["时间"].dataValue.split(",")[0]}~${
                              item["时间"].dataValue.split(",")[1]
                            }`
                          : `${item["时间"].dataValue.split(",")[0]}至今`
                      }}
                    </div>
                    <div class="valueInfo">
                      <div class="updateDate">
                        数据更新于{{
                          list["非学历教育"][index]["时间"].createDate
                            | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                        }}
                      </div>
                      <div class="operation">
                        <span
                          @click="handleCorrigendum(item['时间'].dataId)"
                          v-if="
                            !item['时间'].deleteTag &&
                              item['时间'].dataSourceType !== 'CONSUMER'
                          "
                          ><i class="icon_corrigendum" />勘误</span
                        >
                        <span @click="handleRecords(item['时间'].dataId)"
                          ><i class="icon_dataSource" />数据记录</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="eduItemDetail" v-if="item['教育产品']">
                    <div class="value">
                      <el-checkbox
                        v-if="isSelect"
                        v-model="
                          checkList['非学历教育'].value[index]['教育产品'][
                            item['教育产品'].dataId
                          ]
                        "
                        @change="
                          handleCheckedChange(
                            $event,
                            '非学历教育',
                            '教育产品',
                            index
                          )
                        "
                      >
                      </el-checkbox
                      >教育产品：{{
                        list["非学历教育"][index]["教育产品"].dataValue
                      }}
                    </div>
                    <div class="valueInfo">
                      <div class="updateDate">
                        数据更新于{{
                          list["非学历教育"][index]["教育产品"].createDate
                            | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                        }}
                      </div>
                      <div class="operation">
                        <span
                          @click="handleCorrigendum(item['教育产品'].dataId)"
                          v-if="
                            !item['教育产品'].deleteTag &&
                              item['教育产品'].dataSourceType !== 'CONSUMER'
                          "
                          ><i class="icon_corrigendum" />勘误</span
                        >
                        <span @click="handleRecords(item['教育产品'].dataId)"
                          ><i class="icon_dataSource" />数据记录</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="eduItemDetail" v-if="item['产品描述']">
                    <div class="value">
                      <div>
                        <el-checkbox
                          v-if="isSelect"
                          v-model="
                            checkList['非学历教育'].value[index]['产品描述'][
                              item['产品描述'].dataId
                            ]
                          "
                          @change="
                            handleCheckedChange(
                              $event,
                              '非学历教育',
                              '产品描述',
                              index
                            )
                          "
                        >
                        </el-checkbox
                        >产品描述：
                      </div>
                      <div class="textareaText">
                        {{ list["非学历教育"][index]["产品描述"].dataValue }}
                      </div>
                    </div>
                    <div class="valueInfo">
                      <div class="updateDate">
                        数据更新于{{
                          list["非学历教育"][index]["产品描述"].createDate
                            | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                        }}
                      </div>
                      <div class="operation">
                        <span
                          @click="handleCorrigendum(item['产品描述'].dataId)"
                          v-if="
                            !item['产品描述'].deleteTag &&
                              item['产品描述'].dataSourceType !== 'CONSUMER'
                          "
                          ><i class="icon_corrigendum" />勘误</span
                        >
                        <span @click="handleRecords(item['产品描述'].dataId)"
                          ><i class="icon_dataSource" />数据记录</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="eduItemDetail" v-if="item['班期']">
                    <div class="value">
                      <el-checkbox
                        v-if="isSelect"
                        v-model="
                          checkList['非学历教育'].value[index]['班期'][
                            item['班期'].dataId
                          ]
                        "
                        @change="
                          handleCheckedChange(
                            $event,
                            '非学历教育',
                            '班期',
                            index
                          )
                        "
                      >
                      </el-checkbox
                      >班期：{{ item["班期"].dataValue }}
                    </div>
                    <div class="valueInfo">
                      <div class="updateDate">
                        数据更新于{{
                          item["班期"].createDate
                            | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                        }}
                      </div>
                      <div class="operation">
                        <span
                          @click="handleCorrigendum(item['班期'].dataId)"
                          v-if="
                            !item['班期'].deleteTag &&
                              item['班期'].dataSourceType !== 'CONSUMER'
                          "
                          ><i class="icon_corrigendum" />勘误</span
                        >
                        <span @click="handleRecords(item['班期'].dataId)"
                          ><i class="icon_dataSource" />数据记录</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="eduItemDetail" v-if="item['教育结果']">
                    <div class="value">
                      <el-checkbox
                        v-if="isSelect"
                        v-model="
                          checkList['非学历教育'].value[index]['教育结果'][
                            item['教育结果'].dataId
                          ]
                        "
                        @change="
                          handleCheckedChange(
                            $event,
                            '非学历教育',
                            '教育结果',
                            index
                          )
                        "
                      >
                      </el-checkbox
                      >教育结果：{{
                        list["非学历教育"][index]["教育结果"].dataValue
                      }}
                    </div>
                    <div class="valueInfo">
                      <div class="updateDate">
                        数据更新于{{
                          list["非学历教育"][index]["教育结果"].createDate
                            | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                        }}
                      </div>
                      <div class="operation">
                        <span
                          v-if="
                            !item['教育结果'].deleteTag &&
                              item['教育结果'].dataSourceType !== 'CONSUMER'
                          "
                          @click="handleCorrigendum(item['教育结果'].dataId)"
                          ><i class="icon_corrigendum" />勘误</span
                        >
                        <span @click="handleRecords(item['教育结果'].dataId)"
                          ><i class="icon_dataSource" />数据记录</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="eduItemDetail" v-if="item['附件']">
                    <div class="value">
                      <el-checkbox
                        v-if="isSelect"
                        v-model="
                          checkList['非学历教育'].value[index]['附件'][
                            item['附件'].dataId
                          ]
                        "
                        @change="
                          handleCheckedChange(
                            $event,
                            '非学历教育',
                            '附件',
                            index
                          )
                        "
                      >
                      </el-checkbox
                      >附件：
                    </div>
                    <div class="files">
                      <div
                        class="file"
                        v-for="(item, fileIndex) in item[
                          '附件'
                        ].dataValue.split(',')"
                        :key="fileIndex"
                      >
                        <div style="line-height: 30px;">
                          <div class="fileName" @click="handlePreviewImg(item)">
                            {{ item.split(":")[2] }}
                          </div>
                          <div class="updateDate">
                            {{
                              list["非学历教育"][index]["附件"].createDate
                                | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                            }}
                          </div>
                        </div>
                        <!-- <div class="operation" :name="item['附件'].dataValue">
                        <span
                          @click="handleCorrigendum(item['附件'].dataId)"
                          v-if="
                            !item['附件'].deleteTag &&
                              item['附件'].dataSourceType !== 'CONSUMER'
                          "
                          >勘误</span
                        >
                        <span @click="handleRecords(item['附件'].dataId)"
                          >数据记录</span
                        >
                      </div> -->
                      </div>
                    </div>
                  </div>

                  <div class="eduItemDetail">
                    <div class="value">
                      <div>
                        <el-checkbox
                          v-if="
                            isSelect &&
                              checkList['非学历教育'].value[index][
                                '事件/活动记录'
                              ]
                          "
                          v-model="
                            checkList['非学历教育'].value[index][
                              '事件/活动记录'
                            ].checkAll
                          "
                          :indeterminate="
                            checkList['非学历教育'].value[index][
                              '事件/活动记录'
                            ].indeterminate
                          "
                          @change="
                            handleCheckAll(
                              $event,
                              '非学历教育',
                              '事件/活动记录',
                              index
                            )
                          "
                        ></el-checkbox
                        >事件/活动记录：
                      </div>
                      <div class="timeLine">
                        <el-timeline>
                          <el-timeline-item
                            v-if="isSelect ? !eItem['时间'].deleteTag : true"
                            v-for="(eItem, eventIndex) in list['非学历教育'][
                              index
                            ]['事件/活动记录']"
                            :key="eventIndex"
                            :hide-timestamp="true"
                          >
                            <div style="line-height: 26px;">
                              <div style="display:flex">
                                <el-checkbox
                                  v-if="isSelect"
                                  v-model="
                                    checkList['非学历教育'].value[index][
                                      '事件/活动记录'
                                    ].value[eventIndex][
                                      Object.keys(eItem)
                                        .filter(e => e !== '上级Id')
                                        .map(r => eItem[r].dataId.toString())
                                    ]
                                  "
                                  @change="
                                    handleCheckedChange(
                                      $event,
                                      '非学历教育',
                                      '事件/活动记录',
                                      index
                                    )
                                  "
                                >
                                </el-checkbox>
                                <div class="eventItem">
                                  <div class="eventDate">
                                    <div>
                                      <!-- :class="item['时间'].deleteTag?'deleteLine':''" -->
                                      <div style="display:flex">
                                        <div
                                          :class="
                                            `${eItem['时间'].deleteTag &&
                                              'deleteLine'}`
                                          "
                                        >
                                          {{
                                            eItem["时间"].dataValue.split(",")
                                              .length > 1
                                              ? eItem["时间"].dataValue.split(
                                                  ","
                                                )[0] +
                                                "~" +
                                                eItem["时间"].dataValue.split(
                                                  ","
                                                )[1]
                                              : eItem["时间"].dataValue
                                          }}
                                        </div>
                                        <span
                                          v-if="eItem['时间'].deleteTag"
                                          style="color:#FF4C4C;margin-left:15px"
                                          >已删除</span
                                        >
                                      </div>
                                      <div class="eventUpdateDate">
                                        数据更新于{{
                                          eItem["时间"].lastUpdateDate
                                            | parseTime(
                                              "{y}-{m}-{d} {h}:{i}:{s}"
                                            )
                                        }}
                                      </div>
                                    </div>
                                    <div class="operations" v-if="!isSelect">
                                      <span
                                        v-if="
                                          eItem['时间'].dataSourceType ===
                                            'CONSUMER' &&
                                            !eItem['时间'].deleteTag
                                        "
                                        @click="
                                          handleEditNoEduEvent(
                                            eItem,
                                            eItem['上级Id'],
                                            index
                                          )
                                        "
                                        ><i class="icon_edit" />修改</span
                                      >
                                      <span
                                        v-if="
                                          eItem['时间'].dataSourceType ===
                                            'CONSUMER' &&
                                            !eItem['时间'].deleteTag
                                        "
                                        @click="
                                          handleDeleteAll(
                                            eItem['上级Id'],
                                            '事件/活动记录'
                                          )
                                        "
                                        ><i class="icon_delete" />删除</span
                                      >
                                      <span
                                        @click="
                                          handleCorrigendum(
                                            eItem['时间'].dataId
                                          )
                                        "
                                        v-if="
                                          !eItem['时间'].deleteTag &&
                                            eItem['时间'].dataSourceType !==
                                              'CONSUMER'
                                        "
                                      >
                                        <i class="icon_corrigendum" />勘误
                                      </span>
                                      <span
                                        @click="
                                          handleRecords(eItem['时间'].dataId)
                                        "
                                        ><i
                                          class="icon_dataSource"
                                        />数据记录</span
                                      >
                                    </div>
                                  </div>
                                  <div
                                    class="eventContent"
                                    v-if="eItem['内容']"
                                  >
                                    <div>
                                      <div style="display:flex">
                                        <div
                                          :class="
                                            `eContent ${eItem['内容']
                                              .deleteTag && 'deleteLine'}`
                                          "
                                        >
                                          {{ eItem["内容"].dataValue }}
                                        </div>
                                        <span
                                          v-if="eItem['内容'].deleteTag"
                                          style="color:#FF4C4C;margin-left:15px"
                                          >已删除</span
                                        >
                                      </div>
                                      <div class="eventUpdateDate">
                                        数据更新于{{
                                          eItem["内容"].lastUpdateDate
                                            | parseTime(
                                              "{y}-{m}-{d} {h}:{i}:{s}"
                                            )
                                        }}
                                      </div>
                                    </div>
                                    <div class="operations" v-if="!isSelect">
                                      <span
                                        @click="
                                          handleCorrigendum(
                                            eItem['内容'].dataId
                                          )
                                        "
                                        v-if="
                                          !eItem['内容'].deleteTag &&
                                            eItem['内容'].dataSourceType !==
                                              'CONSUMER'
                                        "
                                      >
                                        勘误
                                      </span>
                                      <span
                                        @click="
                                          handleRecords(eItem['内容'].dataId)
                                        "
                                        >数据记录</span
                                      >
                                    </div>
                                  </div>
                                  <div v-if="eItem['附件']">附件：</div>
                                  <div class="eventFile" v-if="eItem['附件']">
                                    <div class="eventFileLayout">
                                      <div></div>
                                      <div class="eventFileList">
                                        <div
                                          @click="handlePreviewImg(file)"
                                          class="eventFileItem"
                                          v-for="(file, fileIndex) in eItem[
                                            '附件'
                                          ].dataValue.split(',')"
                                          :key="fileIndex"
                                        >
                                          {{ file.split(":")[2] }}
                                        </div>
                                      </div>
                                      <div class="operations" v-if="!isSelect">
                                        <span
                                          @click="
                                            handleCorrigendum(
                                              eItem['附件'].dataId
                                            )
                                          "
                                          v-if="
                                            !eItem['附件'].deleteTag &&
                                              eItem['附件'].dataSourceType !==
                                                'CONSUMER'
                                          "
                                        >
                                          勘误
                                        </span>
                                        <span
                                          @click="
                                            handleRecords(eItem['附件'].dataId)
                                          "
                                          >数据记录</span
                                        >
                                      </div>
                                    </div>
                                    <div class="eventUpdateDate">
                                      数据更新于{{
                                        eItem["附件"].lastUpdateDate
                                          | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                                      }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </el-timeline-item>
                          <el-timeline-item
                            v-if="noEduEventForm && noEduIndex === index"
                            id="noEduEventForm"
                          >
                            <el-form
                              :model="noEduEventForm"
                              v-if="noEduEventForm"
                              label-position="left"
                              label-width="85px"
                            >
                              <el-form-item label="开始时间">
                                <el-date-picker
                                  :editable="false"
                                  v-model="noEduEventForm['时间'].startDate"
                                  value-format="yyyy-MM-dd"
                                  style="width: 289px;"
                                  placeholder="请选择时间"
                                ></el-date-picker>
                              </el-form-item>
                              <el-form-item label="结束时间">
                                <el-radio-group
                                  v-model="noEduEventForm.eventRadio"
                                  @change="
                                    eventEndDateTypeChange(
                                      $event,
                                      noEduEventForm
                                    )
                                  "
                                >
                                  <el-radio :label="0">当天</el-radio>
                                  <el-radio :label="1">至今</el-radio>
                                  <el-radio :label="2">时间选择</el-radio>
                                </el-radio-group>
                                <br />
                                <el-date-picker
                                  v-if="noEduEventForm.eventRadio === 2"
                                  :editable="false"
                                  value-format="yyyy-MM-dd"
                                  v-model="noEduEventForm['时间'].endDate"
                                  style="width: 286px;"
                                  placeholder="请选择结束时间"
                                ></el-date-picker>
                              </el-form-item>
                              <el-form-item label="事件描述：">
                                <el-input
                                  type="textarea"
                                  v-model="noEduEventForm['内容'].dataValue"
                                  placeholder="请输入事件描述"
                                ></el-input>
                              </el-form-item>
                              <el-form-item label="附件：">
                                <div class="fileList">
                                  <div
                                    class="fileItem"
                                    v-for="(item, index) in fileList"
                                    :key="item.uid"
                                  >
                                    {{ item.name
                                    }}<i
                                      @click="handleRemoveFile(index)"
                                      class="icon_fileRemove"
                                    ></i>
                                  </div>
                                </div>
                                <el-upload
                                  ref="upload"
                                  class="upload"
                                  action=""
                                  :auto-upload="false"
                                  multiple
                                  :show-file-list="false"
                                  :on-change="
                                    event =>
                                      handleEventUploadChange(
                                        event,
                                        index,
                                        eventIndex
                                      )
                                  "
                                >
                                  <span
                                    style="color:#3A61B1;text-decoration: underline;"
                                    >+选择附件</span
                                  >
                                  <div slot="tip" class="el-upload__tip">
                                    <TipText
                                      text="您可以添加多个图片附件作为信息证明文件上传"
                                    />
                                  </div>
                                </el-upload>
                              </el-form-item>
                              <el-form-item>
                                <Btn
                                  btnText="提交"
                                  :width="69"
                                  :height="30"
                                  :radius="15"
                                  @handleClick="handleSubmitNoEduEventForm"
                                />
                                <Btn
                                  btnText="取消"
                                  className="primary_plain"
                                  :width="69"
                                  :height="30"
                                  :radius="15"
                                  style="margin-left:13px"
                                  @handleClick="handleCloseEventForm"
                                />
                              </el-form-item>
                            </el-form>
                          </el-timeline-item>
                        </el-timeline>
                      </div>

                      <span
                        v-if="
                          item['教育机构'].modifiable &&
                            !noEduEventForm &&
                            !isSelect
                        "
                        class="btn_addEvent"
                        @click="handleAddNoEduEvent(index)"
                        >+事件/活动记录</span
                      >
                      <TipText
                        text="您可以添加在读期间事件/活动记录。如“2022年 参与全国大学生数学建模竞赛获得一等奖”"
                      />
                    </div>
                  </div>
                </div>
                <div class="panel_toggle" v-if="!item['时间'].deleteTag">
                  <Toggle
                    :flag="noEduToggles[index]"
                    @handleClick="handleNoEduItemToggle(index)"
                  />
                </div>
              </div>
            </div>
            <div id="noEduForm" class="eduForm" v-if="isAddNoEdu">
              <el-form
                :modal="noEduForm"
                label-width="120px"
                label-position="left"
              >
                <el-form-item label="教育机构：">
                  <el-autocomplete
                    clearable
                    style="width:100%"
                    v-model="noEduForm['教育机构']"
                    :fetch-suggestions="queryNoEduSearch"
                    :trigger-on-focus="false"
                    placeholder="请输入教育机构名称"
                    @select="val => handleSelectAuto(val, '非学历教育')"
                  >
                    <template slot-scope="scope">
                      <div class="autoName">
                        <span>{{ scope.item.name }}</span>
                        <i
                          v-if="scope.item.authentication"
                          class="icon_renzheng"
                        ></i>
                      </div>
                    </template>
                  </el-autocomplete>
                </el-form-item>
                <el-form-item label="机构描述：">
                  <el-input
                    v-model="noEduForm['机构描述']"
                    type="textarea"
                    :autosize="{ minRows: 5, maxRows: 5 }"
                    placeholder="请简单描述机构信息。如“该机构是一家专业的财经职业培训机构,以财会类考试培训为核心业务,包括职业资格考试和注册会计师考试”"
                  ></el-input>
                </el-form-item>
                <el-form-item label="开始时间：">
                  <!-- <el-date-picker
                    :editable="false"
                    v-model="noEduForm['时间']"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width:100%"
                  >
                  </el-date-picker> -->
                  <el-date-picker
                    :editable="false"
                    v-model="noEduForm['时间'][0]"
                    value-format="yyyy-MM-dd"
                    style="width: 286px;"
                    placeholder="请选择开始时间"
                  ></el-date-picker>
                  <!-- <span style="margin-left:10px;margin-right:10px">至</span> -->
                  <!-- <el-date-picker
                    :editable="false"
                    value-format="yyyy-MM-dd"
                    v-model="noEduForm['时间'][1]"
                    style="width: 286px;"
                    placeholder="请选择结束时间"
                  ></el-date-picker> -->
                </el-form-item>
                <el-form-item label="结束时间">
                  <el-radio-group
                    v-model="noEduForm.endDateType"
                    @change="endDateTypeChange($event, noEduForm)"
                  >
                    <el-radio :label="0">当天</el-radio>
                    <el-radio :label="1">至今</el-radio>
                    <el-radio :label="2">时间选择</el-radio>
                  </el-radio-group>
                  <br />
                  <el-date-picker
                    v-if="noEduForm.endDateType === 2"
                    :editable="false"
                    value-format="yyyy-MM-dd"
                    v-model="noEduForm['时间'][1]"
                    style="width: 286px;"
                    placeholder="请选择结束时间"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="教育产品：">
                  <el-input
                    v-model="noEduForm['教育产品']"
                    placeholder="请输入接受的教育产品名称。如“初级会计职称、教师资格证培训”"
                  ></el-input>
                </el-form-item>
                <el-form-item label="产品描述：">
                  <el-input
                    v-model="noEduForm['产品描述']"
                    type="textarea"
                    :autosize="{ minRows: 5, maxRows: 5 }"
                    placeholder="请简单描述产品信息。如“初级会计职称考试培训，设经济法基础、初级会计实务两个科目…”"
                  ></el-input>
                </el-form-item>
                <el-form-item label="班期：">
                  <el-input
                    v-model="noEduForm['班期']"
                    placeholder="请输入班期信息。如“初级会计职称培训班、2022年教资春季班”"
                  ></el-input>
                </el-form-item>
                <el-form-item label="教育结果：">
                  <el-input
                    v-model="noEduForm['教育结果']"
                    placeholder="请输入教育结果。如“结业、取得教师资格证”"
                  ></el-input>
                  <!-- <el-select v-model="noEduForm['教育结果']" style="width:100%">
                    <el-option label="在读" value="在读"></el-option>
                    <el-option label="结业" value="结业"></el-option>
                    <el-option label="毕业" value="毕业"></el-option>
                    <el-option label="肄业" value="肄业"></el-option>
                  </el-select> -->
                </el-form-item>
                <el-form-item label="添加附件：">
                  <div class="fileList">
                    <div
                      class="fileItem"
                      v-for="(item, index) in fileList"
                      :key="item.uid"
                    >
                      {{ item.name
                      }}<i
                        @click="handleRemoveFile(index)"
                        class="icon_fileRemove"
                      ></i>
                    </div>
                  </div>
                  <el-upload
                    ref="upload"
                    class="upload"
                    action=""
                    :auto-upload="false"
                    multiple
                    :show-file-list="false"
                    :on-change="handleUploadChange"
                  >
                    <span style="color:#3A61B1;text-decoration: underline;"
                      >+选择附件</span
                    >
                    <div slot="tip" class="el-upload__tip">
                      <TipText
                        text="您可以添加多个图片附件作为信息证明文件上传"
                      />
                    </div>
                  </el-upload>
                </el-form-item>

                <el-form-item>
                  <Btn
                    btnText="提交"
                    className="primary"
                    :height="30"
                    :width="69"
                    style="margin-right:13px"
                    @handleClick="handleSubmitNoEduForm"
                  />
                  <Btn
                    btnText="取消"
                    className="primary_plain"
                    :height="30"
                    :width="69"
                    @handleClick="handleCloseAddNoEdu"
                  />
                </el-form-item>
                <el-form-item>
                  <TipText
                    text="教育经历信息提交成功后，可添加事件/活动记录信息。"
                  />
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <!-- <template id="postInfo"></template> -->
        <div id="postInfo" class="piItem">
          <div class="piTitle">
            <div class="titleName">
              <el-checkbox
                v-if="isSelect"
                v-model="checkList['职业经历'].checkAll"
                :indeterminate="checkList['职业经历'].indeterminate"
                @change="handleCheckAll($event, '职业经历')"
              ></el-checkbox
              >职业经历<Btn
                v-if="!isSelect"
                btnText="职业经历"
                :width="116"
                className="default"
                :height="39"
                style="margin-left:14px"
                :plus="true"
                @handleClick="handleAddProExpForm('add')"
              />
            </div>

            <Toggle
              :flag="toggle['职业经历']"
              @handleClick="toggle['职业经历'] = !toggle['职业经历']"
            />
          </div>
          <div
            class="eduList"
            v-if="toggle['职业经历'] && (list['职业经历'] || isAddProExp)"
          >
            <div
              :class="`eduItem ${item['时间'].deleteTag ? 'deleteTag' : ''}`"
              v-for="(item, index) in list['职业经历']"
              v-if="isSelect ? !item['时间'].deleteTag : true"
              :key="index"
            >
              <div class="eduItemPanel">
                <div class="panel_top">
                  <div class="panel_top_left">
                    <div class="panel_top_left_top">
                      <el-checkbox
                        v-if="isSelect"
                        v-model="checkList['职业经历'].value[index].checkAll"
                        :indeterminate="
                          checkList['职业经历'].value[index].indeterminate
                        "
                        @change="
                          handleCheckAll($event, '职业经历', undefined, index)
                        "
                      ></el-checkbox>
                      <span class="date">{{
                        `${item["时间"].dataValue.split(",")[0]}~${
                          item["时间"].dataValue.split(",")[1]
                        }`
                      }}</span>
                      <span
                        v-if="item['时间'].deleteTag"
                        style="color: rgb(255, 76, 76); margin-left: 20px;"
                        >已删除</span
                      >
                    </div>
                    <div class="panel_top_left_bottom">
                      <!-- {{ item["时间"].createDate | parseTime("{y}-{m}-{d}") }}
                      {{
                        `由 ${item["时间"].dataSourceName}${
                          item["时间"].deleteTag
                            ? "删除"
                            : item["时间"].dataSourceType === "CONSUMER"
                            ? "自填"
                            : "添加"
                        }`
                      }} -->
                    </div>
                  </div>
                  <div class="panel_top_right">
                    {{ item["单位名称"].dataValue }}
                    <RedDot v-if="redDotMakStr.indexOf(item['上级Id']) > -1" />
                    <span
                      class="jigourenzheng"
                      v-if="
                        !isSelect
                          ? superiorIdAttachInfoResponseVoMap[item['上级Id']]
                            ? superiorIdAttachInfoResponseVoMap[item['上级Id']]
                                .businessNameAuthenticationTag
                              ? false
                              : superiorIdAttachInfoResponseVoMap[
                                  item['上级Id']
                                ].businessNameAuthenticationApply
                              ? false
                              : true
                            : true
                          : false
                      "
                      @click="
                        handleAgencyApply(
                          item['单位名称'].dataValue,
                          item['上级Id']
                        )
                      "
                      >机构认证>></span
                    >
                    <span
                      v-if="
                        superiorIdAttachInfoResponseVoMap[item['上级Id']] &&
                          superiorIdAttachInfoResponseVoMap[item['上级Id']]
                            .businessNameAuthenticationTag
                      "
                      ><i class="icon_renzheng" />已认证</span
                    >
                  </div>
                </div>
                <div class="panel_bottom">
                  <div class="panel_bottom_left">
                    <!-- <div class="renzhengBox">
                      <i class="icon_yirenzheng" />
                      <span class="renzhengText">
                        有<span class="renzhengNum">2568</span>人认证
                        |&nbsp;</span
                      ><span class="inviteText"> 邀请认证>></span>
                    </div> -->
                    {{ item["时间"].createDate | parseTime("{y}-{m}-{d}") }}
                    {{
                      `由 ${item["时间"].dataSourceName}${
                        item["时间"].deleteTag
                          ? "删除"
                          : item["时间"].dataSourceType === "CONSUMER"
                          ? "自填"
                          : "添加"
                      }`
                    }}
                  </div>
                  <div class="panel_bottom_right">
                    <span
                      v-if="item['单位名称'].modifiable"
                      @click="handleAddProExpForm('edit', '职业经历', index)"
                      ><i class="icon_edit" />修改</span
                    >
                    <span
                      v-if="
                        item['单位名称'].dataSourceType !== 'CONSUMER' &&
                          !item['单位名称'].deleteTag
                      "
                      @click="handleCorrigendum(item['单位名称'].dataId)"
                      ><i class="icon_corrigendum" />勘误</span
                    >
                    <span
                      v-if="item['单位名称'].modifiable"
                      @click="handleDeleteAll(item['上级Id'], '学历教育')"
                      ><i class="icon_delete" />删除</span
                    >
                    <span @click="handleRecords(item['单位名称'].dataId)"
                      ><i class="icon_dataSource" />数据记录</span
                    >
                  </div>
                </div>
                <div class="eduItemDetails" v-if="proExpToggles[index]">
                  <div class="eduItemDetail" v-if="item['单位名称']">
                    <div class="value">
                      <el-checkbox
                        v-if="isSelect"
                        v-model="
                          checkList['职业经历'].value[index]['单位名称'][
                            item['单位名称'].dataId
                          ]
                        "
                        @change="
                          handleCheckedChange(
                            $event,
                            '职业经历',
                            '单位名称',
                            index
                          )
                        "
                      >
                      </el-checkbox
                      >单位名称:{{ item["单位名称"].dataValue }}
                    </div>
                    <div class="valueInfo">
                      <div class="updateDate">
                        数据更新于{{
                          item["单位名称"].createDate
                            | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                        }}
                      </div>
                      <div class="operation">
                        <span
                          @click="handleCorrigendum(item['单位名称'].dataId)"
                          v-if="
                            !item['单位名称'].deleteTag &&
                              item['单位名称'].dataSourceType !== 'CONSUMER'
                          "
                          ><i class="icon_corrigendum" />勘误</span
                        >
                        <span @click="handleRecords(item['单位名称'].dataId)"
                          ><i class="icon_dataSource" />数据记录</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="eduItemDetail" v-if="item['单位介绍']">
                    <div class="value">
                      <div>
                        <el-checkbox
                          v-if="isSelect"
                          v-model="
                            checkList['职业经历'].value[index]['单位介绍'][
                              item['单位介绍'].dataId
                            ]
                          "
                          @change="
                            handleCheckedChange(
                              $event,
                              '职业经历',
                              '机构描述',
                              index
                            )
                          "
                        >
                        </el-checkbox
                        >单位介绍：
                      </div>
                      <div class="textareaText">
                        {{ item["单位介绍"].dataValue }}
                      </div>
                    </div>
                    <div class="valueInfo">
                      <div class="updateDate">
                        数据更新于{{
                          item["单位介绍"].createDate
                            | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                        }}
                      </div>
                      <div class="operation">
                        <span
                          @click="handleCorrigendum(item['单位介绍'].dataId)"
                          v-if="
                            !item['单位介绍'].deleteTag &&
                              item['单位介绍'].dataSourceType !== 'CONSUMER'
                          "
                          ><i class="icon_corrigendum" />勘误</span
                        >
                        <span @click="handleRecords(item['单位介绍'].dataId)"
                          ><i class="icon_dataSource" />数据记录</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="eduItemDetail">
                    <div class="value">
                      <el-checkbox
                        v-if="isSelect"
                        v-model="
                          checkList['职业经历'].value[index]['时间'][
                            item['时间'].dataId
                          ]
                        "
                        @change="
                          handleCheckedChange($event, '职业经历', '时间', index)
                        "
                      >
                      </el-checkbox
                      >时间段：{{
                        item["时间"].dataValue.split(",").length > 1
                          ? `${item["时间"].dataValue.split(",")[0]}~${
                              item["时间"].dataValue.split(",")[1]
                            }`
                          : `${item["时间"].dataValue.split(",")[0]}至今`
                      }}
                    </div>
                    <div class="valueInfo">
                      <div class="updateDate">
                        数据更新于{{
                          item["时间"].createDate
                            | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                        }}
                      </div>
                      <div class="operation">
                        <span
                          @click="handleCorrigendum(item['时间'].dataId)"
                          v-if="
                            !item['时间'].deleteTag &&
                              item['时间'].dataSourceType !== 'CONSUMER'
                          "
                          ><i class="icon_corrigendum" />勘误</span
                        >
                        <span @click="handleRecords(item['时间'].dataId)"
                          ><i class="icon_dataSource" />数据记录</span
                        >
                      </div>
                    </div>
                  </div>

                  <div class="eduItemDetail" v-if="item['附件']">
                    <div class="value">
                      <el-checkbox
                        v-if="isSelect"
                        v-model="
                          checkList['职业经历'].value[index]['附件'][
                            item['附件'].dataId
                          ]
                        "
                        @change="
                          handleCheckedChange($event, '职业经历', '附件', index)
                        "
                      >
                      </el-checkbox
                      >附件：
                    </div>
                    <div class="files">
                      <div
                        class="file"
                        v-for="(fItem, fileIndex) in item[
                          '附件'
                        ].dataValue.split(',')"
                        :key="fileIndex"
                      >
                        <div style="line-height: 30px;">
                          <div
                            class="fileName"
                            @click="handlePreviewImg(fItem)"
                          >
                            {{ fItem.split(":")[2] }}
                          </div>
                          <div class="updateDate">
                            {{
                              item["附件"].createDate
                                | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                            }}
                          </div>
                        </div>
                        <div class="operation">
                          <span
                            @click="handleCorrigendum(item['附件'].dataId)"
                            v-if="
                              !item['附件'].deleteTag &&
                                item['附件'].dataSourceType !== 'CONSUMER'
                            "
                            ><i class="icon_corrigendum" />勘误</span
                          >
                          <span @click="handleRecords(item['附件'].dataId)"
                            ><i class="icon_dataSource" />数据记录</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="eduItemDetail"
                    v-if="
                      item['岗位记录'] ||
                        item['时间'].dataSourceType === 'CONSUMER'
                    "
                  >
                    <div class="value">
                      <div
                        v-if="
                          (!isSelect && item['岗位记录']) ||
                            item['时间'].dataSourceType === 'CONSUMER'
                        "
                      >
                        <el-checkbox
                          v-if="
                            isSelect &&
                              checkList['职业经历'].value[index]['岗位记录']
                          "
                          v-model="
                            checkList['职业经历'].value[index]['岗位记录']
                              .checkAll
                          "
                          :indeterminate="
                            checkList['职业经历'].value[index]['岗位记录']
                              .indeterminate
                          "
                          @change="
                            handleCheckAll(
                              $event,
                              '职业经历',
                              '岗位记录',
                              index
                            )
                          "
                        ></el-checkbox
                        >岗位记录：
                      </div>
                      <div class="timeLine">
                        <el-timeline>
                          <!-- v-if="!eItem['时间'].deleteTag" -->
                          <!-- v-if="isSelect&&!eItem['时间'].deleteTag" -->
                          <el-timeline-item
                            v-if="isSelect ? !eItem['时间'].deleteTag : true"
                            v-for="(eItem, eventIndex) in item['岗位记录']"
                            :key="eventIndex"
                            :hide-timestamp="true"
                          >
                            <div style="line-height: 26px;">
                              <div style="display:flex">
                                <el-checkbox
                                  v-if="isSelect"
                                  v-model="
                                    checkList['职业经历'].value[index][
                                      '岗位记录'
                                    ].value[eventIndex][
                                      Object.keys(eItem)
                                        .filter(e => e !== '上级Id')
                                        .map(r => eItem[r].dataId.toString())
                                    ]
                                  "
                                  @change="
                                    handleCheckedChange(
                                      $event,
                                      '职业经历',
                                      '岗位记录',
                                      index
                                    )
                                  "
                                >
                                </el-checkbox>
                                <div class="eventItem">
                                  <div class="eventDate">
                                    <div>
                                      <!-- :class="item['时间'].deleteTag?'deleteLine':''" -->
                                      <div style="display:flex">
                                        <div
                                          :class="
                                            `${eItem['时间'].deleteTag &&
                                              'deleteLine'}`
                                          "
                                        >
                                          {{
                                            eItem["时间"].dataValue.split(",")
                                              .length > 1
                                              ? eItem["时间"].dataValue.split(
                                                  ","
                                                )[0] +
                                                "~" +
                                                eItem["时间"].dataValue.split(
                                                  ","
                                                )[1]
                                              : eItem["时间"].dataValue + "至今"
                                          }}
                                        </div>
                                        <span
                                          v-if="eItem['时间'].deleteTag"
                                          style="color:#FF4C4C;margin-left:15px"
                                          >已删除</span
                                        >
                                      </div>
                                      <div class="eventUpdateDate">
                                        数据更新于{{
                                          eItem["时间"].lastUpdateDate
                                            | parseTime(
                                              "{y}-{m}-{d} {h}:{i}:{s}"
                                            )
                                        }}
                                      </div>
                                    </div>
                                    <!-- <div class="operations" v-if="!isSelect">
                                    <span
                                      v-if="
                                        eItem['时间'].dataSourceType ===
                                          'CONSUMER' && !eItem['时间'].deleteTag
                                      "
                                      @click="
                                        handleEditProExpPost(
                                          eItem,
                                          eItem['上级Id'],
                                          index
                                        )
                                      "
                                      >修改</span
                                    >
                                    <span
                                      v-if="
                                        eItem['时间'].dataSourceType ===
                                          'CONSUMER' && !eItem['时间'].deleteTag
                                      "
                                      @click="
                                        handleDeleteAll(
                                          eItem['上级Id'],
                                          '岗位记录'
                                        )
                                      "
                                      >删除</span
                                    >
                                    <span
                                      @click="
                                        handleCorrigendum(eItem['时间'].dataId)
                                      "
                                      v-if="
                                        !eItem['时间'].deleteTag &&
                                          eItem['时间'].dataSourceType !==
                                            'CONSUMER'
                                      "
                                      >勘误</span
                                    >
                                    <span
                                      @click="
                                        handleRecords(eItem['时间'].dataId)
                                      "
                                      >数据记录</span
                                    >
                                  </div> -->
                                    <div>
                                      <div
                                        style="display: flex;justify-content: flex-end;align-items: center;"
                                      >
                                        <div>
                                          {{ eItem["岗位名称"].dataValue }}
                                        </div>
                                        <Toggle
                                          v-if="!item['单位名称'].deleteTag"
                                          :flag="
                                            proExpPostToggles[index][eventIndex]
                                          "
                                          @handleClick="
                                            handleProExpPostToggle(
                                              index,
                                              eventIndex
                                            )
                                          "
                                        />
                                      </div>

                                      <div class="operations" v-if="!isSelect">
                                        <span
                                          v-if="
                                            eItem['时间'].dataSourceType ===
                                              'CONSUMER' &&
                                              !eItem['时间'].deleteTag
                                          "
                                          @click="
                                            handleEditProExpPost(
                                              eItem,
                                              eItem['上级Id'],
                                              index
                                            )
                                          "
                                          ><i class="icon_edit" />修改</span
                                        >
                                        <span
                                          v-if="
                                            eItem['时间'].dataSourceType ===
                                              'CONSUMER' &&
                                              !eItem['时间'].deleteTag
                                          "
                                          @click="
                                            handleDeleteAll(
                                              eItem['上级Id'],
                                              '岗位记录'
                                            )
                                          "
                                          ><i class="icon_delete" />删除</span
                                        >
                                        <span
                                          @click="
                                            handleCorrigendum(
                                              eItem['时间'].dataId
                                            )
                                          "
                                          v-if="
                                            !eItem['时间'].deleteTag &&
                                              eItem['时间'].dataSourceType !==
                                                'CONSUMER'
                                          "
                                          ><i
                                            class="icon_corrigendum"
                                          />勘误</span
                                        >
                                        <span
                                          @click="
                                            handleRecords(eItem['时间'].dataId)
                                          "
                                          ><i
                                            class="icon_dataSource"
                                          />数据记录</span
                                        >
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    v-if="proExpPostToggles[index][eventIndex]"
                                    class="details"
                                  >
                                    <!-- ### -->
                                    <div
                                      class="eventContent"
                                      v-if="eItem['时间']"
                                    >
                                      <div>
                                        <div style="display:flex">
                                          <div
                                            :class="
                                              `${eItem['时间'].deleteTag &&
                                                'deleteLine'}`
                                            "
                                          >
                                            时间段：{{
                                              eItem["时间"].dataValue.split(",")
                                                .length > 1
                                                ? eItem["时间"].dataValue.split(
                                                    ","
                                                  )[0] +
                                                  "~" +
                                                  eItem["时间"].dataValue.split(
                                                    ","
                                                  )[1]
                                                : eItem["时间"].dataValue
                                            }}
                                          </div>
                                          <span
                                            v-if="eItem['时间'].deleteTag"
                                            style="color:#FF4C4C;margin-left:15px"
                                            >已删除</span
                                          >
                                        </div>
                                        <div class="eventUpdateDate">
                                          数据更新于{{
                                            eItem["时间"].lastUpdateDate
                                              | parseTime(
                                                "{y}-{m}-{d} {h}:{i}:{s}"
                                              )
                                          }}
                                        </div>
                                      </div>
                                      <div class="operations" v-if="!isSelect">
                                        <span
                                          @click="
                                            handleCorrigendum(
                                              eItem['时间'].dataId
                                            )
                                          "
                                          v-if="
                                            !eItem['时间'].deleteTag &&
                                              eItem['时间'].dataSourceType !==
                                                'CONSUMER'
                                          "
                                          ><i
                                            class="icon_corrigendum"
                                          />勘误</span
                                        >
                                        <span
                                          @click="
                                            handleRecords(eItem['时间'].dataId)
                                          "
                                          ><i
                                            class="icon_dataSource"
                                          />数据记录</span
                                        >
                                      </div>
                                    </div>
                                    <!-- ###### -->
                                    <div
                                      class="eventContent"
                                      v-if="eItem['岗位名称']"
                                    >
                                      <div>
                                        <div style="display:flex">
                                          <div
                                            :class="
                                              `eContent ${eItem['岗位名称']
                                                .deleteTag && 'deleteLine'}`
                                            "
                                          >
                                            岗位名称：{{
                                              eItem["岗位名称"].dataValue
                                            }}
                                          </div>
                                          <span
                                            v-if="eItem['岗位名称'].deleteTag"
                                            style="color:#FF4C4C;margin-left:15px"
                                            >已删除</span
                                          >
                                        </div>
                                        <div class="eventUpdateDate">
                                          数据更新于{{
                                            eItem["岗位名称"].lastUpdateDate
                                              | parseTime(
                                                "{y}-{m}-{d} {h}:{i}:{s}"
                                              )
                                          }}
                                        </div>
                                      </div>
                                      <div class="operations" v-if="!isSelect">
                                        <span
                                          @click="
                                            handleCorrigendum(
                                              eItem['岗位名称'].dataId
                                            )
                                          "
                                          v-if="
                                            !eItem['岗位名称'].deleteTag &&
                                              eItem['岗位名称']
                                                .dataSourceType !== 'CONSUMER'
                                          "
                                          ><i
                                            class="icon_corrigendum"
                                          />勘误</span
                                        >
                                        <span
                                          @click="
                                            handleRecords(
                                              eItem['岗位名称'].dataId
                                            )
                                          "
                                          ><i
                                            class="icon_dataSource"
                                          />数据记录</span
                                        >
                                      </div>
                                    </div>

                                    <div
                                      class="eventContent"
                                      v-if="eItem['内容']"
                                    >
                                      <div>
                                        <div style="display:flex">
                                          <div
                                            :class="
                                              `eContent ${eItem['内容']
                                                .deleteTag && 'deleteLine'}`
                                            "
                                          >
                                            岗位描述：{{
                                              eItem["内容"].dataValue
                                            }}
                                          </div>
                                          <span
                                            v-if="eItem['内容'].deleteTag"
                                            style="color:#FF4C4C;margin-left:15px"
                                            >已删除</span
                                          >
                                        </div>
                                        <div class="eventUpdateDate">
                                          数据更新于{{
                                            eItem["内容"].lastUpdateDate
                                              | parseTime(
                                                "{y}-{m}-{d} {h}:{i}:{s}"
                                              )
                                          }}
                                        </div>
                                      </div>
                                      <div class="operations" v-if="!isSelect">
                                        <span
                                          @click="
                                            handleCorrigendum(
                                              eItem['内容'].dataId
                                            )
                                          "
                                          v-if="
                                            !eItem['内容'].deleteTag &&
                                              eItem['内容'].dataSourceType !==
                                                'CONSUMER'
                                          "
                                          ><i
                                            class="icon_corrigendum"
                                          />勘误</span
                                        >
                                        <span
                                          @click="
                                            handleRecords(eItem['内容'].dataId)
                                          "
                                          ><i
                                            class="icon_dataSource"
                                          />数据记录</span
                                        >
                                      </div>
                                    </div>
                                    <div v-if="eItem['附件']">附件：</div>
                                    <div class="eventFile" v-if="eItem['附件']">
                                      <div class="eventFileLayout">
                                        <div></div>
                                        <div class="eventFileList">
                                          <div
                                            @click="handlePreviewImg(file)"
                                            class="eventFileItem"
                                            v-for="(file, fileIndex) in eItem[
                                              '附件'
                                            ].dataValue.split(',')"
                                            :key="fileIndex"
                                          >
                                            {{ file.split(":")[2] }}
                                          </div>
                                        </div>
                                        <div
                                          class="operations"
                                          v-if="!isSelect"
                                        >
                                          <span
                                            @click="
                                              handleCorrigendum(
                                                eItem['附件'].dataId
                                              )
                                            "
                                            v-if="
                                              !eItem['附件'].deleteTag &&
                                                eItem['附件'].dataSourceType !==
                                                  'CONSUMER'
                                            "
                                            ><i
                                              class="icon_corrigendum"
                                            />勘误</span
                                          >
                                          <span
                                            @click="
                                              handleRecords(
                                                eItem['附件'].dataId
                                              )
                                            "
                                            ><i
                                              class="icon_dataSource"
                                            />数据记录</span
                                          >
                                        </div>
                                      </div>
                                      <div class="eventUpdateDate">
                                        数据更新于{{
                                          eItem["附件"].lastUpdateDate
                                            | parseTime(
                                              "{y}-{m}-{d} {h}:{i}:{s}"
                                            )
                                        }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </el-timeline-item>
                          <el-timeline-item
                            v-if="proExpPostForm && proExpIndex === index"
                            id="proExpPostForm"
                          >
                            <!-- <div style="margin-bottom:23px">
                            <el-radio
                              v-model="proExpPostForm.eventRadio"
                              :label="0"
                              @change="handleEventRadioChange"
                              >时间段</el-radio
                            >
                            <el-radio
                              v-model="proExpPostForm.eventRadio"
                              :label="1"
                              @change="handleEventRadioChange"
                              >时间点</el-radio
                            >
                          </div> -->
                            <el-form
                              :model="proExpPostForm"
                              label-position="left"
                              label-width="85px"
                            >
                              <el-form-item label="开始时间：">
                                <div style="display:flex">
                                  <el-date-picker
                                    :editable="false"
                                    v-model="proExpPostForm['时间'].startDate"
                                    value-format="yyyy-MM-dd"
                                    style="width: 289px;"
                                    placeholder="请选择开始时间"
                                  ></el-date-picker>
                                  <!-- <span style="margin-left:10px;margin-right:10px"
                                  >至</span
                                >
                                <el-date-picker
                                  :editable="false"
                                  value-format="yyyy-MM-dd"
                                  v-model="proExpPostForm['时间'].endDate"
                                  style="width: 289px;"
                                  placeholder="请选择结束时间"
                                ></el-date-picker> -->
                                </div>
                              </el-form-item>

                              <el-form-item label="结束时间：">
                                <!-- <div style="display:flex">
                                <el-date-picker
                                  :editable="false"
                                  v-model="proExpPostForm['时间'].startDate"
                                  value-format="yyyy-MM-dd"
                                  style="width: 289px;"
                                  placeholder="请选择时间"
                                ></el-date-picker>
                              </div> -->
                                <el-radio-group
                                  v-model="proExpPostForm.eventRadio"
                                  @change="
                                    eventEndDateTypeChange(
                                      $event,
                                      proExpPostForm
                                    )
                                  "
                                >
                                  <el-radio :label="0">当天</el-radio>
                                  <el-radio :label="1">至今</el-radio>
                                  <el-radio :label="2">时间选择</el-radio>
                                </el-radio-group>
                                <br />
                                <el-date-picker
                                  v-if="proExpPostForm.eventRadio === 2"
                                  :editable="false"
                                  value-format="yyyy-MM-dd"
                                  v-model="proExpPostForm['时间'].endDate"
                                  style="width: 286px;"
                                  placeholder="请选择结束时间"
                                ></el-date-picker>
                              </el-form-item>
                              <el-form-item label="岗位名称：">
                                <el-input
                                  type="text"
                                  v-model="proExpPostForm['岗位名称'].dataValue"
                                  placeholder="请输入岗位名称"
                                ></el-input>
                              </el-form-item>
                              <el-form-item label="岗位描述：">
                                <el-input
                                  type="textarea"
                                  v-model="proExpPostForm['内容'].dataValue"
                                  placeholder="请输入岗位描述"
                                ></el-input>
                              </el-form-item>
                              <el-form-item label="附件：">
                                <div class="fileList">
                                  <div
                                    class="fileItem"
                                    v-for="(item, index) in fileList"
                                    :key="item.uid"
                                  >
                                    {{ item.name
                                    }}<i
                                      @click="handleRemoveFile(index)"
                                      class="icon_fileRemove"
                                    ></i>
                                  </div>
                                </div>
                                <el-upload
                                  ref="upload"
                                  class="upload"
                                  action=""
                                  :auto-upload="false"
                                  multiple
                                  :show-file-list="false"
                                  :on-change="
                                    event =>
                                      handleEventUploadChange(
                                        event,
                                        index,
                                        eventIndex
                                      )
                                  "
                                >
                                  <span
                                    style="color:#3A61B1;text-decoration: underline;"
                                    >+选择附件</span
                                  >
                                  <div slot="tip" class="el-upload__tip">
                                    <TipText
                                      text="您可以添加多个图片附件作为信息证明文件上传"
                                    />
                                  </div>
                                </el-upload>
                              </el-form-item>
                              <el-form-item>
                                <Btn
                                  btnText="提交"
                                  :width="69"
                                  :height="30"
                                  :radius="15"
                                  @handleClick="handleSubmitPostForm(index)"
                                />
                                <Btn
                                  btnText="取消"
                                  className="primary_plain"
                                  :width="69"
                                  :height="30"
                                  :radius="15"
                                  style="margin-left:13px"
                                  @handleClick="handleCloseEventForm"
                                />
                              </el-form-item>
                            </el-form>
                          </el-timeline-item>
                        </el-timeline>
                      </div>

                      <span
                        v-if="
                          !isSelect &&
                            item['单位名称'].modifiable &&
                            !proExpPostForm
                        "
                        class="btn_addEvent"
                        @click="handleAddProExpEvent(index, '岗位记录')"
                        >+岗位记录</span
                      >
                    </div>
                  </div>

                  <div
                    class="eduItemDetail"
                    v-if="
                      item['事件/活动记录'] ||
                        item['时间'].dataSourceType === 'CONSUMER'
                    "
                  >
                    <div class="value">
                      <!-- v-if="!isSelect && item['岗位记录'] ||item['时间'].dataSourceType ==='CONSUMER'" -->
                      <div
                        v-if="
                          (!isSelect && item['事件/活动记录']) ||
                            item['时间'].dataSourceType === 'CONSUMER'
                        "
                      >
                        <el-checkbox
                          v-if="
                            isSelect &&
                              checkList['职业经历'].value[index][
                                '事件/活动记录'
                              ]
                          "
                          v-model="
                            checkList['职业经历'].value[index]['事件/活动记录']
                              .checkAll
                          "
                          :indeterminate="
                            checkList['职业经历'].value[index]['事件/活动记录']
                              .indeterminate
                          "
                          @change="
                            handleCheckAll(
                              $event,
                              '职业经历',
                              '事件/活动记录',
                              index
                            )
                          "
                        ></el-checkbox
                        >事件/活动记录：
                      </div>
                      <div class="timeLine">
                        <el-timeline>
                          <!-- v-if="!isSelect&&!eItem['时间'].deleteTag" -->
                          <el-timeline-item
                            v-if="isSelect ? !eItem['时间'].deleteTag : true"
                            v-for="(eItem, eventIndex) in item['事件/活动记录']"
                            :key="eventIndex"
                            :hide-timestamp="true"
                          >
                            <div style="line-height: 26px;">
                              <div style="display:flex">
                                <el-checkbox
                                  v-if="isSelect"
                                  v-model="
                                    checkList['职业经历'].value[index][
                                      '事件/活动记录'
                                    ].value[eventIndex][
                                      Object.keys(eItem)
                                        .filter(e => e !== '上级Id')
                                        .map(r => eItem[r].dataId.toString())
                                    ]
                                  "
                                  @change="
                                    handleCheckedChange(
                                      $event,
                                      '职业经历',
                                      '事件/活动记录',
                                      index
                                    )
                                  "
                                >
                                </el-checkbox>
                                <div class="eventItem">
                                  <div class="eventDate">
                                    <div>
                                      <div style="display:flex">
                                        <div
                                          :class="
                                            `${eItem['时间'].deleteTag &&
                                              'deleteLine'}`
                                          "
                                        >
                                          {{
                                            eItem["时间"].dataValue.split(",")
                                              .length > 1
                                              ? eItem["时间"].dataValue.split(
                                                  ","
                                                )[0] +
                                                "~" +
                                                eItem["时间"].dataValue.split(
                                                  ","
                                                )[1]
                                              : eItem["时间"].dataValue
                                          }}
                                        </div>
                                        <span
                                          v-if="eItem['时间'].deleteTag"
                                          style="color:#FF4C4C;margin-left:15px"
                                          >已删除</span
                                        >
                                      </div>
                                      <div class="eventUpdateDate">
                                        数据更新于{{
                                          eItem["时间"].lastUpdateDate
                                            | parseTime(
                                              "{y}-{m}-{d} {h}:{i}:{s}"
                                            )
                                        }}
                                      </div>
                                    </div>
                                    <div class="operations" v-if="!isSelect">
                                      <span
                                        v-if="
                                          eItem['时间'].dataSourceType ===
                                            'CONSUMER' &&
                                            !eItem['时间'].deleteTag
                                        "
                                        @click="
                                          handleEditProExpEvent(
                                            eItem,
                                            eItem['上级Id'],
                                            index
                                          )
                                        "
                                        ><i class="icon_edit" />修改</span
                                      >
                                      <span
                                        v-if="
                                          eItem['时间'].dataSourceType ===
                                            'CONSUMER' &&
                                            !eItem['时间'].deleteTag
                                        "
                                        @click="
                                          handleDeleteAll(
                                            eItem['上级Id'],
                                            '事件/活动记录'
                                          )
                                        "
                                        ><i class="icon_delete" />删除</span
                                      >
                                      <span
                                        @click="
                                          handleCorrigendum(
                                            eItem['时间'].dataId
                                          )
                                        "
                                        v-if="
                                          !eItem['时间'].deleteTag &&
                                            eItem['时间'].dataSourceType !==
                                              'CONSUMER'
                                        "
                                        ><i
                                          class="icon_corrigendum"
                                        />勘误</span
                                      >
                                      <span
                                        @click="
                                          handleRecords(eItem['时间'].dataId)
                                        "
                                        ><i
                                          class="icon_dataSource"
                                        />数据记录</span
                                      >
                                    </div>
                                  </div>

                                  <div
                                    class="eventContent"
                                    v-if="eItem['内容']"
                                  >
                                    <div>
                                      <div style="display:flex">
                                        <div
                                          :class="
                                            `eContent ${eItem['内容']
                                              .deleteTag && 'deleteLine'}`
                                          "
                                        >
                                          {{ eItem["内容"].dataValue }}
                                        </div>
                                        <span
                                          v-if="eItem['内容'].deleteTag"
                                          style="color:#FF4C4C;margin-left:15px"
                                          >已删除</span
                                        >
                                      </div>
                                      <div class="eventUpdateDate">
                                        数据更新于{{
                                          eItem["内容"].lastUpdateDate
                                            | parseTime(
                                              "{y}-{m}-{d} {h}:{i}:{s}"
                                            )
                                        }}
                                      </div>
                                    </div>
                                    <div class="operations" v-if="!isSelect">
                                      <span
                                        @click="
                                          handleCorrigendum(
                                            eItem['内容'].dataId
                                          )
                                        "
                                        v-if="
                                          !eItem['内容'].deleteTag &&
                                            eItem['内容'].dataSourceType !==
                                              'CONSUMER'
                                        "
                                        ><i
                                          class="icon_corrigendum"
                                        />勘误</span
                                      >
                                      <span
                                        @click="
                                          handleRecords(eItem['内容'].dataId)
                                        "
                                        ><i
                                          class="icon_dataSource"
                                        />数据记录</span
                                      >
                                    </div>
                                  </div>
                                  <div v-if="eItem['附件']">附件：</div>
                                  <div class="eventFile" v-if="eItem['附件']">
                                    <div class="eventFileLayout">
                                      <div></div>
                                      <div class="eventFileList">
                                        <div
                                          @click="handlePreviewImg(file)"
                                          class="eventFileItem"
                                          v-for="(file, fileIndex) in eItem[
                                            '附件'
                                          ].dataValue.split(',')"
                                          :key="fileIndex"
                                        >
                                          {{ file.split(":")[2] }}
                                        </div>
                                      </div>
                                      <div class="operations" v-if="!isSelect">
                                        <span
                                          @click="
                                            handleCorrigendum(
                                              eItem['附件'].dataId
                                            )
                                          "
                                          v-if="
                                            !eItem['附件'].deleteTag &&
                                              eItem['附件'].dataSourceType !==
                                                'CONSUMER'
                                          "
                                          ><i
                                            class="icon_corrigendum"
                                          />勘误</span
                                        >
                                        <span
                                          @click="
                                            handleRecords(eItem['附件'].dataId)
                                          "
                                          ><i
                                            class="icon_dataSource"
                                          />数据记录</span
                                        >
                                      </div>
                                    </div>
                                    <div class="eventUpdateDate">
                                      数据更新于{{
                                        eItem["附件"].lastUpdateDate
                                          | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                                      }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </el-timeline-item>
                          <el-timeline-item
                            v-if="proExpEventForm && proExpIndex === index"
                            id="proExpEventForm"
                          >
                            <!-- <div style="margin-bottom:23px">
                            <el-radio
                              v-model="proExpEventForm.eventRadio"
                              :label="0"
                              @change="handleEventRadioChange"
                              >时间段</el-radio
                            >
                            <el-radio
                              v-model="proExpEventForm.eventRadio"
                              :label="1"
                              @change="handleEventRadioChange"
                              >时间点</el-radio
                            >
                          </div> -->
                            <el-form
                              :model="proExpEventForm"
                              label-position="left"
                              label-width="85px"
                            >
                              <el-form-item label="开始时间：">
                                <div style="display:flex">
                                  <el-date-picker
                                    :editable="false"
                                    v-model="proExpEventForm['时间'].startDate"
                                    value-format="yyyy-MM-dd"
                                    style="width: 289px;"
                                    placeholder="请选择开始时间"
                                  ></el-date-picker>
                                  <!-- <span style="margin-left:10px;margin-right:10px"
                                  >至</span
                                >
                                <el-date-picker
                                  :editable="false"
                                  value-format="yyyy-MM-dd"
                                  v-model="proExpEventForm['时间'].endDate"
                                  style="width: 289px;"
                                  placeholder="请选择结束时间"
                                ></el-date-picker>-->
                                </div>
                              </el-form-item>
                              <el-form-item label="结束时间：">
                                <!-- <div style="display:flex"> -->
                                <el-radio-group
                                  v-model="proExpEventForm.eventRadio"
                                  @change="
                                    eventEndDateTypeChange(
                                      $event,
                                      proExpEventForm
                                    )
                                  "
                                >
                                  <el-radio :label="0">当天</el-radio>
                                  <el-radio :label="1">至今</el-radio>
                                  <el-radio :label="2">时间选择</el-radio>
                                </el-radio-group>
                                <br />
                                <el-date-picker
                                  v-if="proExpEventForm.eventRadio === 2"
                                  :editable="false"
                                  value-format="yyyy-MM-dd"
                                  v-model="proExpEventForm['时间'].endDate"
                                  style="width: 286px;"
                                  placeholder="请选择结束时间"
                                ></el-date-picker>
                                <!-- </div> -->
                              </el-form-item>
                              <!-- <el-form-item label="岗位名称">
                              <el-input
                                type="text"
                                v-model="proExpEventForm['岗位名称']"
                              ></el-input>
                            </el-form-item> -->
                              <el-form-item label="事件描述：">
                                <el-input
                                  type="textarea"
                                  v-model="proExpEventForm['内容'].dataValue"
                                  placeholder="请输入事件描述"
                                ></el-input>
                              </el-form-item>
                              <el-form-item label="附件：">
                                <div class="fileList">
                                  <div
                                    class="fileItem"
                                    v-for="(item, index) in fileList"
                                    :key="item.uid"
                                  >
                                    {{ item.name
                                    }}<i
                                      @click="handleRemoveFile(index)"
                                      class="icon_fileRemove"
                                    ></i>
                                  </div>
                                </div>
                                <el-upload
                                  ref="upload"
                                  class="upload"
                                  action=""
                                  :auto-upload="false"
                                  multiple
                                  :show-file-list="false"
                                  :on-change="
                                    event =>
                                      handleEventUploadChange(
                                        event,
                                        index,
                                        eventIndex
                                      )
                                  "
                                >
                                  <span
                                    style="color:#3A61B1;text-decoration: underline;"
                                    >+选择附件</span
                                  >
                                  <div slot="tip" class="el-upload__tip">
                                    <TipText
                                      text="您可以添加多个图片附件作为信息证明文件上传"
                                    />
                                  </div>
                                </el-upload>
                              </el-form-item>
                              <el-form-item>
                                <Btn
                                  btnText="提交"
                                  :width="69"
                                  :height="30"
                                  :radius="15"
                                  @handleClick="
                                    handleSubmitProExpEventForm(index)
                                  "
                                />
                                <Btn
                                  btnText="取消"
                                  className="primary_plain"
                                  :width="69"
                                  :height="30"
                                  :radius="15"
                                  style="margin-left:13px"
                                  @handleClick="handleCloseEventForm"
                                />
                              </el-form-item>
                            </el-form>
                          </el-timeline-item>
                        </el-timeline>
                      </div>

                      <span
                        v-if="
                          !isSelect &&
                            item['时间'].modifiable &&
                            !proExpEventForm
                        "
                        class="btn_addEvent"
                        @click="handleAddProExpEvent(index, '事件/活动记录')"
                        >+事件/活动记录</span
                      >
                      <!-- <div></div> -->
                      <TipText
                        text="您可以添加在职期间事件/活动记录。如“2022年 参与全国大学生数学建模竞赛获得一等奖”"
                      />
                    </div>
                  </div>
                </div>
                <div class="panel_toggle" v-if="!item['时间'].deleteTag">
                  <Toggle
                    :flag="proExpToggles[index]"
                    @handleClick="handleProExpItemToggle(index)"
                  />
                </div>
                <!-- <div class="eduItem_l">
                  <div class="eduItem_l_t">
                    <el-checkbox
                      v-if="isSelect"
                      v-model="checkList['职业经历'].value[index].checkAll"
                      :indeterminate="
                        checkList['职业经历'].value[index].indeterminate
                      "
                      @change="
                        handleCheckAll($event, '职业经历', undefined, index)
                      "
                    ></el-checkbox>
                    <span class="date">{{
                      item["时间"].dataValue.split(",").length > 1
                        ? `${item["时间"].dataValue.split(",")[0]}~${
                            item["时间"].dataValue.split(",")[1]
                          }`
                        : `${item["时间"].dataValue.split(",")[0]}至今`
                    }}</span>
                    <span
                      v-if="item['时间'].deleteTag"
                      style="color: rgb(255, 76, 76); margin-left: 20px;"
                      >已删除</span
                    >
                  </div>
                  <div class="eduItem_l_b">
                    
                    {{ item["时间"].createDate | parseTime("{y}-{m}-{d}") }}
                    {{
                      `由 ${item["时间"].dataSourceName}${
                        item["时间"].deleteTag
                          ? "删除"
                          : item["时间"].dataSourceType === "CONSUMER"
                          ? "自填"
                          : "添加"
                      }`
                    }}
                  </div>
                </div>
                <div class="eduItem_r">
                  <div class="eduItem_r_t">
                    <div>
                      {{ item["单位名称"].dataValue }}
                      <RedDot
                        v-if="redDotMakStr.indexOf(item['上级Id']) > -1"
                      />
                    </div>
                    
                    <Toggle
                      v-if="!item['单位名称'].deleteTag"
                      :flag="proExpToggles[index]"
                      @handleClick="handleProExpItemToggle(index)"
                    />
                  </div>
                  <div class="eduItem_r_b" v-if="!isSelect">
                    <span
                      v-if="item['单位名称'].modifiable"
                      @click="handleAddProExpForm('edit', index)"
                      >修改</span
                    >
                    <span
                      v-if="item['单位名称'].modifiable"
                      @click="handleDeleteAll(item['上级Id'], '职业经历')"
                      >删除</span
                    >
                    <span
                      @click="handleCorrigendum(item['单位名称'].dataId)"
                      v-if="
                        !item['单位名称'].deleteTag &&
                          item['单位名称'].dataSourceType !== 'CONSUMER'
                      "
                      >勘误</span
                    >
                    <span @click="handleRecords(item['单位名称'].dataId)"
                      >数据记录</span
                    >
                  </div>
                  <div v-else class="eduItem_r_b"></div>
                </div> -->
              </div>
            </div>
            <div id="proExpForm" class="eduForm" v-if="isAddProExp">
              <el-form
                :modal="proExpForm"
                label-width="120px"
                label-position="left"
              >
                <el-form-item label="单位名称：">
                  <!-- <el-input v-model="proExpForm['单位名称']"></el-input> -->
                  <el-autocomplete
                    clearable
                    style="width:100%"
                    v-model="proExpForm['单位名称']"
                    :fetch-suggestions="queryProExpSearch"
                    :trigger-on-focus="false"
                    placeholder="请输入内容"
                    @select="val => handleSelectAuto(val, '职业经历')"
                  >
                    <template slot-scope="scope">
                      <div class="autoName">
                        <span>{{ scope.item.name }}</span>
                        <i
                          v-if="scope.item.authentication"
                          class="icon_renzheng"
                        ></i>
                      </div>
                    </template>
                  </el-autocomplete>
                </el-form-item>
                <el-form-item label="单位介绍：">
                  <el-input
                    v-model="proExpForm['单位介绍']"
                    type="textarea"
                    :autosize="{ minRows: 5, maxRows: 5 }"
                    placeholder="请简单描述单位信息。如“该单位是一家互联网信息服务公司，成立于2012年3月,”"
                  ></el-input>
                </el-form-item>
                <el-form-item label="开始时间：">
                  <!-- <el-date-picker
                    :editable="false"
                    v-model="proExpForm['时间']"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width:100%"
                  >
                  </el-date-picker> -->
                  <el-date-picker
                    :editable="false"
                    v-model="proExpForm['时间'][0]"
                    value-format="yyyy-MM-dd"
                    style="width: 286px;"
                    placeholder="请选择开始时间"
                  ></el-date-picker>
                  <!-- <span style="margin-left:10px;margin-right:10px">至</span>
                  <el-date-picker
                    :editable="false"
                    value-format="yyyy-MM-dd"
                    v-model="proExpForm['时间'][1]"
                    style="width: 286px;"
                    placeholder="请选择结束时间"
                  ></el-date-picker> -->
                </el-form-item>
                <el-form-item label="结束时间">
                  <el-radio-group
                    v-model="proExpForm.endDateType"
                    @change="endDateTypeChange($event, proExpForm)"
                  >
                    <el-radio :label="0">当天</el-radio>
                    <el-radio :label="1">至今</el-radio>
                    <el-radio :label="2">时间选择</el-radio>
                  </el-radio-group>
                  <br />
                  <el-date-picker
                    v-if="proExpForm.endDateType === 2"
                    :editable="false"
                    value-format="yyyy-MM-dd"
                    v-model="proExpForm['时间'][1]"
                    style="width: 286px;"
                    placeholder="请选择结束时间"
                  ></el-date-picker>
                </el-form-item>

                <el-form-item label="附件：">
                  <div class="fileList">
                    <div
                      class="fileItem"
                      v-for="(item, index) in fileList"
                      :key="item.uid"
                    >
                      {{ item.name
                      }}<i
                        @click="handleRemoveFile(index)"
                        class="icon_fileRemove"
                      ></i>
                    </div>
                  </div>
                  <el-upload
                    ref="upload"
                    class="upload"
                    action=""
                    :auto-upload="false"
                    multiple
                    :show-file-list="false"
                    :on-change="handleUploadChange"
                  >
                    <span style="color:#3A61B1;text-decoration: underline;"
                      >+选择附件</span
                    >
                    <div slot="tip" class="el-upload__tip">
                      <TipText
                        text="您可以添加多个图片附件作为信息证明文件上传"
                      />
                    </div>
                  </el-upload>
                </el-form-item>

                <el-form-item>
                  <Btn
                    btnText="提交"
                    className="primary"
                    :height="30"
                    :width="69"
                    style="margin-right:13px"
                    @handleClick="handleSubmitProExpForm"
                  />
                  <Btn
                    btnText="取消"
                    className="primary_plain"
                    :height="30"
                    :width="69"
                    @handleClick="isAddProExp = false"
                  />
                </el-form-item>
                <el-form-item>
                  <TipText
                    text="单位信息提交后，可添加岗位记录和事件/活动记录信息"
                  />
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <!-- <template id="socialInfo"></template> -->
        <div id="socialInfo" class="piItem">
          <div class="piTitle">
            <div class="titleName">
              <el-checkbox
                v-if="isSelect"
                v-model="checkList['社会活动经历'].checkAll"
                :indeterminate="checkList['社会活动经历'].indeterminate"
                @change="handleCheckAll($event, '社会活动经历')"
              ></el-checkbox
              >社会活动经历<Btn
                v-if="!isSelect"
                btnText="社会活动经历"
                :width="132"
                className="default"
                :height="39"
                style="margin-left:14px"
                :plus="true"
                @handleClick="handleAddSocialEvent('社会活动经历')"
              />
            </div>
            <!-- <i
              :class="`${toggle['社会活动经历'] ? 'toggled' : 'toggle'}`"
              @click="toggle['社会活动经历'] = !toggle['社会活动经历']"
            ></i> -->
            <Toggle
              :flag="toggle['社会活动经历']"
              @handleClick="toggle['社会活动经历'] = !toggle['社会活动经历']"
            />
          </div>
          <div
            class="eduList"
            v-if="
              toggle['社会活动经历'] && (list['社会活动经历'] || isAddSocial)
            "
          >
            <!-- v-for="(item, index) in list['社会活动经历']"
              :key="index" -->
            <div class="eduItem">
              <div class="eduItemDetails" style="padding-top:0">
                <div class="eduItemDetail">
                  <div class="value">
                    <div class="timeLine">
                      <el-timeline>
                        <div v-if="list['社会活动经历']">
                          <el-timeline-item
                            v-if="isSelect ? !eItem['时间'].deleteTag : true"
                            v-for="(eItem, eventIndex) in list[
                              '社会活动经历'
                            ][0]['事件/活动记录']"
                            :key="eventIndex"
                            :hide-timestamp="true"
                          >
                            <div class="eventItem">
                              <div class="eventDate" v-if="eItem['时间']">
                                <div>
                                  <div style="display:flex">
                                    <div
                                      :class="
                                        `${eItem['时间'].deleteTag &&
                                          'deleteLine'}`
                                      "
                                    >
                                      <el-checkbox
                                        v-if="isSelect"
                                        v-model="
                                          checkList['社会活动经历'].value[0][
                                            '事件/活动记录'
                                          ].value[eventIndex][
                                            Object.keys(eItem)
                                              .filter(e => e !== '上级Id')
                                              .map(r =>
                                                eItem[r].dataId.toString()
                                              )
                                          ]
                                        "
                                        @change="
                                          handleCheckedChange(
                                            $event,
                                            '社会活动经历',
                                            '事件/活动记录',
                                            eventIndex
                                          )
                                        "
                                      >
                                      </el-checkbox>
                                      {{
                                        eItem["时间"].dataValue.split(",")
                                          .length > 1
                                          ? eItem["时间"].dataValue.split(
                                              ","
                                            )[0] +
                                            "~" +
                                            eItem["时间"].dataValue.split(
                                              ","
                                            )[1]
                                          : eItem["时间"].dataValue
                                      }}
                                    </div>
                                    <span
                                      v-if="eItem['时间'].deleteTag"
                                      style="color:#FF4C4C;margin-left:15px"
                                      >已删除</span
                                    >
                                  </div>
                                  <div class="eventUpdateDate">
                                    {{
                                      eItem["时间"].lastUpdateDate
                                        | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                                    }}
                                    {{
                                      `由 ${eItem["时间"].dataSourceName}${
                                        eItem["时间"].deleteTag
                                          ? "删除"
                                          : eItem["时间"].dataSourceType ===
                                            "CONSUMER"
                                          ? "自填"
                                          : "添加"
                                      }`
                                    }}
                                  </div>
                                </div>
                                <!-- <div class="operations" v-if="!isSelect">
                                  <span
                                    v-if="
                                      eItem['时间'].dataSourceType ===
                                        'CONSUMER' && !eItem['时间'].deleteTag
                                    "
                                    @click="
                                      handleEditSocial(
                                        eItem,
                                        eItem['上级Id'],
                                        eventIndex
                                      )
                                    "
                                    >修改</span
                                  >
                                  <span
                                    v-if="
                                      eItem['时间'].dataSourceType ===
                                        'CONSUMER' && !eItem['时间'].deleteTag
                                    "
                                    @click="
                                      handleDeleteAll(
                                        eItem['上级Id'],
                                        '社会活动经历'
                                      )
                                    "
                                    >删除</span
                                  >
                                  <span
                                    v-if="
                                      eItem['时间'].dataSourceType !==
                                        'CONSUMER' && !eItem['时间'].deleteTag
                                    "
                                    @click="
                                      handleCorrigendum(eItem['时间'].dataId)
                                    "
                                    >勘误</span
                                  >
                                  <span
                                    @click="handleRecords(eItem['时间'].dataId)"
                                    >数据记录</span
                                  >
                                </div> -->
                                <OperationList
                                  v-if="!isSelect"
                                  :data="eItem['时间']"
                                  :isEdit="true"
                                  :isDelete="true"
                                  @handleEdit="
                                    handleEditSocial(
                                      eItem,
                                      eItem['上级Id'],
                                      eventIndex
                                    )
                                  "
                                  @handleDelete="
                                    handleDeleteAll(
                                      eItem['上级Id'],
                                      '社会活动经历'
                                    )
                                  "
                                  @updateRedDotMark="
                                    eItem['时间'].redDotMark = false
                                  "
                                />
                              </div>

                              <div class="eventContent" v-if="eItem['内容']">
                                <div>
                                  <div style="display:flex">
                                    <div
                                      :class="
                                        `eContent ${eItem['内容'].deleteTag &&
                                          'deleteLine'}`
                                      "
                                    >
                                      {{ eItem["内容"].dataValue }}
                                    </div>
                                    <span
                                      v-if="eItem['内容'].deleteTag"
                                      style="color:#FF4C4C;margin-left:15px"
                                      >已删除</span
                                    >
                                  </div>
                                  <div class="eventUpdateDate">
                                    {{
                                      eItem["内容"].lastUpdateDate
                                        | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                                    }}
                                    {{
                                      `由 ${eItem["内容"].dataSourceName}${
                                        eItem["内容"].deleteTag
                                          ? "删除"
                                          : eItem["内容"].dataSourceType ===
                                            "CONSUMER"
                                          ? "自填"
                                          : "添加"
                                      }`
                                    }}
                                  </div>
                                </div>
                                <!-- <div class="operations" v-if="!isSelect">
                                  <span
                                    v-if="
                                      !eItem['内容'].deleteTag &&
                                        eItem['内容'].dataSourceType !==
                                          'CONSUMER'
                                    "
                                    @click="
                                      handleCorrigendum(eItem['内容'].dataId)
                                    "
                                    >勘误</span
                                  >
                                  <span
                                    @click="handleRecords(eItem['内容'].dataId)"
                                    >数据记录</span
                                  >
                                </div> -->
                                <OperationList
                                  v-if="!isSelect"
                                  :data="eItem['内容']"
                                  @updateRedDotMark="
                                    eItem['内容'].redDotMark = false
                                  "
                                />
                              </div>
                              <div v-if="eItem['附件']">附件：</div>
                              <div class="eventFile" v-if="eItem['附件']">
                                <div class="eventFileLayout">
                                  <div></div>
                                  <div class="eventFileList">
                                    <div
                                      @click="handlePreviewImg(file)"
                                      class="eventFileItem"
                                      v-for="(file, fileIndex) in eItem[
                                        '附件'
                                      ].dataValue.split(',')"
                                      :key="fileIndex"
                                    >
                                      {{ file.split(":")[2] }}
                                    </div>
                                  </div>
                                  <!-- <div class="operations" v-if="!isSelect">
                                    <span
                                      v-if="
                                        eItem['附件'].dataSourceType !==
                                          'CONSUMER' && !eItem['附件'].deleteTag
                                      "
                                      @click="
                                        handleCorrigendum(eItem['附件'].dataId)
                                      "
                                      >勘误</span
                                    >
                                    <span
                                      @click="
                                        handleRecords(eItem['附件'].dataId)
                                      "
                                      >数据记录</span
                                    >
                                  </div> -->
                                  <OperationList
                                    v-if="!isSelect"
                                    :data="eItem['附件']"
                                    @updateRedDotMark="
                                      eItem['附件'].redDotMark = false
                                    "
                                  />
                                </div>
                                <div class="eventUpdateDate">
                                  数据更新于{{
                                    eItem["附件"].lastUpdateDate
                                      | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
                                  }}
                                </div>
                              </div>
                            </div>
                          </el-timeline-item>
                        </div>

                        <el-form
                          id="socialForm"
                          :modal="socialEventForm"
                          v-if="socialEventForm"
                          label-position="left"
                          label-width="85px"
                        >
                          <!-- <el-form-item> -->
                          <el-timeline-item>
                            <!-- <el-form-item>
                                <el-radio
                                  v-model="socialEventForm.eventRadio"
                                  :label="0"
                                  @change="handleEventRadioChange"
                                  >时间段</el-radio
                                >
                                <el-radio
                                  v-model="socialEventForm.eventRadio"
                                  :label="1"
                                  @change="handleEventRadioChange"
                                  >时间点</el-radio
                                >
                              </el-form-item> -->
                            <el-form-item label="开始时间：">
                              <div style="display:flex">
                                <el-date-picker
                                  :editable="false"
                                  v-model="socialEventForm['时间'].startDate"
                                  value-format="yyyy-MM-dd"
                                  style="width: 289px;"
                                  placeholder="请选择开始时间"
                                ></el-date-picker>
                                <!-- <span
                                    style="margin-left:10px;margin-right:10px"
                                    >至</span
                                  >
                                  <el-date-picker
                                    :editable="false"
                                    v-model="socialEventForm['时间'].endDate"
                                    value-format="yyyy-MM-dd"
                                    style="width: 289px;"
                                    placeholder="请选择结束时间"
                                  ></el-date-picker> -->
                              </div>
                            </el-form-item>
                            <el-form-item label="结束时间：">
                              <!-- <div> -->
                              <el-radio-group
                                v-model="socialEventForm.eventRadio"
                                @change="
                                  eventEndDateTypeChange(
                                    $event,
                                    socialEventForm
                                  )
                                "
                              >
                                <el-radio :label="0">当天</el-radio>
                                <el-radio :label="1">至今</el-radio>
                                <el-radio :label="2">时间选择</el-radio>
                              </el-radio-group>
                              <br />
                              <el-date-picker
                                :editable="false"
                                v-if="socialEventForm.eventRadio === 2"
                                v-model="socialEventForm['时间'].endDate"
                                value-format="yyyy-MM-dd"
                                style="width: 289px;"
                                placeholder="请选择时间"
                              ></el-date-picker>
                              <!-- </div> -->
                            </el-form-item>
                            <el-form-item label="内容：">
                              <div style="display:flex">
                                <el-input
                                  type="textarea"
                                  v-model="socialEventForm['内容'].dataValue"
                                  placeholder="您可以添加参与的社会事件/活动记录。如“2022年 参与某选秀节目获得全国六强成绩"
                                ></el-input>
                              </div>
                            </el-form-item>
                            <el-form-item label="附件：">
                              <div
                                class="fileList"
                                style="display: flex;flex-direction: column;"
                              >
                                <div
                                  class="fileItem"
                                  v-for="(item, index) in fileList"
                                  :key="item.uid"
                                >
                                  {{ item.name
                                  }}<i
                                    @click="handleRemoveFile(index)"
                                    class="icon_fileRemove"
                                  ></i>
                                </div>
                              </div>
                              <el-upload
                                ref="upload"
                                class="upload"
                                action=""
                                :auto-upload="false"
                                multiple
                                :show-file-list="false"
                                :on-change="
                                  event =>
                                    handleEventUploadChange(
                                      event,
                                      index,
                                      eventIndex
                                    )
                                "
                              >
                                <span
                                  style="color:#3A61B1;text-decoration: underline;"
                                  >+选择附件</span
                                >
                                <div slot="tip" class="el-upload__tip">
                                  <TipText
                                    text="您可以添加多个图片附件作为信息证明文件上传"
                                  />
                                </div>
                              </el-upload>
                            </el-form-item>
                            <el-form-item>
                              <Btn
                                btnText="提交"
                                :width="69"
                                :height="30"
                                :radius="15"
                                @handleClick="handleSubmitSocialEventForm"
                              />
                              <Btn
                                btnText="取消"
                                className="primary_plain"
                                :width="69"
                                :height="30"
                                :radius="15"
                                style="margin-left:13px"
                                @handleClick="handleCloseEventForm"
                              />
                            </el-form-item>
                          </el-timeline-item>
                          <!-- </el-form-item> -->
                        </el-form>
                      </el-timeline>
                    </div>

                    <span
                      v-if="socialEventForm === undefined && !isSelect"
                      class="btn_addEvent"
                      @click="handleAddSocialEvent('社会活动经历')"
                      >+社会活动经历</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="color:#7E7E7E;font-size:14px;display:flex;" v-if="!isSelect">
        <!-- <Btn
          btnText="生成个人信息报告"
          className="primary"
          :fontSize="16"
          :width="168"
          @handleClick="handleGenerateReport"
        /> -->
        <!-- <i
          class="icon_warning"
          style="position: relative;
    top: 2px;"
        /> -->
        <div>
          <i
            class="icon_warning"
            style="
    position: relative;
    top: -1px;
"
          ></i>
          您可以在<span
            style="color:#3A61B1;cursor: pointer;text-decoration: underline;"
            @click="$router.push('report/list')"
            >【信息报告管理】</span
          >中针对您的个人数据档案勾选全部或部分数据生成不同版本的信息报告，用于个人增信展示或提供给他人查验。
        </div>
      </div>
      <div class="selectLayout" v-if="isSelect">
        <div>
          <el-checkbox v-model="isCheckAll" @change="handleSelectAllIds"
            >全选</el-checkbox
          >
        </div>
        <div>
          <Btn
            btnText="预览"
            className="default"
            :width="95"
            :fontSize="16"
            @handleClick="handlePreview"
          />

          <Btn
            btnText="退出"
            className="default"
            :width="95"
            :fontSize="16"
            @handleClick="isSelect = false"
            style="margin-left:16px"
          />
          <Btn
            btnText="勾选完毕，生成个人信息报告"
            className="primary"
            :width="260"
            :fontSize="16"
            style="margin-left:22px"
            @handleClick="handleSubmitSelectIds"
          />
        </div>
      </div>
    </div>
    <div v-if="dialogReportForm">
      <CoverLayout>
        <div class="reportForm" slot="content">
          <div class="title">设置报告名称</div>
          <div class="tip">
            <i class="icon_warning" />报告名称不对外展示，仅方便个人区别
          </div>
          <el-form :modal="reportForm">
            <el-form-item label="报告名称">
              <el-input
                v-model="reportForm.name"
                :placeholder="`${reportFormDefaultName},可点击修改`"
              ></el-input>
            </el-form-item>
            <el-form-item label="备注">
              <el-input
                type="textarea"
                v-model="reportForm.remark"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="btns">
            <Btn
              btnText="取消"
              :width="165"
              className="default"
              @handleClick="dialogReportForm = false"
            />
            <Btn
              btnText="生成个人信息报告"
              :width="165"
              @handleClick="handleSubmitReportForm"
            />
          </div>
        </div>
      </CoverLayout>
    </div>
    <div v-if="dialogPreview">
      <DialogImgsPreview
        :imgs="previewImgs"
        @handleClose="handleDialogPreviewClose"
      />
    </div>
    <!-- <BackToTop /> -->
    <!-- <FixedMenu /> -->
    <div class="confirmDelete" v-if="confirmDelete">
      <CoverLayout>
        <div slot="content" class="confirmBox">
          <div class="title">确定删除该信息吗？</div>
          <div class="btns">
            <Btn
              btnText="取消"
              className="default"
              :width="100"
              :height="41"
              @handleClick="confirmDelete = false"
            />
            <Btn
              btnText="确定"
              className="primary"
              :width="100"
              :height="41"
              @handleClick="handleConfirmDelete"
            />
          </div>
        </div>
      </CoverLayout>
    </div>
    <div class="confirmDeleteAll" v-if="confirmDeleteAll">
      <CoverLayout>
        <div slot="content" class="confirmBox">
          <div class="title">
            {{ `确定删除该${deletePayload.formName}吗？` }}
          </div>
          <div class="text">
            {{
              `一经确认删除，该${deletePayload.formName}相关所有信息将会被一同删除！`
            }}
          </div>
          <div class="btns">
            <Btn
              btnText="取消"
              className="default"
              :width="100"
              :height="41"
              @handleClick="confirmDeleteAll = false"
            />
            <Btn
              btnText="确定"
              className="primary"
              :width="100"
              :height="41"
              @handleClick="handleConfirmDeleteAll"
            />
          </div>
        </div>
      </CoverLayout>
    </div>
    <div v-if="dialogAddPhone">
      <AddPhone
        @addPhoneClose="addPhoneClose"
        :phoneNumber="dialogAddPhoneNumber"
      />
    </div>
    <Promise ref="promise" @handleAgreePromise="handleAgreePromise" />
    <!-- 申请机构认证 -->
    <div class="confirmDeleteAll" v-if="dialogAgencyApply">
      <CoverLayout>
        <div slot="content" class="confirmBox">
          <div class="title">
            申请机构认证
          </div>
          <div
            class="text"
            style="
    width: 287px;
"
          >
            暂未收录当前机构数据信息，是否申请当前机构为您做数据认证？
          </div>
          <div
            class="btns"
            style="
    display: flex;
    flex-direction: column;
    align-items: center;
"
          >
            <!-- <Btn
              btnText="取消"
              className="default"
              :width="100"
              :height="41"
              @handleClick="confirmDeleteAll = false"
            /> -->
            <Btn
              btnText="提交机构认证申请"
              className="primary"
              :width="258"
              :height="41"
              @handleClick="handleSubmitAgencyApply"
            />
            <div
              style="
    cursor: pointer;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #6E6E6E;
    margin-top: 15px;
"
              @click="dialogAgencyApply = false"
            >
              取消
            </div>
          </div>
        </div>
      </CoverLayout>
    </div>
  </div>
</template>

<script>
import Btn from "../../components/Btn.vue";
import {
  getUserInfoByKey,
  updatePersonalInfo,
  updateWithDataId,
  deleteInfo,
  reportSave,
  redDotMarkDeal,
  agencyApply
} from "@/api/user";
import { upload } from "@/api/uploadFile";
import UnVerified from "../../components/UnVerified.vue";
import { parseTime, nationList } from "@/utils";
import MyDatepicker from "../../components/MyDatepicker.vue";
import CoverLayout from "../../components/CoverLayout.vue";
import DialogImgsPreview from "../../components/DialogImgsPreview.vue";
import BackToTop from "../../components/BackToTop.vue";
import { reportPreview } from "@/api/report";
import Anchor from "../../components/Anchor.vue";
import EventList from "../../components/EventList.vue";
import Toggle from "../../components/Toggle.vue";
import AddPhone from "../../components/addPhone.vue";
import Guide from "../../components/Guide.vue";
import Promise from "@/components/Promise.vue";
import { businessNameList } from "@/api/business";
import FixedMenu from "@/components/FixedMenu.vue";
import TipText from "@/components/TipText.vue";
import OperationList from "../../components/OperationList.vue";
import RedDot from "@/components/RedDot.vue";
import QA from "@/components/QA.vue";

export default {
  components: {
    Btn,
    UnVerified,
    MyDatepicker,
    CoverLayout,
    DialogImgsPreview,
    BackToTop,
    Anchor,
    EventList,
    Toggle,
    AddPhone,
    EventList,
    Guide,
    Promise,
    FixedMenu,
    TipText,
    OperationList,
    RedDot,
    QA
  },
  data() {
    return {
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      toggle: {
        基础信息: true,
        学历教育: true,
        非学历教育: true,
        职业经历: true,
        社会活动经历: true
      },
      checkAll: false,
      isHandleSelect: true,
      list: [],
      checked: [],
      isIndeterminate: false,
      originCheckList: undefined,
      checkList: {
        基础信息: {
          checked: false,
          checkAll: false,
          indeterminate: false,
          手机号码: {
            checked: false,
            checkAll: false,
            indeterminate: false,
            value: []
          },
          座机号码: {
            checked: false,
            checkAll: false,
            indeterminate: false,
            value: []
          },
          通信地址: {
            checked: false,
            checkAll: false,
            indeterminate: false,
            value: []
          },
          电子邮箱: {
            checked: false,
            checkAll: false,
            indeterminate: false,
            value: []
          }
        },
        学历教育: [],
        非学历教育: [],
        职业经历: [],
        社会活动经历: []
      },
      form: {
        基础信息: {
          民族: undefined,
          手机号码: undefined,
          座机号码: undefined,
          通信地址: undefined,
          电子邮箱: undefined,
          政治面貌: undefined,
          婚姻状况: undefined
        }
      },
      formIsEdit: {
        民族: false,
        手机号码: false,
        座机号码: false,
        通信地址: false,
        电子邮箱: false,
        政治面貌: false
      },
      isAddEdu: false,
      eduEvent: [],
      eduEventForm: undefined,
      eduForm: {},
      isSelect: false,
      fileList: [],
      eduToggles: [],
      eduIndex: 0,
      eventRadio: 0,
      editEduEventUpId: 0,
      // 非学历教育
      noEduToggles: [],
      noEduEventForm: undefined,
      noEduForm: {},
      isAddNoEdu: false,
      noEduIndex: 0,
      // 职业经历
      proExpToggles: [],
      proExpPostToggles: [],
      proExpEventForm: undefined,
      proExpPostForm: undefined,
      proExpForm: {},
      isAddProExp: false,
      proExpIndex: 0,
      //
      socialToggles: [],
      socialEventForm: undefined,
      socialPostForm: undefined,
      socialForm: {},
      isAddSocial: false,
      socialIndex: 0,
      //
      mobileIsIndeterminate: false,
      mobileCheckAll: false,
      isCheckAll: false,
      nationList: [],
      dialogReportForm: false,
      reportForm: {
        dataIds: [],
        name: "",
        remark: ""
      },
      dialogPreview: false,
      previewImgs: [],
      screenHeight: 0,
      confirmDelete: false,
      confirmDeleteAll: false,
      deleteAllformName: "",
      deletePayload: {
        formName: "",
        params: ""
      },
      dialogAddPhone: false,
      dialogAddPhoneNumber: "",
      eduNameList: [],
      noEduNameList: [],
      proExpNameList: [],
      reportFormDefaultName: "",
      redDotMakStr: "",
      isShowInvalid: false,
      // v1.0.2 part2
      superiorIdAttachInfoResponseVoMap: undefined,
      dialogAgencyApply: false,
      agencyApplyForm: undefined,
      eduFormAgent: {
        businessNameAuthenticationName: "",
        businessNameAuthenticationTag: false,
        jsonObject: {}
      },
      noEduFormAgent: {
        businessNameAuthenticationName: "",
        businessNameAuthenticationTag: false,
        jsonObject: {}
      },
      proExpFormAgent: {
        businessNameAuthenticationName: "",
        businessNameAuthenticationTag: false,
        jsonObject: {}
      },
      educationStage: undefined
    };
  },
  created() {
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    if (this.userInfo.status === "3" || this.userInfo.status === "4") {
      this.getList();
      // this.queryBusinessNameList();
    }
    this.isSelect = this.$route.query.isSelect || false;
    this.nationList = nationList();
  },
  methods: {
    async getList() {
      // this.$forceUpdate()
      // this.list = []
      await getUserInfoByKey().then(res => {
        this.list = res.data.d.jsonObject;
        // this.checkList = {}
        // JSON.parse(JSON.stringify(
        this.superiorIdAttachInfoResponseVoMap =
          res.data.d.superiorIdAttachInfoResponseVoMap;
        this.checkList = {
          基础信息: {
            checked: false,
            checkAll: false,
            indeterminate: false,
            手机号码: {
              checked: false,
              checkAll: false,
              indeterminate: false,
              value: []
            },
            座机号码: {
              checked: false,
              checkAll: false,
              indeterminate: false,
              value: []
            },
            通信地址: {
              checked: false,
              checkAll: false,
              indeterminate: false,
              value: []
            },
            电子邮箱: {
              checked: false,
              checkAll: false,
              indeterminate: false,
              value: []
            }
          },
          学历教育: [],
          非学历教育: [],
          职业经历: [],
          社会活动经历: []
        };
        this.redDotMakStr = res.data.d.redDotMakStr;
        Object.keys(this.list).forEach(listKey => {
          if (Array.isArray(this.list[listKey])) {
            this.checkList[listKey] = {
              checkAll: false,
              indeterminate: false,
              value: []
            };

            this.list[listKey].map((item, itemIndex) => {
              let posts = [];
              if (
                listKey === "学历教育" ||
                listKey === "非学历教育" ||
                listKey === "职业经历" ||
                listKey === "社会活动经历"
              ) {
                let tempObj = {};
                Object.keys(item).forEach(eduKey => {
                  if (eduKey !== "上级Id") {
                    tempObj.checkAll = false;
                    tempObj.indeterminate = false;
                    if (item[eduKey].length > 0) {
                      tempObj[eduKey] = {
                        checked: false,
                        checkAll: false,
                        indeterminate: false,
                        value: []
                      };
                      item[eduKey].map((eventItem, eventItemIndex) => {
                        // console.log(eventItem);

                        if (eduKey === "岗位记录") {
                          posts.push(false);
                        }
                        let eventItemKeys = [];
                        Object.keys(eventItem).forEach(eventKey => {
                          if (eventKey !== "上级Id") {
                            eventItemKeys.push(
                              item[eduKey][eventItemIndex][eventKey].dataId
                            );
                          }
                        });
                        tempObj[eduKey].value.push({
                          [eventItemKeys.toString()]: false
                        });
                      });
                    } else {
                      tempObj[eduKey] = {
                        // checked: false,
                        // checkAll: false,
                        // indeterminate: false,
                        [item[eduKey].dataId]: false
                      };
                    }
                  }
                });
                if (listKey === "职业经历") {
                  this.proExpPostToggles.push(posts);
                }
                this.checkList[listKey].value.push(tempObj);
              }
            });
          } else {
            Object.keys(this.list[listKey]).forEach(item => {
              if (item !== "上级Id") {
                if (Array.isArray(this.list[listKey][item])) {
                  this.list[listKey][item].map(arr => {
                    this.checkList[listKey][item].value.push({
                      [arr["值"].dataId]: false
                    });
                  });
                } else {
                  this.checkList[listKey][item] = {
                    checked: false,
                    checkAll: false,
                    indeterminate: false,
                    [this.list[listKey][item].dataId]: false
                  };
                }
              }
            });
          }
        });

        if (this.list["学历教育"]) {
          this.list["学历教育"].map(item => {
            this.eduToggles.push(false);
          });
        }
        this.originCheckList = JSON.parse(JSON.stringify(this.checkList));
      });
    },
    exitSelect() {
      this.isHandleSelect = false;
    },
    // handleCheckAllChange(val, key1, key2) {
    //   if (val) {
    //     //
    //   }
    //   if (key2) {
    //     this.checkboxTree[key1][key2].checked = val
    //       ? Array.isArray(this.list[key1][key2])
    //         ? this.list[key1][key2].map(item => item["值"].dataId)
    //         : [this.list[key1][key2].dataId]
    //       : [];
    //     this.checkboxTree[key1][key2].isIndeterminate = false;
    //   } else {
    //     let obj = this.checkboxTree[key1];
    //     for (const key in obj) {
    //       if (key.match(/[\u4e00-\u9fa5]/)) {
    //         this.checkboxTree[key1][key].checkAll = val;
    //         if (val) {
    //           if (this.list[key1][key]) {
    //             if (this.list[key1][key].dataId) {
    //               this.checkboxTree[key1][key].checked.push(
    //                 this.list[key1][key].dataId
    //               );
    //             } else {
    //               this.checkboxTree[key1][key].checked = this.list[key1][
    //                 key
    //               ].map(item => item["值"].dataId);
    //               this.checkboxTree[key1][key].isIndeterminate = false;
    //             }
    //           }
    //         } else {
    //           this.checkboxTree[key1][key].checked = [];
    //         }
    //       }
    //     }
    //   }

    //   //   if (label === "座机号码") {
    //   //     this.checked = val
    //   //       ? this.list["基础信息"]["座机号码"].map(item => item["值"].dataId)
    //   //       : [];
    //   //   } else {
    //   //     this.checkboxTree[label].checked = val
    //   //       ? [this.list["基础信息"][label].dataId]
    //   //       : [];
    //   //   }
    // },

    handleAdd(key1, key2) {
      if (!this.isPromised()) {
        return false;
      }
      if (key2 === "手机号码") {
        this.handleOpenDialogAddPhone();
      } else {
        this.form[key1][key2] = {
          type: "add",
          value: ""
        };
      }
    },
    handleSubmitForm(key1, key2) {
      let payload = {};
      let isAdd = this.form[key1][key2].type;
      let filters = ["手机号码", "座机号码", "通信地址", "电子邮箱"];
      if (this.form[key1][key2].value === "") {
        this.$message.error(key2 + "不能为空");
        return;
      }
      if (key2 === "手机号码") {
        if (this.form[key1][key2].value.length !== 11) {
          this.$message.error(key2 + "格式错误");
          return;
        }
      }
      if (key2 === "电子邮箱") {
        let str = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/; //正则表达式
        if (str.test(this.form[key1][key2].value)) {
          //检查正则表达式是否符合邮箱地址要求
          // return true;
        } else {
          this.$message.error(key2 + "格式错误");
          return false;
        }
      }
      if (isAdd === "add") {
        if (filters.indexOf(key2) === -1) {
          payload = {
            [this.list[key1]["上级Id"]]: {
              [key2]:
                filters.indexOf(key2) > -1
                  ? [{ 值: this.form[key1][key2].value }]
                  : this.form[key1][key2].value
            }
          };
        } else {
          payload = {
            [this.list[key1]["上级Id"]]: {
              [key2]:
                filters.indexOf(key2) > -1
                  ? [{ 值: this.form[key1][key2].value }]
                  : this.form[key1][key2].value
            }
          };
        }
        updatePersonalInfo(payload).then(res => {
          if (res.data.c === 200) {
            this.$message.success("提交成功");
            this.form[key1][key2] = undefined;
            this.formIsEdit[key2] = false;
            this.getList();
          }
        });
      } else {
        payload = {
          updateDataList: [
            {
              dataId:
                this.form[key1][key2].index === undefined
                  ? this.list[key1][key2].dataId
                  : this.list[key1][key2][this.form[key1][key2].index]["值"]
                      .dataId,
              dataName: this.form[key1][key2].index === undefined ? key2 : "值",
              dataValue: this.form[key1][key2].value,
              modifiable: true
            }
          ]
        };
        updateWithDataId(payload).then(res => {
          this.form[key1][key2] = undefined;
          this.formIsEdit[key2] = false;
          this.getList();
        });
      }
    },
    handleCancelForm(key1, key2) {
      this.form[key1][key2] = undefined;
      this.formIsEdit[key2] = false;
    },
    handleSelectReport() {
      this.isSelect = !this.isSelect;
    },
    handleEdit(key1, key2, index) {
      let filters = ["手机号码", "座机号码", "通信地址", "电子邮箱"];

      this.formIsEdit[key2] = true;
      this.form[key1][key2] = {
        type: "edit",
        value:
          filters.indexOf(key2) > -1
            ? this.list[key1][key2][index]["值"].dataValue
            : this.list[key1][key2].dataValue,
        index
      };
    },
    handleConfirmDelete() {
      deleteInfo(this.deletePayload.params).then(res => {
        if (res.data.c === 200) {
          this.$message.success("删除成功");
          this.confirmDelete = false;
          this.getList();
        }
      });
    },
    handleConfirmDeleteAll() {
      deleteInfo({ dataId: this.deletePayload.params, deleteAll: true }).then(
        res => {
          if (res.data.c === 200) {
            this.$message.success("删除成功");
            this.confirmDeleteAll = false;
            this.getList();
          }
        }
      );
    },
    handleDelete(key1, key2, row) {
      let filters = ["手机号码", "座机号码", "通信地址", "电子邮箱"];

      let payload = {
        dataId: filters.indexOf(key2) > -1 ? row["值"].dataId : row.dataId,
        deleteAll: false
      };

      this.deletePayload = {
        formName: "",
        params: payload
      };
      this.confirmDelete = true;
      // deleteInfo(payload).then(res => {
      //   if (res.data.c === 200) {
      //     this.getList();
      //   }
      // });
    },
    handleSocialDelete(dataId) {
      deleteInfo({
        dataId: "hdlbdgjm:TI1:ggybpdpd:TI1:",
        deleteAll: false
      }).then(res => {});
    },
    handleRecords(id) {
      // this.$router.push({ path: "/personal/dataSource", query: { id } });
      redDotMarkDeal(id).then(res => {
        let routeData = this.$router.resolve({
          path: "/personal/dataSource",
          query: { id }
        });
        window.open(routeData.href, "_blank");
      });
    },

    // 学历教育
    handleAddEduForm(type, key1, index) {
      if (!this.isPromised()) {
        return false;
      }
      this.toggle["学历教育"] = true;
      if (type === "add") {
        this.eduForm = {
          时间: new Array(2),
          endDateType: undefined
        };
        this.fileList = [];
        this.educationStage = undefined;
      } else {
        // console.log(this.superiorIdAttachInfoResponseVoMap[this.list[key1][index]['上级Id']].educationStage);
        let stage = this.superiorIdAttachInfoResponseVoMap[
          this.list[key1][index]["上级Id"]
        ].educationStage;
        this.educationStage = stage === null ? 4 : stage;
        this.$nextTick(() => {
          this.eduFormAgent.businessNameAuthenticationName = this.eduForm[
            "教育机构"
          ];
        });

        this.fileList = [];
        if (this.list[key1] && this.list[key1][index]["附件"]) {
          let files = this.list[key1][index]["附件"].dataValue.split(",");
          files.map(item => {
            this.fileList.push({
              name: item.split(":")[2],
              url: item
            });
          });
        }
      }

      this.isAddEdu = true;
      if (this.list[key1]) {
        let temp = Object.assign({}, this.list[key1][index]);
        if (temp) {
          this.eduIndex = index;
          for (const key in temp) {
            if (key === "上级Id" || key === "事件/活动记录") continue;
            if (key === "时间") {
              this.$set(this.eduForm, key, temp[key].dataValue.split(","));
              if (temp[key].dataValue.split(",")[1] === "当天") {
                this.$set(this.eduForm, "endDateType", 0);
              } else if (temp[key].dataValue.split(",")[1] === "至今") {
                this.$set(this.eduForm, "endDateType", 1);
              } else {
                this.$set(this.eduForm, "endDateType", 2);
              }
            } else {
              this.$set(this.eduForm, key, temp[key].dataValue);
            }
          }
        }
      }
      this.formScoll("eduForm");
    },
    handleRedDot(id) {
      redDotMarkDeal(id);
    },

    handleEduItemToggle(index) {
      // console.log("handleEduItemToggle");
      this.$set(this.eduToggles, index, !this.eduToggles[index]);
      this.redDotMakStr = this.redDotMakStr.replace(
        RegExp(this.list["学历教育"][index]["上级Id"], "g"),
        ""
      );
      // console.log(this.list["学历教育"][index]["上级Id"], this.redDotMakStr);
      this.handleRedDot(this.list["学历教育"][index]["上级Id"]);
    },

    async handleSubmitEduForm() {
      if (!this.eduForm["教育机构"]) {
        this.$message.error("教育机构不能为空");
        return false;
      }
      // console.log(this.eduForm);
      if (!this.eduForm["时间"][0]) {
        this.$message.error("开始时间不能为空");
        return false;
      }
      if (this.eduForm.endDateType === undefined) {
        this.$message.error("请选择结束时间类型");
        return false;
      } else if (this.eduForm.endDateType === 2) {
        if (!this.eduForm["时间"][1]) {
          this.$message.error("请选择结束时间");
          return false;
        }
        if (
          this.eduForm["时间"][1] !== "" &&
          this.eduForm["时间"][1] !== null
        ) {
          if (
            new Date(this.eduForm["时间"][0]).getTime() >
            new Date(this.eduForm["时间"][1]).getTime()
          ) {
            this.$message.error("时间范围不正确");
            return false;
          }
        }
      }

      delete this.eduForm.endDateType;
      let payload = {
        学历教育: [{ ...this.eduForm }]
      };
      payload["学历教育"][0]["时间"] =
        this.eduForm["时间"][0] +
        (this.eduForm["时间"][1] !== undefined
          ? this.eduForm["时间"][1] !== null
            ? "," + this.eduForm["时间"][1]
            : ""
          : "");
      if (this.fileList.length > 0) {
        payload["学历教育"][0]["附件"] = this.fileList
          .map(item => item.url)
          .toString();
      }
      let editArr = [];
      if (this.list["学历教育"]) {
        for (const key in this.list["学历教育"][this.eduIndex]) {
          if (key === "上级Id" || key === "事件/活动记录") continue;
          editArr.push(key);
        }
      }
      if (editArr.length > 0) {
        let payloadUpdate = {
          businessNameAuthenticationName: this.eduForm["教育机构"],
          businessNameAuthenticationTag: this.eduFormAgent
            .businessNameAuthenticationTag,
          updateDataList: []
        };
        if (
          this.eduForm["教育机构"] ===
          this.eduFormAgent.businessNameAuthenticationName
        ) {
          delete payloadUpdate.businessNameAuthenticationName;
          delete payloadUpdate.businessNameAuthenticationTag;
        }
        editArr.map(item => {
          payloadUpdate.updateDataList.push({
            dataId: this.list["学历教育"][this.eduIndex][item].dataId,
            dataName: this.list["学历教育"][this.eduIndex][item].dataName,
            dataValue:
              item === "时间"
                ? this.eduForm[item][0] +
                  (this.eduForm[item][1] !== undefined
                    ? this.eduForm[item][1] !== null
                      ? "," + this.eduForm[item][1]
                      : ""
                    : "") //this.eduForm[item].toString()
                : item === "附件"
                ? this.fileList.map(item => item.url).toString()
                : this.eduForm[item],
            modifiable: true
          });
          delete payload["学历教育"][0][item];
        });
        payloadUpdate.updateDataList["附件"] = this.fileList
          .map(item => item.url)
          .toString();
        console.log(payloadUpdate);
        await updateWithDataId(payloadUpdate).then(res => {
          if (res.data.c === 200) {
            // this.eduForm = {};
            this.isAddEdu = false;
            this.$message.success("提交成功");
            this.getList();
          }
        });
        // 新增
        let payloadAdd = {
          [this.list["学历教育"][this.eduIndex]["上级Id"]]: [
            payload["学历教育"][0]
          ]
        };

        for (const key in payloadAdd) {
          payloadAdd[key].map((item, index) => {
            for (const key1 in item) {
              if (item[key1] === "") {
                delete payloadAdd[key][index][key1];
              }
            }
          });
        }
        console.log(payloadAdd);
        if (JSON.stringify(payloadAdd[Object.keys(payloadAdd)]) !== "[{}]") {
          // this.$nextTick(()=>{
          if (
            this.eduForm["教育机构"] ===
            this.eduFormAgent.businessNameAuthenticationName
          ) {
            delete this.eduFormAgent.businessNameAuthenticationName;
            delete this.eduFormAgent.businessNameAuthenticationTag;
          }
          // })
          this.eduFormAgent.jsonObject = payloadAdd;
          // console.log(this.eduFormAgent);
          updatePersonalInfo(this.eduFormAgent).then(res => {
            if (res.data.c === 200) {
              this.eduForm = {};
              this.isAddEdu = false;
              this.getList();
            }
          });
        }
      } else {
        this.eduFormAgent.businessNameAuthenticationName =
          payload["学历教育"][0]["教育机构"];
        this.eduFormAgent.jsonObject = payload;
        if (this.educationStage) {
          this.eduFormAgent.educationStage = this.educationStage;
        }
        // console.log(this.eduFormAgent);
        updatePersonalInfo(this.eduFormAgent).then(res => {
          if (res.data.c === 200) {
            this.eduForm = {};
            this.fileList = [];
            this.isAddEdu = false;
            this.$message.success("提交成功");
            this.getList();
          }
        });
      }
    },

    // 非学历教育
    handleAddNoEduForm(type, key1, index) {
      if (!this.isPromised()) {
        return false;
      }
      this.toggle["非学历教育"] = true;
      if (type === "add") {
        this.noEduForm = {
          时间: new Array(2),
          endDateType: undefined
        };
        this.fileList = [];
      } else {
        this.$nextTick(() => {
          this.noEduFormAgent.businessNameAuthenticationName = this.noEduForm[
            "教育机构"
          ];
        });

        this.fileList = [];
        if (this.list["非学历教育"] && this.list["非学历教育"][index]["附件"]) {
          let files = this.list["非学历教育"][index]["附件"].dataValue.split(
            ","
          );
          files.map(item => {
            this.fileList.push({
              name: item.split(":")[2],
              url: item
            });
          });
        }
      }

      this.isAddNoEdu = true;
      if (this.list["非学历教育"]) {
        let temp = Object.assign({}, this.list["非学历教育"][index]);
        if (temp) {
          this.noEduIndex = index;
          for (const key in temp) {
            if (key === "上级Id" || key === "事件/活动记录") continue;
            if (key === "时间") {
              this.$set(this.noEduForm, key, temp[key].dataValue.split(","));
              if (temp[key].dataValue.split(",")[1] === "当天") {
                this.$set(this.noEduForm, "endDateType", 0);
              } else if (temp[key].dataValue.split(",")[1] === "至今") {
                this.$set(this.noEduForm, "endDateType", 1);
              } else {
                this.$set(this.noEduForm, "endDateType", 2);
              }
            } else {
              this.$set(this.noEduForm, key, temp[key].dataValue);
            }
          }
        }
      }
      this.formScoll("noEduForm");
    },
    handleNoEduItemToggle(index) {
      this.$set(this.noEduToggles, index, !this.noEduToggles[index]);
      this.handleRedDot(this.list["非学历教育"][index]["上级Id"]);
    },

    async handleSubmitNoEduForm() {
      if (!this.noEduForm["教育机构"]) {
        this.$message.error("教育机构不能为空");
        return false;
      }
      // console.log(this.eduForm);
      if (!this.noEduForm["时间"][0]) {
        this.$message.error("开始时间不能为空");
        return false;
      }
      if (this.noEduForm.endDateType === undefined) {
        this.$message.error("请选择结束时间类型");
        return false;
      } else if (this.noEduForm.endDateType === 2) {
        if (!this.noEduForm["时间"][1]) {
          this.$message.error("请选择结束时间");
          return false;
        }
        if (
          this.noEduForm["时间"][1] !== "" &&
          this.noEduForm["时间"][1] !== null
        ) {
          if (
            new Date(this.noEduForm["时间"][0]).getTime() >
            new Date(this.noEduForm["时间"][1]).getTime()
          ) {
            this.$message.error("时间范围不正确");
            return false;
          }
        }
      }
      delete this.noEduForm.endDateType;
      let payload = {
        非学历教育: [{ ...this.noEduForm }]
      };

      payload["非学历教育"][0]["时间"] =
        this.noEduForm["时间"][0] +
        (this.noEduForm["时间"][1] !== undefined
          ? this.noEduForm["时间"][1] !== null
            ? "," + this.noEduForm["时间"][1]
            : ""
          : ""); //this.noEduForm["时间"].toString();
      if (this.fileList.length > 0) {
        payload["非学历教育"][0]["附件"] = this.fileList
          .map(item => item.url)
          .toString();
      }
      let editArr = [];
      if (this.list["非学历教育"]) {
        for (const key in this.list["非学历教育"][this.noEduIndex]) {
          if (key === "上级Id") continue;
          editArr.push(key);
        }
      }

      if (editArr.length > 0) {
        let payloadUpdate = {
          businessNameAuthenticationName: this.noEduForm["教育机构"],
          businessNameAuthenticationTag: this.noEduFormAgent
            .businessNameAuthenticationTag,
          updateDataList: []
        };
        if (
          this.noEduForm["教育机构"] ===
          this.noEduFormAgent.businessNameAuthenticationName
        ) {
          delete payloadUpdate.businessNameAuthenticationName;
          delete payloadUpdate.businessNameAuthenticationTag;
        }
        editArr.map(item => {
          if (item !== "事件/活动记录") {
            payloadUpdate.updateDataList.push({
              dataId: this.list["非学历教育"][this.noEduIndex][item].dataId,
              dataName: this.list["非学历教育"][this.noEduIndex][item].dataName,
              dataValue:
                item === "时间"
                  ? this.noEduForm[item][0] +
                    (this.noEduForm[item][1] !== undefined
                      ? this.noEduForm[item][1] !== null
                        ? "," + this.noEduForm[item][1]
                        : ""
                      : "") //this.noEduForm[item].toString()
                  : item === "附件"
                  ? this.fileList.map(item => item.url).toString()
                  : this.noEduForm[item],
              modifiable: true
            });
            delete payload["非学历教育"][0][item];
          }
        });
        payloadUpdate.updateDataList["附件"] = this.fileList
          .map(item => item.url)
          .toString();
        await updateWithDataId(payloadUpdate).then(res => {
          // this.noEduForm = {};
          this.fileList = [];
          this.isAddNoEdu = false;
          this.$message.success("提交成功");
          this.getList();
        });
        // 新增
        let payloadAdd = {
          [this.list["非学历教育"][this.noEduIndex]["上级Id"]]: [
            payload["非学历教育"][0]
          ]
        };

        for (const key in payloadAdd) {
          payloadAdd[key].map((item, index) => {
            for (const key1 in item) {
              if (item[key1] === "") {
                delete payloadAdd[key][index][key1];
              }
            }
          });
        }
        if (JSON.stringify(payloadAdd[Object.keys(payloadAdd)]) !== "[{}]") {
          if (
            this.noEduForm["教育机构"] ===
            this.noEduFormAgent.businessNameAuthenticationName
          ) {
            delete this.noEduFormAgent.businessNameAuthenticationName;
            delete this.noEduFormAgent.businessNameAuthenticationTag;
          }
          this.noEduFormAgent.jsonObject = payloadAdd;
          updatePersonalInfo(this.noEduFormAgent).then(res => {
            if (res.data.c === 200) {
              this.noEduForm = {};
              this.fileList = [];
              this.isAddNoEdu = false;
              this.getList();
            }
          });
        }
      } else {
        this.noEduFormAgent.businessNameAuthenticationName =
          payload["非学历教育"][0]["教育机构"];
        this.noEduFormAgent.jsonObject = payload;
        updatePersonalInfo(this.noEduFormAgent).then(res => {
          if (res.data.c === 200) {
            this.noEduForm = {};
            this.fileList = [];
            this.isAddNoEdu = false;
            this.$message.success("提交成功");
            this.getList();
          }
        });
      }
    },

    // 职业经历
    handleAddProExpForm(type, key1, index) {
      if (!this.isPromised()) {
        return false;
      }
      this.toggle["职业经历"] = true;
      if (type === "add") {
        this.proExpForm = {
          时间: new Array(2),
          endDateType: undefined
        };
        this.fileList = [];
      } else {
        // if (
        //   this.proExpFormAgent.businessNameAuthenticationName !==
        //   this.proExpForm["单位名称"]
        // ) {
        //   this.proExpFormAgent.businessNameAuthenticationTag =
        //     (this.superiorIdAttachInfoResponseVoMap[
        //       this.list[key1][index]["上级Id"]
        //     ] &&
        //       this.superiorIdAttachInfoResponseVoMap[
        //         this.list[key1][index]["上级Id"]
        //       ].businessNameAuthenticationTag) ||
        //     false;
        //   this.proExpFormAgent.businessNameAuthenticationName = this.list[key1][
        //     index
        //   ]["单位名称"].dataValue;
        // }else{

        // }
        this.$nextTick(() => {
          this.proExpFormAgent.businessNameAuthenticationName = this.proExpForm[
            "教育机构"
          ];
        });
        this.fileList = [];
        if (this.list["职业经历"] && this.list["职业经历"][index]["附件"]) {
          let files = this.list["职业经历"][index]["附件"].dataValue.split(",");
          files.map(item => {
            this.fileList.push({
              name: item.split(":")[2],
              url: item
            });
          });
        }
      }
      this.isAddProExp = true;
      if (this.list["职业经历"]) {
        let temp = Object.assign({}, this.list["职业经历"][index]);
        if (temp) {
          this.proExpIndex = index;
          for (const key in temp) {
            if (key === "上级Id") continue;
            if (key === "时间") {
              this.$set(this.proExpForm, key, temp[key].dataValue.split(","));
              if (temp[key].dataValue.split(",")[1] === "当天") {
                this.$set(this.proExpForm, "endDateType", 0);
              } else if (temp[key].dataValue.split(",")[1] === "至今") {
                this.$set(this.proExpForm, "endDateType", 1);
              } else {
                this.$set(this.proExpForm, "endDateType", 2);
              }
            } else {
              this.$set(this.proExpForm, key, temp[key].dataValue);
            }
          }
        }
      }
      this.formScoll("proExpForm");
    },
    handleProExpItemToggle(index) {
      this.$set(this.proExpToggles, index, !this.proExpToggles[index]);
      this.handleRedDot(this.list["职业经历"][index]["上级Id"]);
    },
    handleProExpPostToggle(index, eIndex) {
      this.proExpPostToggles[index][eIndex] = !this.proExpPostToggles[index][
        eIndex
      ];
      this.$forceUpdate();
    },
    async handleSubmitProExpForm() {
      if (!this.proExpForm["单位名称"]) {
        this.$message.error("单位名称不能为空");
        return false;
      }

      if (!this.proExpForm["时间"][0]) {
        this.$message.error("开始时间不能为空");
        return false;
      }
      if (this.proExpForm.endDateType === undefined) {
        this.$message.error("请选择结束时间类型");
        return false;
      } else if (this.proExpForm.endDateType === 2) {
        if (!this.proExpForm["时间"][1]) {
          this.$message.error("请选择结束时间");
          return false;
        }
        if (
          this.proExpForm["时间"][1] !== "" &&
          this.proExpForm["时间"][1] !== null
        ) {
          if (
            new Date(this.proExpForm["时间"][0]).getTime() >
            new Date(this.proExpForm["时间"][1]).getTime()
          ) {
            this.$message.error("时间范围不正确");
            return false;
          }
        }
      }

      delete this.proExpForm.endDateType;
      let payload = {
        职业经历: [{ ...this.proExpForm }]
      };

      payload["职业经历"][0]["时间"] =
        this.proExpForm["时间"][0] +
        (this.proExpForm["时间"][1] !== undefined
          ? this.proExpForm["时间"][1] !== null
            ? "," + this.proExpForm["时间"][1]
            : ""
          : ""); //this.proExpForm["时间"].toString();
      if (this.fileList.length > 0) {
        payload["职业经历"][0]["附件"] = this.fileList
          .map(item => item.url)
          .toString();
      }
      let editArr = [];
      if (this.list["职业经历"]) {
        for (const key in this.list["职业经历"][this.proExpIndex]) {
          if (key === "上级Id" || key === "事件/活动记录" || key === "岗位记录")
            continue;
          editArr.push(key);
        }
      }

      if (editArr.length > 0) {
        // let payloadUpdate = {
        //   updateDataList: []
        // };
        let payloadUpdate = {
          businessNameAuthenticationName: this.proExpForm["教育机构"],
          businessNameAuthenticationTag: this.proExpFormAgent
            .businessNameAuthenticationTag,
          updateDataList: []
        };
        if (
          this.eduForm["教育机构"] ===
          this.proExpFormAgent.businessNameAuthenticationName
        ) {
          delete payloadUpdate.businessNameAuthenticationName;
          delete payloadUpdate.businessNameAuthenticationTag;
        }
        editArr.map(item => {
          if (item !== "事件/活动记录") {
            payloadUpdate.updateDataList.push({
              dataId: this.list["职业经历"][this.proExpIndex][item].dataId,
              dataName: this.list["职业经历"][this.proExpIndex][item].dataName,
              dataValue:
                item === "时间"
                  ? this.proExpForm[item][0] +
                    (this.proExpForm[item][1] !== undefined
                      ? this.proExpForm[item][1] !== null
                        ? "," + this.proExpForm[item][1]
                        : ""
                      : "") //this.proExpForm[item].toString()
                  : item === "附件"
                  ? this.fileList.map(item => item.url).toString()
                  : this.proExpForm[item],
              modifiable: true
            });
            delete payload["职业经历"][0][item];
          }

          // delete payload["非学历教育"][0]['事件/活动记录']
        });
        payloadUpdate.updateDataList["附件"] = this.fileList
          .map(item => item.url)
          .toString();
        await updateWithDataId(payloadUpdate).then(res => {
          // this.proExpForm = {};
          this.fileList = [];
          this.isAddProExp = false;
          this.$message.success("提交成功");
          this.getList();
        });
        // 新增
        let payloadAdd = {
          [this.list["职业经历"][this.proExpIndex]["上级Id"]]: [
            payload["职业经历"][0]
          ]
        };

        for (const key in payloadAdd) {
          payloadAdd[key].map((item, index) => {
            for (const key1 in item) {
              if (item[key1] === "") {
                delete payloadAdd[key][index][key1];
              }
            }
          });
        }
        if (JSON.stringify(payloadAdd[Object.keys(payloadAdd)]) !== "[{}]") {
          if (
            this.proExpForm["单位名称"] ===
            this.proExpFormAgent.businessNameAuthenticationName
          ) {
            delete this.proExpFormAgent.businessNameAuthenticationName;
            delete this.proExpFormAgent.businessNameAuthenticationTag;
          }
          this.proExpFormAgent.jsonObject = payloadAdd;
          updatePersonalInfo(this.proExpFormAgent).then(res => {
            if (res.data.c === 200) {
              this.proExpForm = {};
              this.fileList = [];
              this.isAddProExp = false;
              this.getList();
            }
          });
        }
      } else {
        this.proExpFormAgent.businessNameAuthenticationName =
          payload["职业经历"][0]["单位名称"];
        this.proExpFormAgent.jsonObject = payload;
        updatePersonalInfo(this.proExpFormAgent).then(res => {
          if (res.data.c === 200) {
            this.$message.success("提交成功");
            this.proExpForm = {};
            this.fileList = [];
            this.isAddProExp = false;
            this.getList();
          }
        });
      }
    },
    handleAddProExpEvent(index, key) {
      this.fileList = [];
      if (key === "岗位记录") {
        this.proExpIndex = index;
        this.proExpPostForm = {
          type: "add",
          eventRadio: undefined,
          时间: {
            startDate: undefined,
            endDate: undefined
          },
          岗位名称: {
            dataValue: ""
          },
          内容: {
            dataValue: ""
          },
          附件: ""
        };
      } else {
        this.proExpIndex = index;
        this.proExpEventForm = {
          type: "add",
          eventRadio: undefined,
          时间: {
            startDate: undefined,
            endDate: undefined
          },
          内容: {
            dataValue: ""
          },
          附件: ""
        };
      }
    },
    handleSubmitPostForm(index) {
      if (!this.validateEvent(this.proExpPostForm, true)) return false;

      if (this.proExpPostForm.type === "edit") {
        let payloadEdit = {
          updateDataList: []
        };
        let payloadAdd = {};
        Object.keys(this.proExpPostForm).forEach(key => {
          if (key !== "eventRadio" && key !== "type" && key !== "upId") {
            if (key === "fileList") {
            } else {
              if (
                this.proExpPostForm[key] &&
                this.proExpPostForm[key].dataId !== undefined
              ) {
                if (key === "附件") {
                  payloadEdit.updateDataList.push({
                    dataId: this.proExpPostForm[key].dataId,
                    dataName: this.proExpPostForm[key].dataName,
                    dataValue: this.fileList.map(item => item.url).toString(),
                    modifiable: true
                  });
                } else if (key === "时间") {
                  payloadEdit.updateDataList.push({
                    dataId: this.proExpPostForm[key].dataId,
                    dataName: this.proExpPostForm[key].dataName,
                    // dataValue:
                    //   this.proExpPostForm.eventRadio === 0
                    //     ? this.proExpPostForm[key].startDate +
                    //       "," +
                    //       this.proExpPostForm[key].endDate
                    //     : this.proExpPostForm[key].startDate,
                    dataValue:
                      this.proExpPostForm[key].startDate +
                      "," +
                      this.proExpPostForm[key].endDate,
                    modifiable: true
                  });
                } else {
                  payloadEdit.updateDataList.push({
                    dataId: this.proExpPostForm[key].dataId,
                    dataName: this.proExpPostForm[key].dataName,
                    dataValue: this.proExpPostForm[key].dataValue,
                    modifiable: true
                  });
                }
              } else {
                payloadAdd = {
                  [this.proExpPostForm.upId]: [{}]
                };
                if (key === "附件") {
                  payloadAdd[this.proExpPostForm.upId][0][
                    key
                  ] = this.fileList.map(item => item.url).toString();
                } else if (key === "时间") {
                  payloadAdd[this.proExpPostForm.upId][0][key] =
                    this.proExpPostForm.eventRadio === 0
                      ? this.proExpPostForm[key].startDate +
                        "," +
                        this.proExpPostForm[key].endDate
                      : this.proExpPostForm[key].startDate;
                } else {
                  payloadAdd[this.proExpPostForm.upId][0][
                    key
                  ] = this.proExpPostForm[key].dataValue;
                }
                let v2payloadAdd = {
                  jsonObject: payloadAdd
                };
                if (payloadAdd[this.proExpPostForm.upId][0]["附件"] != "") {
                  updatePersonalInfo(v2payloadAdd);
                }
                // updatePersonalInfo(v2payloadAdd);
              }
            }
          }
        });
        updateWithDataId(payloadEdit).then(res => {
          if (res.data.c === 200) {
            this.$message.success("修改成功");
            this.proExpPostForm = undefined;
            this.getList();
          }
        });
      } else {
        let payload = {
          [this.list["职业经历"][this.proExpIndex]["上级Id"]]: [
            {
              岗位记录: [
                {
                  岗位名称: this.proExpPostForm["岗位名称"].dataValue,
                  内容: this.proExpPostForm["内容"].dataValue,
                  // 时间:
                  // this.proExpPostForm.eventRadio === 0
                  //   ? this.proExpPostForm["时间"].startDate +
                  //     "," +
                  //     this.proExpPostForm["时间"].endDate
                  //   : this.proExpPostForm["时间"].startDate, //`${this.proExpPostForm["时间"].startDate},${this.proExpPostForm["时间"].endDate}`,
                  时间: `${this.proExpPostForm["时间"].startDate},${this.proExpPostForm["时间"].endDate}`,
                  附件: this.fileList.map(item => item.url).toString()
                }
              ]
            }
          ]
        };
        // if (
        //   payload[this.list["职业经历"][this.proExpIndex]["上级Id"]][0][
        //     "岗位记录"
        //   ][0]["内容"] === "" ||
        //   payload[this.list["职业经历"][this.proExpIndex]["上级Id"]][0][
        //     "岗位记录"
        //   ][0]["内容"] === undefined
        // ) {
        //   delete payload[this.list["职业经历"][this.proExpIndex]["上级Id"]][0][
        //     "岗位记录"
        //   ][0]["内容"];
        // }
        // let time = [];
        // payload[this.list["职业经历"][this.proExpIndex]["上级Id"]][0][
        //   "岗位记录"
        // ][0]["时间"]
        //   .split(",")
        //   .map((item, index) => {
        //     if (item !== "undefined" && item !== "") {
        //       time.push(item);
        //     }
        //   });
        // payload[this.list["职业经历"][this.proExpIndex]["上级Id"]][0][
        //   "岗位记录"
        // ][0]["时间"] = time.toString();

        if (
          payload[this.list["职业经历"][this.proExpIndex]["上级Id"]][0][
            "岗位记录"
          ][0]["附件"] === ""
        ) {
          delete payload[this.list["职业经历"][this.proExpIndex]["上级Id"]][0][
            "岗位记录"
          ][0]["附件"];
        }
        let v2payload = {
          jsonObject: payload
        };
        updatePersonalInfo(v2payload).then(res => {
          if (res.data.c === 200) {
            this.proExpPostForm = undefined;
            this.$message.success("提交成功");
            this.getList();
          }
        });
      }
    },
    handleSubmitProExpEventForm(index) {
      if (!this.validateEvent(this.proExpEventForm)) return false;
      if (this.proExpEventForm.type === "edit") {
        let payloadEdit = {
          updateDataList: []
        };
        let payloadAdd = {};
        Object.keys(this.proExpEventForm).forEach(key => {
          if (key !== "eventRadio" && key !== "type" && key !== "upId") {
            if (key === "fileList") {
            } else {
              if (
                this.proExpEventForm[key] &&
                this.proExpEventForm[key].dataId !== undefined
              ) {
                if (key === "附件") {
                  payloadEdit.updateDataList.push({
                    dataId: this.proExpEventForm[key].dataId,
                    dataName: this.proExpEventForm[key].dataName,
                    dataValue: this.fileList.map(item => item.url).toString(),
                    modifiable: true
                  });
                } else if (key === "时间") {
                  payloadEdit.updateDataList.push({
                    dataId: this.proExpEventForm[key].dataId,
                    dataName: this.proExpEventForm[key].dataName,
                    // dataValue:
                    //   this.proExpEventForm.eventRadio === 0
                    //     ? this.proExpEventForm[key].startDate +
                    //       "," +
                    //       this.proExpEventForm[key].endDate
                    //     : this.proExpEventForm[key].startDate,
                    dataValue:
                      this.proExpEventForm[key].startDate +
                      "," +
                      this.proExpEventForm[key].endDate,
                    modifiable: true
                  });
                } else {
                  payloadEdit.updateDataList.push({
                    dataId: this.proExpEventForm[key].dataId,
                    dataName: this.proExpEventForm[key].dataName,
                    dataValue: this.proExpEventForm[key].dataValue,
                    modifiable: true
                  });
                }
              } else {
                payloadAdd = {
                  [this.proExpEventForm.upId]: [{}]
                };
                if (key === "附件") {
                  payloadAdd[this.proExpEventForm.upId][0][
                    key
                  ] = this.fileList.map(item => item.url).toString();
                } else if (key === "时间") {
                  payloadAdd[this.proExpEventForm.upId][0][key] =
                    this.proExpEventForm.eventRadio === 0
                      ? this.proExpEventForm[key].startDate +
                        "," +
                        this.proExpEventForm[key].endDate
                      : this.proExpEventForm[key].startDate;
                } else {
                  payloadAdd[this.proExpEventForm.upId][0][
                    key
                  ] = this.proExpEventForm[key].dataValue;
                }
                let v2payloadAdd = {
                  jsonObject: payloadAdd
                };
                if (payloadAdd[this.proExpEventForm.upId][0]["附件"] != "") {
                  updatePersonalInfo(v2payloadAdd);
                }
                // updatePersonalInfo(payloadAdd);
              }
            }
          }
        });
        updateWithDataId(payloadEdit).then(res => {
          if (res.data.c === 200) {
            this.$message.success("修改成功");
            this.proExpEventForm = undefined;
            this.getList();
          }
        });
      } else {
        let payload = {
          [this.list["职业经历"][this.proExpIndex]["上级Id"]]: [
            {
              "事件/活动记录": [
                {
                  内容: this.proExpEventForm["内容"].dataValue,
                  // 时间:
                  //   this.proExpEventForm.eventRadio === 0
                  //     ? this.proExpEventForm["时间"].startDate +
                  //       "," +
                  //       this.proExpEventForm["时间"].endDate
                  //     : this.proExpEventForm["时间"].startDate, //`${this.proExpEventForm["时间"].startDate},${this.proExpEventForm["时间"].endDate}`,
                  时间: `${this.proExpEventForm["时间"].startDate},${this.proExpEventForm["时间"].endDate}`,
                  附件: this.fileList.map(item => item.url).toString()
                }
              ]
            }
          ]
        };
        // if (
        //   payload[this.list["职业经历"][this.proExpIndex]["上级Id"]][0][
        //     "事件/活动记录"
        //   ][0]["内容"] === "" ||
        //   payload[this.list["职业经历"][this.proExpIndex]["上级Id"]][0][
        //     "事件/活动记录"
        //   ][0]["内容"] === undefined
        // ) {
        //   delete payload[this.list["职业经历"][this.proExpIndex]["上级Id"]][0][
        //     "事件/活动记录"
        //   ][0]["内容"];
        // }
        // let time = [];
        // payload[this.list["职业经历"][this.proExpIndex]["上级Id"]][0][
        //   "事件/活动记录"
        // ][0]["时间"]
        //   .split(",")
        //   .map((item, index) => {
        //     if (item !== "undefined" && item !== "") {
        //       time.push(item);
        //     }
        //   });
        // payload[this.list["职业经历"][this.proExpIndex]["上级Id"]][0][
        //   "事件/活动记录"
        // ][0]["时间"] = time.toString();

        if (
          payload[this.list["职业经历"][this.proExpIndex]["上级Id"]][0][
            "事件/活动记录"
          ][0]["附件"] === ""
        ) {
          delete payload[this.list["职业经历"][this.proExpIndex]["上级Id"]][0][
            "事件/活动记录"
          ][0]["附件"];
        }
        let v2payload = {
          jsonObject: payload
        };
        updatePersonalInfo(v2payload).then(res => {
          if (res.data.c === 200) {
            this.proExpEventForm = undefined;
            this.$message.success("提交成功");
            this.getList();
          }
        });
      }
    },
    // 社会
    // handleAddSocialForm(type, index) {
    //   this.isAddSocial = true;
    //   this.socialEventForm = {
    //     时间: {
    //       startDate: undefined,
    //       endDate: undefined
    //     },

    //     附件: "",
    //     事件描述: "",
    //     eventRadio: 0
    //   };
    // },
    handleSocialItemToggle(index) {
      this.$set(this.socialToggles, index, !this.socialToggles[index]);
    },

    handleAddSocialEvent(key) {
      if (!this.isPromised()) {
        return false;
      }
      this.toggle["社会活动经历"] = true;
      this.isAddSocial = true;
      this.fileList = [];
      this.socialEventForm = {
        type: "add",
        eventRadio: undefined,
        时间: {
          startDate: undefined,
          endDate: undefined
        },
        内容: {
          dataValue: ""
        },
        附件: ""
      };
      this.formScoll("socialForm");
    },

    handleSubmitSocialEventForm() {
      if (!this.validateEvent(this.socialEventForm)) return false;
      if (this.socialEventForm.type === "edit") {
        let payloadEdit = {
          updateDataList: []
        };
        let payloadAdd = {};
        Object.keys(this.socialEventForm).forEach(key => {
          if (key !== "eventRadio" && key !== "type" && key !== "upId") {
            if (key === "fileList") {
            } else {
              if (
                this.socialEventForm[key] &&
                this.socialEventForm[key].dataId !== undefined
              ) {
                if (key === "附件") {
                  payloadEdit.updateDataList.push({
                    dataId: this.socialEventForm[key].dataId,
                    dataName: this.socialEventForm[key].dataName,
                    dataValue: this.fileList.map(item => item.url).toString(),
                    modifiable: true
                  });
                } else if (key === "时间") {
                  payloadEdit.updateDataList.push({
                    dataId: this.socialEventForm[key].dataId,
                    dataName: this.socialEventForm[key].dataName,
                    // dataValue:
                    //   this.socialEventForm.eventRadio === 0
                    //     ? this.socialEventForm[key].startDate +
                    //       "," +
                    //       this.socialEventForm[key].endDate
                    //     : this.socialEventForm[key].startDate,
                    dataValue:
                      this.socialEventForm[key].startDate +
                      "," +
                      this.socialEventForm[key].endDate,
                    modifiable: true
                  });
                } else {
                  payloadEdit.updateDataList.push({
                    dataId: this.socialEventForm[key].dataId,
                    dataName: this.socialEventForm[key].dataName,
                    dataValue: this.socialEventForm[key].dataValue,
                    modifiable: true
                  });
                }
              } else {
                payloadAdd = {
                  [this.socialEventForm.upId]: [{}]
                };
                if (key === "附件") {
                  payloadAdd[this.socialEventForm.upId][0][
                    key
                  ] = this.fileList.map(item => item.url).toString();
                } else if (key === "时间") {
                  payloadAdd[this.socialEventForm.upId][0][key] =
                    this.socialEventForm.eventRadio === 0
                      ? this.socialEventForm[key].startDate +
                        "," +
                        this.socialEventForm[key].endDate
                      : this.socialEventForm[key].startDate;
                } else {
                  payloadAdd[this.socialEventForm.upId][0][
                    key
                  ] = this.socialEventForm[key].dataValue;
                }
                let v2payloadAdd = {
                  jsonObject: payloadAdd
                };
                // if (JSON.stringify(payloadAdd[Object.keys(payloadAdd)]) !== "[{}]") {
                // console.log(this.socialEventForm);
                if (payloadAdd[this.socialEventForm.upId][0]["附件"] != "") {
                  updatePersonalInfo(v2payloadAdd);
                }
              }
            }
          }
        });

        updateWithDataId(payloadEdit).then(res => {
          if (res.data.c === 200) {
            this.$message.success("修改成功");
            this.socialEventForm = undefined;
            this.getList();
          }
        });
      } else {
        let payload = {};
        if (this.list["社会活动经历"]) {
          // 0->1
          payload = {
            jsonObject: {
              [this.list["社会活动经历"][this.socialIndex]["上级Id"]]: [
                {
                  "事件/活动记录": [
                    {
                      内容: this.socialEventForm["内容"].dataValue,
                      // 时间:
                      //   this.socialEventForm.eventRadio === 0
                      //     ? this.socialEventForm["时间"].startDate +
                      //       "," +
                      //       this.socialEventForm["时间"].endDate
                      //     : this.socialEventForm["时间"].startDate, //`${this.socialEventForm["时间"].startDate},${this.socialEventForm["时间"].endDate}`,
                      时间: `${this.socialEventForm["时间"].startDate},${this.socialEventForm["时间"].endDate}`,
                      附件: this.fileList.map(item => item.url).toString()
                    }
                  ]
                }
              ]
            }
          };
        } else {
          // 1->n
          payload = {
            jsonObject: {
              ["社会活动经历"]: [
                {
                  "事件/活动记录": [
                    {
                      内容: this.socialEventForm["内容"].dataValue,
                      时间:
                        this.socialEventForm.eventRadio === 0
                          ? this.socialEventForm["时间"].startDate +
                            "," +
                            this.socialEventForm["时间"].endDate
                          : this.socialEventForm["时间"].startDate, //`${this.socialEventForm["时间"].startDate},${this.socialEventForm["时间"].endDate}`,
                      附件: this.fileList.map(item => item.url).toString()
                    }
                  ]
                }
              ]
            }
          };
        }
        // if (
        //   payload[this.list["社会活动经历"][this.socialIndex]["上级Id"]][0][
        //     "事件/活动记录"
        //   ][0]["内容"] === "" ||
        //   payload[this.list["社会活动经历"][this.socialIndex]["上级Id"]][0][
        //     "事件/活动记录"
        //   ][0]["内容"] === undefined
        // ) {
        //   delete payload[
        //     this.list["社会活动经历"][this.socialIndex]["上级Id"]
        //   ][0]["事件/活动记录"][0]["内容"];
        // }
        // let time = [];
        // payload[this.list["社会活动经历"][this.socialIndex]["上级Id"]][0][
        //   "事件/活动记录"
        // ][0]["时间"]
        //   .split(",")
        //   .map((item, index) => {
        //     if (item !== "undefined" && item !== "") {
        //       time.push(item);
        //     }
        //   });
        // payload[this.list["社会活动经历"][this.socialIndex]["上级Id"]][0][
        //   "事件/活动记录"
        // ][0]["时间"] = time.toString();

        // if (
        //   payload[this.list["社会活动经历"][0]['事件/活动记录'][this.socialIndex]["上级Id"]][0][
        //     "事件/活动记录"
        //   ][0]["附件"] === ""
        // ) {
        //   delete payload[
        //     this.list["社会活动经历"][0][this.socialIndex]["上级Id"]
        //   ][0]["事件/活动记录"][this.socialIndex]["附件"];
        // }
        // console.log(payload);
        // if (JSON.stringify(payload[Object.keys(payload)]) !== "[{}]") {
        updatePersonalInfo(payload).then(res => {
          if (res.data.c === 200) {
            this.socialEventForm = undefined;
            this.getList();
          }
        });
        // }
      }
    },
    handleCloseAddEdu() {
      this.isAddEdu = false;
      this.fileList = [];
    },
    // ------------------------------------------
    handleCloseAddNoEdu() {
      this.isAddNoEdu = false;
      this.fileList = [];
    },
    handleCloseEventForm() {
      this.isAddSocial = false;
      this.eduEventForm = undefined;
      this.noEduEventForm = undefined;
      this.proExpEventForm = undefined;
      this.socialEventForm = undefined;
      this.proExpPostForm = undefined;
      this.fileList = [];
    },

    handleRemove() {},
    beforeRemove() {},
    handleExceed() {},

    async handleUploadChange(file, fileList) {
      let fd = new FormData();
      let fileObj = {
        name: file.name,
        url: ""
      };
      fd.append("file", file.raw);
      fd.append("uploadType", "PC");
      await upload(fd).then(res => {
        fileObj.url = res.data.d;
        this.fileList.push(fileObj);
      });
    },
    handleRemoveFile(index) {
      this.fileList.splice(index, 1);
    },

    async handleEventUploadChange(file, index) {
      let fd = new FormData();
      let fileObj = {
        name: file.name,
        url: ""
      };
      fd.append("file", file.raw);
      fd.append("uploadType", "PC");
      await upload(fd).then(res => {
        fileObj.url = res.data.d;
        this.fileList.push(fileObj);
      });
    },

    handleEventRadioChange(val) {
      this.eventRadio = val;
    },

    doSomething(val) {
      this.$forceUpdate();
    },

    handleGenerateReport() {
      this.isSelect = !this.isSelect;
      this.isCheckAll = false;
      this.checkList = JSON.parse(JSON.stringify(this.originCheckList));
      this.$nextTick(() => {
        this.$scrollTo("#personalServer", 500, {
          offset: 0
        });
      });
    },

    handleCheckAll(isChecked, key1, key2, arrIndex) {
      this.$forceUpdate();
      let filterMap = ["checkAll", "indeterminate", "checked"];
      if (
        key1 === "学历教育" ||
        key1 === "非学历教育" ||
        key1 === "职业经历" ||
        key1 === "社会活动经历"
      ) {
        if (key2 === "事件/活动记录" || key2 === "岗位记录") {
          // this.checkList[key1].value[arrIndex][key2].value.map(eventChecked => {
          //   eventChecked[Object.keys(eventChecked)] = isChecked;
          // });
          this.checkList[key1].value[arrIndex][key2].value.map(
            (eventChecked, eventIndex) => {
              if (
                !this.list[key1][arrIndex][key2][eventIndex]["时间"].deleteTag
              ) {
                eventChecked[Object.keys(eventChecked)] = isChecked;
              }
            }
          );
          this.checkHalf(key1, key2, arrIndex);
          this.checkList[key1].value[arrIndex][key2].checkAll = isChecked;
          this.checkList[key1].value[arrIndex][key2].indeterminate = false;
        } else {
          if (key2 === undefined && arrIndex === undefined) {
            this.checkList[key1].checkAll = isChecked;
            this.checkList[key1].indeterminate = false;

            this.checkList[key1].value &&
              this.checkList[key1].value.map((item, index) => {
                if (key1 === "社会活动经历") {
                  item["事件/活动记录"].value.map((eItem, eIndex) => {
                    if (
                      !this.list[key1][index]["事件/活动记录"][eIndex]["时间"]
                        .deleteTag
                    ) {
                      item.checkAll = isChecked;
                      item.indeterminate = false;
                      Object.keys(item).forEach(key => {
                        if (filterMap.indexOf(key) === -1) {
                          item[key].checkAll = isChecked;
                          item[key].value.map((event, eIndex) => {
                            if (
                              !this.list[key1][0]["事件/活动记录"][eIndex][
                                "时间"
                              ].deleteTag
                            )
                              event[Object.keys(event)] = isChecked;
                          });
                        }
                      });
                    }
                  });
                } else {
                  if (!this.list[key1][index]["时间"].deleteTag) {
                    item.checkAll = isChecked;
                    item.indeterminate = false;
                    Object.keys(item).forEach(key => {
                      if (filterMap.indexOf(key) === -1) {
                        if (key !== "事件/活动记录" && key !== "岗位记录") {
                          item[key][
                            this.list[key1][index][key].dataId
                          ] = isChecked;
                        } else {
                          item[key].checkAll = isChecked;
                          // item[key].value.map(event => {
                          //   event[Object.keys(event)] = isChecked;
                          // });
                          item[key].value.map((event, eventIndex) => {
                            if (
                              !this.list[key1][index][key][eventIndex]["时间"]
                                .deleteTag
                            ) {
                              event[Object.keys(event)] = isChecked;
                            }
                          });
                        }
                      }
                    });
                  }
                }
              });
          } else {
            this.checkList[key1].value[arrIndex].indeterminate = false;
            let max = this.checkList[key1].value.filter(
              (item, index) => this.list[key1][index]["时间"].deleteTag !== true
            ).length;
            let checkedCount = this.checkList[key1].value.filter(
              item => item.checkAll === true
            ).length;
            Object.keys(this.checkList[key1].value[arrIndex]).forEach(key => {
              if (filterMap.indexOf(key) === -1) {
                if (key !== "事件/活动记录" && key !== "岗位记录") {
                  this.checkList[key1].value[arrIndex][key][
                    this.list[key1][arrIndex][key].dataId
                  ] = isChecked;
                } else {
                  this.checkList[key1].value[arrIndex][
                    key
                  ].checkAll = isChecked;
                  // this.checkList[key1].value[arrIndex][key].value.map(event => {
                  //   event[Object.keys(event)] = isChecked;
                  // });
                  this.checkList[key1].value[arrIndex][key].value.map(
                    (event, eventIndex) => {
                      // console.log(event,eventIndex,this.list[key1][arrIndex],this.list[key1][arrIndex][key][eventIndex][
                      //     "时间"
                      //   ].deleteTag);
                      if (
                        !this.list[key1][arrIndex][key][eventIndex]["时间"]
                          .deleteTag
                      ) {
                        event[Object.keys(event)] = isChecked;
                      }
                    }
                  );
                }
              }
            });
            // let max = this.checkList[key1].value.length;
            // let checkedCount = this.checkList[key1].value.filter(
            //   item => item.checkAll === true
            // ).length;
            console.log(max, checkedCount);
            this.checkList[key1].checkAll = checkedCount === max;
            this.checkList[key1].indeterminate =
              checkedCount > 0 && checkedCount < max;
          }
        }
      } else {
        if (key2 === undefined) {
          this.list[key1].checkAll = isChecked;
          this.list[key1].checked = isChecked;
          this.checkList[key1].indeterminate = false;

          Object.keys(this.checkList[key1]).forEach(key => {
            if (
              key1 === "学历教育" ||
              key1 === "非学历教育" ||
              key1 === "职业经历"
            ) {
            } else {
              if (filterMap.indexOf(key) === -1 && key !== "上级Id") {
                if (this.checkList[key1][key].value !== undefined) {
                  // 多个
                  if (Array.isArray(this.list[key1][key])) {
                    if (key === "手机号码") {
                      this.list[key1][key]
                        .filter(item => item["值"].phoneExpireTag !== true)
                        .map(ite => {
                          this.checkList[key1][key].value.map(obj => {
                            Object.keys(obj).forEach(k => {
                              if (ite["值"].dataId === k) {
                                obj[k] = isChecked;
                                this.checkList[key1][key].indeterminate = false;
                                this.checkList[key1][key].checkAll = isChecked;
                              }
                            });
                          });
                        });
                    } else {
                      this.list[key1][key]
                        .filter(item => item["值"].deleteTag !== true)
                        .map(ite => {
                          this.checkList[key1][key].value.map(obj => {
                            Object.keys(obj).forEach(k => {
                              if (ite["值"].dataId === k) {
                                obj[k] = isChecked;
                                this.checkList[key1][key].indeterminate = false;
                                this.checkList[key1][key].checkAll = isChecked;
                              }
                            });
                          });
                        });
                    }
                  } else {
                    if (this.list[key1][key]) {
                      this.checkList[key1][key][
                        this.list[key1][key].dataId
                      ] = isChecked;
                    }
                  }
                } else {
                  if (key1 === "社会活动经历") {
                    this.checkList[key1].value[0]["事件/活动记录"].value.map(
                      item => {
                        item[Object.keys(item)] = isChecked;
                      }
                    );
                  } else {
                    this.checkList[key1][key][
                      this.list[key1][key].dataId
                    ] = isChecked;
                    this.checkList[key1][key].checkAll = isChecked;
                    this.checkList[key1][key].indeterminate = false;
                  }
                }
              }
            }
          });
        } else {
          if (Array.isArray(this.list[key1][key2])) {
            if (key2 === "手机号码") {
              this.list[key1][key2]
                .filter(item => item["值"].phoneExpireTag !== true)
                .map(ite => {
                  this.checkList[key1][key2].value.map(obj => {
                    Object.keys(obj).forEach(k => {
                      if (ite["值"].dataId === k) {
                        obj[k] = isChecked;
                        this.checkList[key1][key2].indeterminate = false;
                      }
                    });
                  });
                });
            } else {
              this.list[key1][key2]
                .filter(item => item["值"].deleteTag !== true)
                .map(ite => {
                  this.checkList[key1][key2].value.map(obj => {
                    Object.keys(obj).forEach(k => {
                      if (ite["值"].dataId === k) {
                        obj[k] = isChecked;
                        this.checkList[key1][key2].indeterminate = false;
                      }
                    });
                  });
                });
            }

            // this.list[key1][key2]
            // .filter(item => item["值"].phoneExpireTag !== true)
            // .map(ite => {
            //   this.checkList[key1][key2].value.map(obj => {
            //     Object.keys(obj).forEach(k => {
            //       if (ite["值"].dataId === k) {
            //         obj[k] = isChecked;
            //         this.checkList[key1][key2].indeterminate = false;
            //       }
            //     });
            //   });
            // });
          } else {
            this.checkList[key1][key2][
              this.list[key1][key2].dataId
            ] = isChecked;
          }
          this.checkHalf(key1, key2);
        }
      }
    },
    handleSelectAllIds(flag) {
      this.checkList["基础信息"].checkAll = flag;
      this.checkList["基础信息"].indeterminate = false;
      this.handleCheckAll(flag, "基础信息");
      this.handleCheckAll(flag, "学历教育");
      this.handleCheckAll(flag, "非学历教育");
      this.handleCheckAll(flag, "职业经历");
      this.handleCheckAll(flag, "社会活动经历");
    },
    // checkHalf1(){

    // },
    checkHalf(key1, key2, index) {
      console.log("checkHalf");
      const { checkList, list } = this;
      let max = 0;
      let checkedCount = 0;
      let filterMap = ["checked", "checkAll", "indeterminate"];
      let listMax = 0;
      let listCheckedCount = 0;
      let filterKey = ["手机号码", "电子邮箱", "通信地址", "座机号码"];
      if (key1 === "基础信息") {
        if (filterKey.indexOf(key2) > -1) {
          if (key2 === "手机号码") {
            listMax = list[key1][key2].filter(
              item => !item["值"].phoneExpireTag
            ).length;
            listCheckedCount = checkList[key1][key2].value.filter(
              item => item[Object.keys(item)] === true
            ).length;
          } else {
            listMax = list[key1][key2].filter(item => !item["值"].deleteTag)
              .length;
            listCheckedCount = checkList[key1][key2].value.filter(
              item => item[Object.keys(item)] === true
            ).length;
          }
          checkList[key1][key2].checkAll = listCheckedCount === listMax;
          checkList[key1][key2].indeterminate =
            listCheckedCount > 0 && listCheckedCount < listMax;
        } else {
          checkList[key1][key2].checkAll =
            checkList[key1][key2][list[key1][key2].dataId];
        }
        Object.keys(checkList[key1]).forEach(key => {
          if (filterMap.indexOf(key) === -1) {
            if (checkList[key1][key].value) {
              if (list[key1][key]) {
              }
              list[key1][key] &&
                list[key1][key].map((item, index) => {
                  if (!item["值"].deleteTag) {
                    max++;
                  }
                  if (item["值"].phoneExpireTag) {
                    max--;
                  }
                  if (checkList[key1][key].value[index][item["值"].dataId]) {
                    checkedCount++;
                  }
                });
            } else {
              max++;
              if (checkList[key1][key][list[key1][key].dataId] === true) {
                checkedCount++;
              }
            }
          }
        });
        console.log(max, checkedCount);
        checkList[key1].checkAll = checkedCount === max;
        checkList[key1].indeterminate = checkedCount > 0 && checkedCount < max;
      } else {
        if (key1 !== "社会活动经历") {
          Object.keys(checkList[key1].value[index]).forEach(key => {
            if (filterMap.indexOf(key) === -1) {
              if (checkList[key1].value[index][key].value) {
                listMax = 0;
                listCheckedCount = 0;
                checkList[key1].value[index][key].value.map((eItem, eIndex) => {
                  if (!this.list[key1][index][key][eIndex]["时间"].deleteTag) {
                    max++;
                    if (key2 === "事件/活动记录" || key2 === "岗位记录") {
                      listMax++;
                    }
                  }
                  if (eItem[Object.keys(eItem)] === true) {
                    checkedCount++;
                    if (key === key2) {
                      listCheckedCount++;
                    }
                  }
                  if (key === key2) {
                    checkList[key1].value[index][key2 || key].checkAll =
                      key2 === undefined
                        ? checkList[key1].value[index].checkAll
                        : listCheckedCount === listMax;
                    checkList[key1].value[index][key2 || key].indeterminate =
                      listCheckedCount > 0 && listCheckedCount < listMax;
                  }
                });
              } else {
                max++;
                if (
                  checkList[key1].value[index][key][
                    Object.keys(checkList[key1].value[index][key])
                  ] === true
                ) {
                  checkedCount++;
                }
              }
            }
          });

          // 2层
          checkList[key1].value[index].checkAll = checkedCount === max;
          checkList[key1].value[index].indeterminate =
            checkedCount > 0 && checkedCount < max;
          // 1层
          let lmax = 0;
          let lcheckedCount = 0;

          checkList[key1].value.map((item, index) => {
            if (!list[key1][index]["时间"].deleteTag) {
              // lmax++;
              // console.log(lmax);
              // if (item.checkAll) {
              //   lcheckedCount++;
              //   console.log(lcheckedCount);
              // }
              Object.keys(item).forEach(key => {
                if (filterMap.indexOf(key) === -1) {
                  if (key === "事件/活动记录" || key === "岗位记录") {
                    console.log("#", item[key]);
                    item[key].value.map((eItem, eIndex) => {
                      if (
                        !this.list[key1][index][key][eIndex]["时间"].deleteTag
                      ) {
                        lmax++;
                        if (eItem[Object.keys(eItem)]) {
                          lcheckedCount++;
                        }
                      }
                    });
                  } else {
                    console.log("##", item[key]);
                    lmax++;
                    if (item[key][Object.keys(item[key])]) {
                      lcheckedCount++;
                    }
                    // if(item[Object.keys(item)])
                  }
                }
              });
            }
          });
          // checkList[key1].value.map(item=>{
          //   if(item.checkAll!==false&&item.indeterminate!==false){
          //     lmax++
          //   }
          // })
          console.log(lmax, lcheckedCount);
          checkList[key1].checkAll = lcheckedCount === lmax;
          checkList[key1].indeterminate =
            lcheckedCount > 0 && lcheckedCount < lmax;
        } else {
          Object.keys(this.checkList[key1].value[0]).forEach(key => {
            if (key === "事件/活动记录") {
              this.checkList[key1].value[0][key].value.map((eItem, eIndex) => {
                if (!this.list[key1][0][key][eIndex]["时间"].deleteTag) {
                  max++;
                  if (eItem[Object.keys(eItem)] === true) {
                    checkedCount++;
                  }
                }
              });
            }
          });

          this.checkList[key1].checkAll = checkedCount === max;
          this.checkList[key1].indeterminate =
            checkedCount > 0 && checkedCount < max;
        }
      }
    },
    handleCheckedChange(isChecked, key1, key2, arrIndex) {
      this.$forceUpdate();
      this.checkHalf(key1, key2, arrIndex);
    },
    // handleSelectReportChange(isChecked, key1, key2, val, index) {
    //   let filters = ["手机号码", "座机号码", "通信地址", "电子邮箱"];
    //   if (isChecked) {
    //     this.checkboxTree[key1][key2].checked = true;
    //     if (key1 === "基础信息") {
    //       if (filters.indexOf(key2) > -1) {
    //         this.checkList[key1][key2].push({
    //           [val]: true
    //         });
    //       } else {
    //         this.checkList[key1][key2] = val;
    //       }
    //     }
    //   } else {
    //     this.checkboxTree[key1][key2].checked = false;
    //     if (key1 === "基础信息") {
    //       if (filters.indexOf(key2) > -1) {
    //         this.checkList[key1][key2].splice(
    //           this.checkList[key1][key2].findIndex(item => item === val),
    //           1
    //         );
    //       } else {
    //         delete this.checkList[key1][key2];
    //       }
    //     }
    //   }
    // },
    handleSelectAllChange(isChecked, key1, key2) {
      if (isChecked) {
        this.checkList[key1][key2] = this.list[key1][key2].dataId;
      } else {
        delete this.checkList[key1][key2];
      }
    },
    handleSubmitSelectIds() {
      const now = new Date();
      this.reportFormDefaultName =
        now.getFullYear() +
        "" +
        (now.getMonth() + 1 < 10
          ? "0" + (now.getMonth() + 1)
          : now.getMonth() + 1) +
        "" +
        (now.getDate() < 10 ? "0" + now.getDate() : now.getDate()) +
        "" +
        (now.getHours() < 10 ? "0" + now.getHours() : now.getHours()) +
        (now.getMinutes() < 10 ? "0" + now.getMinutes() : now.getMinutes()) +
        (now.getSeconds() < 10 ? "0" + now.getSeconds() : now.getSeconds());
      let filterMap = ["checkAll", "indeterminate", "checked"];
      let ids = [];
      Object.keys(this.checkList).forEach(key1 => {
        Object.keys(this.checkList[key1]).forEach(key2 => {
          if (filterMap.indexOf(key2) === -1) {
            if (Array.isArray(this.checkList[key1][key2])) {
              // 2-5
              this.checkList[key1][key2].map(item => {
                Object.keys(item).forEach(key => {
                  if (filterMap.indexOf(key) === -1) {
                    if (item[key].value !== undefined) {
                      item[key].value.map(ite => {
                        if (ite[Object.keys(ite)]) {
                          Object.keys(ite)
                            .toString()
                            .split(",")
                            .map(v => {
                              ids.push(v);
                            });
                        }
                      });
                    } else {
                      if (item[key][Object.keys(item[key])]) {
                        ids.push(Object.keys(item[key]).toString());
                      }
                    }
                  }
                });
              });
            } else {
              // 1 基础信息
              Object.keys(this.checkList[key1][key2]).forEach(biKey => {
                if (filterMap.indexOf(biKey) === -1) {
                  if (Array.isArray(this.checkList[key1][key2][biKey])) {
                    this.checkList[key1][key2][biKey].map(item => {
                      if (item[Object.keys(item)] === true) {
                        ids.push(Object.keys(item).toString());
                      }
                    });
                  } else {
                    if (this.checkList[key1][key2][biKey]) {
                      ids.push(biKey);
                    }
                  }
                }
              });
            }
          }
        });
      });
      this.reportForm = {
        dataIds: ids,
        name: "",
        remark: ""
      };
      if (ids.length > 0) {
        this.dialogReportForm = true;
      } else {
        this.$message.error("至少需要勾选一条信息");
      }
    },
    handlePreview() {
      let previewData = {};
      let filterMap = ["checkAll", "indeterminate", "checked"];
      let ids = [];

      Object.keys(this.checkList).forEach(key1 => {
        previewData[key1] = {};
        Object.keys(this.checkList[key1]).forEach(key2 => {
          previewData[key1][key2] = {};
          if (filterMap.indexOf(key2) === -1) {
            if (Array.isArray(this.checkList[key1][key2])) {
              // 2-5
              this.checkList[key1][key2].map(item => {
                Object.keys(item).forEach(key => {
                  if (filterMap.indexOf(key) === -1) {
                    if (item[key].value !== undefined) {
                      item[key].value.map(ite => {
                        if (ite[Object.keys(ite)]) {
                          Object.keys(ite)
                            .toString()
                            .split(",")
                            .map(v => {
                              ids.push(v);
                            });
                        }
                      });
                    } else {
                      if (item[key][Object.keys(item[key])]) {
                        ids.push(Object.keys(item[key]).toString());
                      }
                    }
                  }
                });
              });
            } else {
              // 1 基础信息
              Object.keys(this.checkList[key1][key2]).forEach(biKey => {
                if (filterMap.indexOf(biKey) === -1) {
                  if (Array.isArray(this.checkList[key1][key2][biKey])) {
                    this.checkList[key1][key2][biKey].map(item => {
                      if (item[Object.keys(item)] === true) {
                        ids.push(Object.keys(item).toString());
                      }
                    });
                  } else {
                    if (this.checkList[key1][key2][biKey]) {
                      ids.push(biKey);
                    }
                  }
                }
              });
            }
          }
        });
      });
      if (ids.length > 0) {
        reportPreview({ dataIds: ids }).then(res => {
          localStorage.setItem("reportView", JSON.stringify(res.data.d));
          let routeData = this.$router.resolve({
            path: "/reportPreview",
            query: { type: 0, active: 1 }
          });
          window.open(routeData.href, "_blank");
        });
      } else {
        this.$message.error("至少需要勾选一条信息");
      }
    },
    handleSubmitReportForm() {
      let payload = Object.assign({}, this.reportForm);

      if (payload.name === "") {
        payload.name = this.reportFormDefaultName;
      }

      reportSave(payload).then(res => {
        if (res.data.c === 200) {
          this.isSelect = false;
          this.$message.success("生成个人信息报告成功");
          this.dialogReportForm = false;
          this.$router.push("/personal/report/list");
        }
      });
    },
    handleCorrigendum(id) {
      // this.$router.push("corrigendum?id=" + dataId);
      let routeData = this.$router.resolve({
        path: "/personal/corrigendum",
        query: { id }
      });
      window.open(routeData.href, "_blank");
    },
    handleAddEduEvent(index) {
      this.eduIndex = index;
      this.fileList = [];
      this.eduEventForm = {
        type: "add",
        eventRadio: undefined,
        时间: {
          startDate: undefined,
          endDate: undefined
        },
        内容: {
          dataValue: ""
        },
        附件: ""
      };
    },
    handleEditSocial(row, upId, index) {
      this.socialIndex = index;
      let tempData = JSON.parse(JSON.stringify(row));
      this.fileList = [];
      this.socialEventForm = {
        内容: { dataId: undefined, dataValue: "" },
        时间: { dataId: undefined, dataValue: "" },
        附件: { dataId: undefined, dataValue: "" },
        eventRadio: 0,
        upId,
        type: "edit"
      };
      if (tempData["时间"].dataValue.split(",")[1] === "当天") {
        this.socialEventForm.eventRadio = 0;
      } else if (tempData["时间"].dataValue.split(",")[1] === "至今") {
        this.socialEventForm.eventRadio = 1;
      } else {
        this.socialEventForm.eventRadio = 2;
      }
      if (tempData["附件"]) {
        this.fileList = tempData["附件"].dataValue.split(",").map(item => {
          return { name: item.split(":")[2], url: item };
        });
      }
      Object.keys(tempData).forEach(key => {
        if (key === "上级Id") {
        } else if (key === "时间") {
          this.socialEventForm[key] = {
            dataId: tempData[key].dataId,
            dataName: tempData[key].dataName,
            dataValue: tempData[key].dataValue,
            startDate: tempData["时间"]
              ? tempData["时间"].dataValue.split(",")[0]
              : undefined,
            endDate: tempData["时间"]
              ? tempData["时间"].dataValue.split(",")[1]
              : undefined
          };
        } else {
          this.socialEventForm[key] = tempData[key];
        }
      });
      this.formScoll("socialForm");
    },
    handleEditEvent(row, upId, index) {
      console.log(row);
      this.eduIndex = index;
      let tempData = JSON.parse(JSON.stringify(row));
      this.fileList = [];
      this.eduEventForm = {
        内容: { dataId: undefined, dataValue: "" },
        时间: { dataId: undefined, dataValue: "" },
        附件: { dataId: undefined, dataValue: "" },
        eventRadio: 0,
        upId,
        type: "edit"
      };
      if (tempData["时间"].dataValue.split(",")[1] === "当天") {
        this.eduEventForm.eventRadio = 0;
      } else if (tempData["时间"].dataValue.split(",")[1] === "至今") {
        this.eduEventForm.eventRadio = 1;
      } else {
        this.eduEventForm.eventRadio = 2;
      }
      if (tempData["附件"]) {
        this.fileList = tempData["附件"].dataValue.split(",").map(item => {
          return { name: item.split(":")[2], url: item };
        });
      }
      Object.keys(tempData).forEach(key => {
        if (key === "上级Id") {
        } else if (key === "时间") {
          this.eduEventForm[key] = {
            dataId: tempData[key].dataId,
            dataName: tempData[key].dataName,
            dataValue: tempData[key].dataValue,
            startDate: tempData["时间"]
              ? tempData["时间"].dataValue.split(",")[0]
              : undefined,
            // endDate: tempData["时间"]
            //   ? tempData["时间"].dataValue.split(",")[1]
            //   : undefined
            endDate: tempData["时间"].dataValue.split(",")[1]
          };
        } else {
          this.eduEventForm[key] = tempData[key];
        }
      });
      this.formScoll("eduEventForm");
    },
    validateEvent(form, isPost) {
      let flag = true;
      // if (form.eventRadio === 0) {
      //   if (!form["时间"].startDate) {
      //     this.$message.error("开始时间不能为空");
      //     flag = false;
      //     return;
      //   }
      //   if (!form["时间"].endDate) {
      //     this.$message.error("结束时间不能为空");
      //     flag = false;
      //     return;
      //   }
      //   if (
      //     new Date(form["时间"].startDate).getTime() >
      //     new Date(form["时间"].endDate).getTime()
      //   ) {
      //     this.$message.error("时间范围不正确");
      //     flag = false;
      //     return;
      //   }
      // } else {
      //   if (!form["时间"].startDate) {
      //     this.$message.error("开始时间不能为空");
      //     flag = false;
      //     return;
      //   }
      // }
      // console.log("isPost", isPost);
      if (!form["时间"].startDate) {
        this.$message.error("开始时间不能为空");
        flag = false;
        return;
      } else {
        if (form.eventRadio === undefined) {
          this.$message.error("请选择时间类型");
          flag = false;
          return;
        } else if (form.eventRadio === 2) {
          if (!form["时间"].endDate) {
            this.$message.error("结束时间不能为空");
            flag = false;
            return;
          } else {
            if (
              new Date(form["时间"].startDate).getTime() >
              new Date(form["时间"].endDate).getTime()
            ) {
              this.$message.error("时间范围不正确");
              return false;
            }
          }
        }
      }

      if (isPost) {
        if (!form["岗位名称"].dataValue) {
          this.$message.error("岗位名称不能为空");
          flag = false;
          return;
        }
        if (!form["内容"].dataValue) {
          this.$message.error("岗位描述不能为空");
          flag = false;
          return;
        }
        // if (!form["内容"].dataValue) {
        //   this.$message.error("岗位描述不能为空");
        //   flag = false;
        //   return;
        // }
      } else {
        if (!form["内容"].dataValue) {
          this.$message.error("事件描述不能为空");
          flag = false;
          return;
        }
      }

      return flag;
    },
    handleSubmitEduEventForm() {
      // console.log('handleSubmitEduEventForm');
      if (!this.validateEvent(this.eduEventForm)) return false;
      if (this.eduEventForm.type === "edit") {
        // console.log("###edit");
        let payloadEdit = {
          updateDataList: []
        };
        let payloadAdd = {};
        Object.keys(this.eduEventForm).forEach(key => {
          if (key !== "eventRadio" && key !== "type" && key !== "upId") {
            if (key === "fileList") {
            } else {
              if (
                this.eduEventForm[key] &&
                this.eduEventForm[key].dataId !== undefined
              ) {
                if (key === "附件") {
                  payloadEdit.updateDataList.push({
                    dataId: this.eduEventForm[key].dataId,
                    dataName: this.eduEventForm[key].dataName,
                    dataValue: this.fileList.map(item => item.url).toString(),
                    modifiable: true
                  });
                } else if (key === "时间") {
                  payloadEdit.updateDataList.push({
                    dataId: this.eduEventForm[key].dataId,
                    dataName: this.eduEventForm[key].dataName,
                    // dataValue:
                    //   this.eduEventForm.eventRadio === 0
                    //     ? this.eduEventForm[key].startDate +
                    //       "," +
                    //       this.eduEventForm[key].endDate
                    //     : this.eduEventForm[key].startDate,
                    dataValue:
                      this.eduEventForm[key].startDate +
                      "," +
                      this.eduEventForm[key].endDate,
                    modifiable: true
                  });
                } else {
                  payloadEdit.updateDataList.push({
                    dataId: this.eduEventForm[key].dataId,
                    dataName: this.eduEventForm[key].dataName,
                    dataValue: this.eduEventForm[key].dataValue,
                    modifiable: true
                  });
                }
              } else {
                payloadAdd = {
                  [this.eduEventForm.upId]: [{}]
                };
                if (key === "附件") {
                  payloadAdd[this.eduEventForm.upId][0][
                    key
                  ] = this.fileList.map(item => item.url).toString();
                } else if (key === "时间") {
                  payloadAdd[this.eduEventForm.upId][0][key] =
                    this.eduEventForm.eventRadio === 0
                      ? this.eduEventForm[key].startDate +
                        "," +
                        this.eduEventForm[key].endDate
                      : this.eduEventForm[key].startDate;
                } else {
                  payloadAdd[this.eduEventForm.upId][0][
                    key
                  ] = this.eduEventForm[key].dataValue;
                }
                let v2payloadAdd = {
                  jsonObject: payloadAdd
                };
                if (payloadAdd[this.eduEventForm.upId][0]["附件"] != "") {
                  updatePersonalInfo(v2payloadAdd);
                }
              }
            }
          }
        });
        // console.log(payloadEdit);
        updateWithDataId(payloadEdit).then(res => {
          if (res.data.c === 200) {
            this.$message.success("修改成功");
            this.eduEventForm = undefined;
            this.getList();
          }
        });
      } else {
        let payload = {
          [this.list["学历教育"][this.eduIndex]["上级Id"]]: [
            {
              "事件/活动记录": [
                {
                  内容: this.eduEventForm["内容"].dataValue,
                  时间: `${this.eduEventForm["时间"].startDate},${this.eduEventForm["时间"].endDate}`,
                  附件: this.fileList.map(item => item.url).toString()
                }
              ]
            }
          ]
        };
        if (
          payload[this.list["学历教育"][this.eduIndex]["上级Id"]][0][
            "事件/活动记录"
          ][0]["内容"] === "" ||
          payload[this.list["学历教育"][this.eduIndex]["上级Id"]][0][
            "事件/活动记录"
          ][0]["内容"] === undefined
        ) {
          delete payload[this.list["学历教育"][this.eduIndex]["上级Id"]][0][
            "事件/活动记录"
          ][0]["内容"];
        }
        let time = [];
        payload[this.list["学历教育"][this.eduIndex]["上级Id"]][0][
          "事件/活动记录"
        ][0]["时间"]
          .split(",")
          .map((item, index) => {
            if (item !== "undefined" && item !== "") {
              time.push(item);
            }
          });
        payload[this.list["学历教育"][this.eduIndex]["上级Id"]][0][
          "事件/活动记录"
        ][0]["时间"] = time.toString();

        if (
          payload[this.list["学历教育"][this.eduIndex]["上级Id"]][0][
            "事件/活动记录"
          ][0]["附件"] === ""
        ) {
          delete payload[this.list["学历教育"][this.eduIndex]["上级Id"]][0][
            "事件/活动记录"
          ][0]["附件"];
        }
        let v2payload = {
          jsonObject: payload
        };
        console.log("v2payload", v2payload);
        updatePersonalInfo(v2payload).then(res => {
          if (res.data.c === 200) {
            this.eduEventForm = undefined;
            this.$message.success("提交成功");
            this.getList();
          }
        });
      }
    },
    handleAddNoEduEvent(index) {
      this.fileList = [];
      this.noEduIndex = index;
      this.noEduEventForm = {
        type: "add",
        // eventRadio: 0,
        eventRadio: undefined,
        时间: {
          startDate: undefined,
          endDate: undefined
        },
        内容: { dataValue: "" },
        附件: ""
      };
    },
    handleEditNoEduEvent(row, upId, index) {
      this.noEduIndex = index;
      let tempData = JSON.parse(JSON.stringify(row));
      this.fileList = [];
      this.noEduEventForm = {
        内容: { dataId: undefined, dataValue: "" },
        时间: { dataId: undefined, dataValue: "" },
        附件: { dataId: undefined, dataValue: "" },
        eventRadio: 0,
        upId,
        type: "edit"
      };
      if (tempData["时间"].dataValue.split(",")[1] === "当天") {
        this.noEduEventForm.eventRadio = 0;
      } else if (tempData["时间"].dataValue.split(",")[1] === "至今") {
        this.noEduEventForm.eventRadio = 1;
      } else {
        this.noEduEventForm.eventRadio = 2;
      }
      if (tempData["附件"]) {
        this.fileList = tempData["附件"].dataValue.split(",").map(item => {
          return { name: item.split(":")[2], url: item };
        });
      }

      Object.keys(tempData).forEach(key => {
        if (key === "上级Id") {
        } else if (key === "时间") {
          this.noEduEventForm[key] = {
            dataId: tempData[key].dataId,
            dataName: tempData[key].dataName,
            dataValue: tempData[key].dataValue,
            startDate: tempData["时间"]
              ? tempData["时间"].dataValue.split(",")[0]
              : undefined,
            endDate: tempData["时间"]
              ? tempData["时间"].dataValue.split(",")[1]
              : undefined
          };
        } else if (key === "附件") {
        } else {
          this.noEduEventForm[key] = tempData[key];
        }
      });
      this.formScoll("noEduEventForm");
    },
    handleSubmitNoEduEventForm() {
      if (!this.validateEvent(this.noEduEventForm)) return false;
      if (this.noEduEventForm.type === "edit") {
        let payloadEdit = {
          updateDataList: []
        };
        let payloadAdd = {};
        Object.keys(this.noEduEventForm).forEach(key => {
          if (key !== "eventRadio" && key !== "type" && key !== "upId") {
            if (key === "fileList") {
            } else {
              if (
                this.noEduEventForm[key] &&
                this.noEduEventForm[key].dataId !== undefined
              ) {
                if (key === "附件") {
                  payloadEdit.updateDataList.push({
                    dataId: this.noEduEventForm[key].dataId,
                    dataName: this.noEduEventForm[key].dataName,
                    dataValue: this.fileList.map(item => item.url).toString(),
                    modifiable: true
                  });
                } else if (key === "时间") {
                  payloadEdit.updateDataList.push({
                    dataId: this.noEduEventForm[key].dataId,
                    dataName: this.noEduEventForm[key].dataName,
                    // dataValue:
                    //   this.noEduEventForm.eventRadio === 0
                    //     ? this.noEduEventForm[key].startDate +
                    //       "," +
                    //       this.noEduEventForm[key].endDate
                    //     : this.noEduEventForm[key].startDate,
                    dataValue:
                      this.noEduEventForm[key].startDate +
                      "," +
                      this.noEduEventForm[key].endDate,
                    modifiable: true
                  });
                } else {
                  payloadEdit.updateDataList.push({
                    dataId: this.noEduEventForm[key].dataId,
                    dataName: this.noEduEventForm[key].dataName,
                    dataValue: this.noEduEventForm[key].dataValue,
                    modifiable: true
                  });
                }
              } else {
                payloadAdd = {
                  [this.noEduEventForm.upId]: [{}]
                };
                if (key === "附件") {
                  payloadAdd[this.noEduEventForm.upId][0][
                    key
                  ] = this.fileList.map(item => item.url).toString();
                } else if (key === "时间") {
                  payloadAdd[this.noEduEventForm.upId][0][key] =
                    this.noEduEventForm.eventRadio === 0
                      ? this.noEduEventForm[key].startDate +
                        "," +
                        this.noEduEventForm[key].endDate
                      : this.noEduEventForm[key].startDate;
                } else {
                  payloadAdd[this.noEduEventForm.upId][0][
                    key
                  ] = this.noEduEventForm[key].dataValue;
                }
                let v2payloadAdd = {
                  jsonObject: payloadAdd
                };
                if (payloadAdd[this.noEduEventForm.upId][0]["附件"] != "") {
                  updatePersonalInfo(v2payloadAdd);
                }
                // updatePersonalInfo(payloadAdd);
              }
            }
          }
        });
        updateWithDataId(payloadEdit).then(res => {
          if (res.data.c === 200) {
            this.$message.success("修改成功");
            this.noEduEventForm = undefined;
            this.getList();
          }
        });
      } else {
        let payload = {
          [this.list["非学历教育"][this.noEduIndex]["上级Id"]]: [
            {
              "事件/活动记录": [
                {
                  内容: this.noEduEventForm["内容"].dataValue,
                  // 时间:
                  //   this.noEduEventForm.eventRadio === 0
                  //     ? this.noEduEventForm["时间"].startDate +
                  //       "," +
                  //       this.noEduEventForm["时间"].endDate
                  //     : this.noEduEventForm["时间"].startDate,
                  时间:
                    this.noEduEventForm["时间"].startDate +
                    "," +
                    this.noEduEventForm["时间"].endDate,
                  附件: this.fileList.map(item => item.url).toString()
                }
              ]
            }
          ]
        };
        // if (
        //   payload[this.list["非学历教育"][this.noEduIndex]["上级Id"]][0][
        //     "事件/活动记录"
        //   ][0]["内容"] === "" ||
        //   payload[this.list["非学历教育"][this.noEduIndex]["上级Id"]][0][
        //     "事件/活动记录"
        //   ][0]["内容"] === undefined
        // ) {
        //   delete payload[this.list["非学历教育"][this.noEduIndex]["上级Id"]][0][
        //     "事件/活动记录"
        //   ][0]["内容"];
        // }
        // let time = [];

        // payload[this.list["非学历教育"][this.noEduIndex]["上级Id"]][0][
        //   "事件/活动记录"
        // ][0]["时间"]
        //   .split(",")
        //   .map((item, index) => {
        //     if (item !== "undefined" && item !== "") {
        //       time.push(item);
        //     }
        //   });
        // payload[this.list["非学历教育"][this.noEduIndex]["上级Id"]][0][
        //   "事件/活动记录"
        // ][0]["时间"] = time.toString();

        if (
          payload[this.list["非学历教育"][this.noEduIndex]["上级Id"]][0][
            "事件/活动记录"
          ][0]["附件"] === ""
        ) {
          delete payload[this.list["非学历教育"][this.noEduIndex]["上级Id"]][0][
            "事件/活动记录"
          ][0]["附件"];
        }
        let v2payload = {
          jsonObject: payload
        };

        updatePersonalInfo(v2payload).then(res => {
          if (res.data.c === 200) {
            this.noEduEventForm = undefined;
            this.getList();
          }
        });
      }
      // let payload = {
      //   [this.list["非学历教育"][this.noEduIndex]["上级Id"]]: [
      //     {
      //       "事件/活动记录": [
      //         {
      //           内容: this.noEduEventForm["内容"],
      //           时间:
      //             this.noEduEventForm.eventRadio === 0
      //               ? this.noEduEventForm["时间"].startDate +
      //                 "," +
      //                 this.noEduEventForm["时间"].endDate
      //               : this.noEduEventForm["时间"].startDate,
      //           附件: this.fileList.map(item => item.url).toString()
      //         }
      //       ]
      //     }
      //   ]
      // };
      // if (
      //   payload[this.list["非学历教育"][this.noEduIndex]["上级Id"]][0][
      //     "事件/活动记录"
      //   ][0]["附件"] === ""
      // ) {
      //   delete payload[this.list["非学历教育"][this.noEduIndex]["上级Id"]][0][
      //     "事件/活动记录"
      //   ][0]["附件"];
      // }
      // updatePersonalInfo(payload).then(res => {
      //   if (res.data.c === 200) {
      //     this.noEduEventForm = undefined;
      //     this.fileList = [];
      //     this.getList();
      //   }
      // });
    },
    handleEditProExpPost(row, upId, index) {
      this.proExpIndex = index;
      let tempData = JSON.parse(JSON.stringify(row));
      this.fileList = [];
      this.proExpPostForm = {
        岗位名称: { dataId: undefined, dataValue: "" },
        内容: { dataId: undefined, dataValue: "" },
        时间: { dataId: undefined, dataValue: "" },
        附件: { dataId: undefined, dataValue: "" },
        eventRadio: 0,
        upId,
        type: "edit"
      };
      if (tempData["时间"].dataValue.split(",")[1] === "当天") {
        this.proExpPostForm.eventRadio = 0;
      } else if (tempData["时间"].dataValue.split(",")[1] === "至今") {
        this.proExpPostForm.eventRadio = 1;
      } else {
        this.proExpPostForm.eventRadio = 2;
      }
      if (tempData["附件"]) {
        this.fileList = tempData["附件"].dataValue.split(",").map(item => {
          return { name: item.split(":")[2], url: item };
        });
      }
      Object.keys(tempData).forEach(key => {
        if (key === "上级Id") {
        } else if (key === "时间") {
          this.proExpPostForm[key] = {
            dataId: tempData[key].dataId,
            dataName: tempData[key].dataName,
            dataValue: tempData[key].dataValue,
            startDate: tempData["时间"]
              ? tempData["时间"].dataValue.split(",")[0]
              : undefined,
            endDate: tempData["时间"]
              ? tempData["时间"].dataValue.split(",")[1]
              : undefined
          };
        } else {
          this.proExpPostForm[key] = tempData[key];
        }
      });
      this.formScoll("proExpPostForm");
    },
    handleEditProExpEvent(row, upId, index) {
      this.proExpIndex = index;
      let tempData = JSON.parse(JSON.stringify(row));
      this.fileList = [];
      this.proExpEventForm = {
        内容: { dataId: undefined, dataValue: "" },
        时间: { dataId: undefined, dataValue: "" },
        附件: { dataId: undefined, dataValue: "" },
        eventRadio: 0,
        upId,
        type: "edit"
      };
      if (tempData["时间"].dataValue.split(",")[1] === "当天") {
        this.proExpEventForm.eventRadio = 0;
      } else if (tempData["时间"].dataValue.split(",")[1] === "至今") {
        this.proExpEventForm.eventRadio = 1;
      } else {
        this.proExpEventForm.eventRadio = 2;
      }
      if (tempData["附件"]) {
        this.fileList = tempData["附件"].dataValue.split(",").map(item => {
          return { name: item.split(":")[2], url: item };
        });
      }
      Object.keys(tempData).forEach(key => {
        if (key === "上级Id") {
        } else if (key === "时间") {
          this.proExpEventForm[key] = {
            dataId: tempData[key].dataId,
            dataName: tempData[key].dataName,
            dataValue: tempData[key].dataValue,
            startDate: tempData["时间"]
              ? tempData["时间"].dataValue.split(",")[0]
              : undefined,
            endDate: tempData["时间"]
              ? tempData["时间"].dataValue.split(",")[1]
              : undefined
          };
        } else {
          this.proExpEventForm[key] = tempData[key];
        }
      });
      this.formScoll("proExpEventForm");
    },
    dateChange(val) {},
    handlePreviewImg(url) {
      this.previewImgs = [];
      this.previewImgs.push(url);
      this.dialogPreview = true;
    },
    handleDialogPreviewClose() {
      this.dialogPreview = false;
    },
    handleDeleteEvent(dataId) {
      deleteInfo({
        dataId: dataId,
        deleteAll: false
      }).then(res => {
        this.$message.success("删除成功");
        this.getList();
      });
    },
    handleDeleteAll(dataId, formName) {
      this.confirmDeleteAll = true;
      this.deletePayload = {
        formName,
        params: dataId
      };
      // deleteInfo({ dataId:this.deletePayload.params, deleteAll: true }).then(res => {
      //   if (res.data.c === 200) {
      //     this.$message.success("删除成功");
      //     this.getList();
      //   }
      // });
    },
    formScoll(ref) {
      setTimeout(() => {
        this.$scrollTo("#" + ref, 500, {
          offset: -200
        });
      }, 100);
    },
    handleCertification() {
      this.$router.push("realNameAuthentication");
    },
    handleOpenDialogAddPhone(phoneNumber) {
      if (phoneNumber !== "") {
        // console.log(phoneNumber);
        this.dialogAddPhoneNumber = phoneNumber;
      }
      this.dialogAddPhone = true;
    },
    addPhoneClose() {
      this.dialogAddPhone = false;
      this.getList();
    },
    handleCheckAll1(data) {
      const { flag, key1, key2, index } = data;
      this.handleCheckAll(flag, key1, key2, index);
    },
    handleCheckedChange1(data) {
      const { flag, key1, key2, index } = data;
      this.handleCheckedChange(flag, key1, key2, index);
    },
    getBusinessNameList(type, name, list, cb) {
      list = [];
      businessNameList({
        type,
        name
      }).then(res => {
        res.data.d.map(item => {
          list.push({
            name: item.name,
            authentication: item.authentication,
            date: item.date
          });
        });
        var results = name
          ? list.filter(item => item.name.includes(name))
          : list;
        cb(results);
      });
    },
    queryEduSearch(queryString, cb) {
      this.eduFormAgent.businessNameAuthenticationTag = false;
      this.getBusinessNameList(
        "ACADEMIC_EDUCATION",
        queryString,
        this.eduNameList,
        cb
      );
    },
    queryNoEduSearch(queryString, cb) {
      this.noEduFormAgent.businessNameAuthenticationTag = false;
      this.getBusinessNameList(
        "NON_ACADEMIC_EDUCATION",
        queryString,
        this.noEduNameList,
        cb
      );
    },
    queryProExpSearch(queryString, cb) {
      this.proExpFormAgent.businessNameAuthenticationTag = false;
      this.getBusinessNameList(
        "EMPLOYER",
        queryString,
        this.proExpNameList,
        cb
      );
    },
    isPromised() {
      if (this.userInfo.firstWritePromise === false) {
        this.$nextTick(() => {
          this.$refs.promise.handleShow();
        });
        return false;
      } else {
        return true;
      }
    },
    handleAgreePromise(userInfo) {
      this.userInfo = userInfo;
    },
    endDateTypeChange(type, form) {
      console.log("endDateTypeChange");
      // form["时间"][1] = null;
      switch (type) {
        case 0:
          form["时间"][1] = "当天";
          break;
        case 1:
          form["时间"][1] = "至今";
          break;
        case 2:
        default:
          form["时间"][1] = null;
          break;
      }
      this.$forceUpdate();
      // form['时间'][1]
    },
    eventEndDateTypeChange(type, form) {
      switch (type) {
        case 0:
          form["时间"].endDate = "当天";
          break;
        case 1:
          form["时间"].endDate = "至今";
          break;
        case 2:
        default:
          form["时间"].endDate = null;
          break;
      }
      this.$forceUpdate();
    },
    handleSelectAuto(val, key) {
      switch (key) {
        case "学历教育":
          this.eduForm["教育机构"] = val.name;
          // this.eduFormAgent.businessNameAuthenticationName = val.name;
          this.eduFormAgent.businessNameAuthenticationTag = val.authentication;
          break;
        case "非学历教育":
          this.noEduForm["教育机构"] = val.name;
          // this.noEduFormAgent.businessNameAuthenticationName = val.name;
          this.noEduFormAgent.businessNameAuthenticationTag =
            val.authentication;
          break;
        case "职业经历":
          this.proExpForm["单位名称"] = val.name;
          // this.proExpFormAgent.businessNameAuthenticationName = val.name;
          this.proExpFormAgent.businessNameAuthenticationTag =
            val.authentication;
          break;
      }
    },
    handleAgencyApply(name, superiorId) {
      this.agencyApplyForm = {
        businessNameAuthenticationName: name,
        superiorId
      };
      this.dialogAgencyApply = true;
    },
    handleSubmitAgencyApply(row) {
      agencyApply(this.agencyApplyForm).then(res => {
        if (res.data.c === 200) {
          this.$message.success("提交成功");
          this.dialogAgencyApply = false;
          this.getList();
        }
      });
    },
    handleStageChange() {
      this.eduForm = {
        时间: new Array(2),
        endDateType: undefined
      };
      this.fileList = [];
    }
  },
  watch: {
    $route: {
      handler(val) {
        console.log(val);
        this.isSelect = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.personalServer {
  background: #fff;
  margin: 39px 0 124px 17px;
  padding: 38px 40px 77px 40px;
  flex: 1;
  position: relative;
  .btn_isInvalid {
    position: absolute;
    right: 40px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #878787;
    cursor: pointer;
    display: flex;
    align-items: center;
    .icon_showInvalid {
      background: url("../../assets/icon_showInvalid.png");
      background-size: cover;
      display: inline-block;
      width: 19px;
      height: 14px;
      margin-right: 9px;
    }
    .icon_hideInvalid {
      background: url("../../assets/icon_hideInvalid.png");
      background-size: cover;
      display: inline-block;
      width: 20px;
      height: 14px;
      margin-right: 9px;
    }
  }
  // .title {
  //   margin-bottom: 22px;
  //   font-weight: bold;
  //   display: flex;
  //   justify-content: space-between;
  //   align-items: center;
  //   font-size: 20px;
  .mainTitle {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #393939;
    margin-bottom: 28px;
    &::before {
      content: "";
      border-left: 3px solid #3a61b1;
      padding-right: 10px;
      height: 16px;
      position: relative;
      top: 0px;
    }
  }
  // }
  .topTip {
    // margin-bottom: 40px;
    padding: 29px 39px 20px 38px;
    background: #f7f9fd;
    display: flex;
    // align-items: center;
    color: #7e7e7e;
    font-size: 14px;
    .description {
      display: flex;
      flex-direction: column;
      justify-content: center;
      color: #7986a0;
      line-height: 24px;
      span {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #7986a0;
        line-height: 24px;
      }
      // justify-content: space-between;
      // align-items: center;
    }
    .pi1 {
      width: 87px;
      height: 69px;
      margin-right: 24px;
    }
  }

  .piList {
    .piItem {
      margin-bottom: 68px;
      .piTitle {
        display: flex;
        position: relative;
        font-size: 20px;
        font-weight: bold;
        // justify-content: center;
        justify-content: space-between;
        align-items: center;
        // cursor: pointer;
        // &::before {
        //   content: "";
        //   border-left: 3px solid #3a61b1;
        //   height: 16px;
        //   // top: 6px;
        //   position: relative;
        //   margin-right: 10px;
        // }
        .titleName {
          flex: 1;
          color: #393939;
        }
        .toggled {
          cursor: pointer;
          position: absolute;
          right: 0;
          // top:3px;
          background: #e9ecf3;
          width: 22px;
          height: 22px;
          &::after {
            content: "";
            border-bottom: 2px solid #3a61b1;
            background: #e9ecf3;
            width: 12px;
            position: absolute;
            right: 5px;
            top: 11px;
          }
        }
        .toggle {
          cursor: pointer;
          position: absolute;
          right: 0;
          // top:3px;
          background: #e9ecf3;
          width: 22px;
          height: 22px;
          &::after {
            content: "";
            border-bottom: 2px solid #3a61b1;
            background: #e9ecf3;
            width: 12px;
            position: absolute;
            right: 5px;
            top: 11px;
          }
          &::before {
            content: "";
            border-left: 2px solid #3a61b1;
            background: #e9ecf3;
            height: 12px;
            position: absolute;
            right: 10px;
            top: 6px;
          }
        }
      }
      .infoList {
        border: 1px solid #f1f1f1;
        margin-top: 31px;
        padding: 22px 37px 11px 24px;
        .infoItem {
          //   padding: 22px 37px 26px 24px;
          //   .name {
          //     margin-top: 20px;
          //     &:first-child{
          //         margin-top: 0;
          //     }
          //   }
          .name {
            font-weight: bold;
          }
          .value {
            font-weight: bold;
          }
          margin-bottom: 30px;
          // .deleteTag {
          //   background: #fff !important;
          //   border: 1px solid #f1f1f1 !important;
          //   .value1 {
          //     text-decoration: line-through;
          //   }
          // }
          .valueBox {
            background: #e7ecf6;
            margin-top: 19px;
            padding: 25px 37px 29px 24px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 16px;
            margin-bottom: 20px;
            .value {
              margin-bottom: 11px;
            }
            .source {
              color: #878787;
              font-size: 14px;
            }
            .operations {
              cursor: pointer;
              span {
                font-size: 16px;
                margin-left: 13px;
                color: #3a61b1;
              }
            }
            .inputDiv {
              width: 100%;
              display: flex;
              flex-direction: column;
              .btns {
                margin-top: 14px;
                display: flex;
              }
            }
          }
        }
      }
      // .eduLayout {
      //   padding: 41px 31px 39px 31px;
      //   border: 1px solid #f1f1f1;
      //   margin-top: 26px;
      //   .eduList {

      //   }
      //   .eduForm {
      //     background: #e7ecf6;
      //     padding: 35px 23px 55px 24px;
      //     font-size: #6e6e6e;
      //   }
      // }
      .eduList {
        padding: 41px 31px 8px 31px;
        border: 1px solid #f1f1f1;
        margin-top: 26px;
        .eduItem {
          background: #e7ecf6;
          padding: 35px 25px 25px 25px;
          margin-bottom: 31px;
          // display: flex;
          // justify-content: space-between;
          .eduItemPanel {
            display: flex;
            justify-content: space-between;
            // align-items: center;
            flex-direction: column;

            .eduItem_l {
              .eduItem_l_t {
                color: #393939;
                font-size: 18px;
                margin-bottom: 10px;
              }
              .eduItem_l_b {
                color: #878787;
                font-size: 14px;
              }
            }
            .eduItem_r {
              .eduItem_r_t {
                font-size: 20px;
                color: #393939;
                position: relative;
                margin-bottom: 10px;
                // padding-right: 30px;
                display: flex;
                justify-content: flex-end;
                font-weight: bold;
                .toggled {
                  cursor: pointer;
                  position: relative;
                  margin-left: 30px;
                  right: 0;
                  top: 3px;
                  background: #bdc9e3;
                  width: 22px;
                  height: 22px;
                  &::after {
                    content: "";
                    border-bottom: 2px solid #3a61b1;
                    background: #bdc9e3;
                    width: 12px;
                    position: absolute;
                    right: 5px;
                    top: 11px;
                  }
                }
                .toggle {
                  cursor: pointer;
                  right: 0;
                  top: 3px;
                  background: #bdc9e3;
                  width: 22px;
                  height: 22px;
                  margin-left: 30px;
                  display: inline-block;
                  position: relative;
                  &::after {
                    content: "";
                    border-bottom: 2px solid #3a61b1;
                    background: #bdc9e3;
                    width: 12px;
                    position: absolute;
                    right: 5px;
                    top: 11px;
                  }
                  &::before {
                    content: "";
                    border-left: 2px solid #3a61b1;
                    background: #bdc9e3;
                    height: 12px;
                    position: absolute;
                    right: 10px;
                    top: 6px;
                  }
                }
              }
              .eduItem_r_b {
                text-align: right;
                span {
                  color: #787878;
                  font-size: 14px;
                  margin-left: 13px;
                  cursor: pointer;
                  font-weight: 500;
                }
              }
            }
            .panel_top {
              display: flex;
              justify-content: space-between;
              width: 100%;
              align-items: center;
              .panel_top_left {
                .panel_top_left_top {
                  font-size: 18px;
                  font-family: PingFang SC;
                  font-weight: 600;
                  color: #393939;
                }
                .panel_top_left_bottom {
                  font-size: 14px;
                  font-family: PingFang SC;
                  font-weight: 400;
                  color: #878787;
                  margin-top: 5px;
                }
              }
              .panel_top_right {
                .jigourenzheng {
                  color: #3a61b1;
                  cursor: pointer;
                }
                span {
                  font-size: 14px;
                  font-family: PingFang SC;
                  font-weight: 400;
                  color: #878787;
                }
              }
            }
            .panel_bottom {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-top: 15px;
              .panel_bottom_left {
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #878787;
                // margin-top: 5px;
                // .renzhengBox {
                //   background: #d8e2f6;
                //   border-radius: 4px;
                //   height: 31px;
                //   display: flex;
                //   align-items: center;
                //   padding: 0 10px;
                //   .icon_yirenzheng {
                //     background: url("../../assets/icon_yirenzheng.png");
                //     background-size: cover;
                //     display: inline-block;
                //     width: 13px;
                //     height: 13px;
                //     margin-right: 4px;
                //   }
                //   .renzhengText {
                //     font-size: 14px;
                //     font-family: PingFang SC;
                //     font-weight: 400;
                //     color: #878787;
                //   }
                //   .renzhengNum {
                //     color: #ff6262;
                //   }
                //   .inviteText {
                //     font-size: 14px;
                //     font-family: PingFang SC;
                //     font-weight: 400;
                //     color: #3a61b1;
                //   }
                // }
              }
              .panel_bottom_right {
                span {
                  color: #787878;
                  font-size: 16px;
                  margin-left: 13px;
                  cursor: pointer;
                }
              }
            }
            .panel_toggle {
              display: flex;
              justify-content: center;
            }
          }
          .eduItemDetails {
            padding: 42px 0 0 31px;

            .eduItemDetail {
              display: flex;
              // justify-content: space-between;
              // align-items: flex-end;
              margin-bottom: 47px;
              flex-direction: column;
              .value {
                font-size: 16px;
                color: #393939;
                margin-bottom: 10px;
                font-weight: bold;
                // max-width: 500px;
              }
              .files {
                .file {
                  position: relative;
                  background: #d1dbee;
                  height: 90px;
                  display: flex;
                  padding: 0 28px 0 31px;
                  justify-content: space-between;
                  align-items: center;
                  margin-bottom: 20px;
                  &:last-child {
                    margin-bottom: 0;
                  }
                  .fileName {
                    color: #3a5891;
                    cursor: pointer;
                    font-weight: bold;
                  }
                  .updateDate {
                    color: #878787;
                    font-size: 14px;
                  }
                  .operation {
                    span {
                      color: #3a61b1;
                      font-size: 16px;
                      margin-left: 13px;
                      cursor: pointer;
                    }
                  }
                }
              }
              .textareaText {
                color: #6e6e6e;
                margin-top: 13px;
              }
              .valueInfo {
                display: flex;
                justify-content: space-between;
                .updateDate {
                  color: #878787;
                  font-size: 14px;
                }
                .operation {
                  span {
                    color: #787878;
                    font-size: 16px;
                    margin-left: 13px;
                    cursor: pointer;
                  }
                }
              }

              // .eduItemDetailInfo {
              //   font-size: 16px;
              //   .value {
              //     color: #393939;
              //     margin-bottom: 10px;
              //   }
              //   .updateDate {
              //     color: #878787;
              //   }
              // }
              // .operation {
              //   span {
              //     color: #3a61b1;
              //     font-size: 14px;
              //     margin-left: 13px;
              //   }
              // }
            }
          }
        }
        .eduForm {
          background: #e7ecf6;
          padding: 35px 23px 55px 24px;
          color: #6e6e6e;
          margin-top: 31px;
          margin-bottom: 23px;
          .icon_warning {
            background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_warning.png")
              no-repeat;
            background-size: cover;
            display: inline-block;
            margin-right: 8px;
            width: 16px;
            height: 16px;
            vertical-align: middle;
          }
        }
      }
    }
  }
  .selectLayout {
    border-top: 2px solid #f2f2f2;
    padding-bottom: 32px;
    padding-top: 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .fileList {
    .fileItem {
      // padding: 16px 16px 17px 12px;
      height: 48px;
      display: flex;
      justify-content: space-between;
      border-radius: 4px;
      padding-left: 12px;
      padding-right: 16px;
      align-items: center;
      color: #6e6e6e;
      &:hover {
        background: #d1dbee;
      }
      .icon_fileRemove {
        width: 13px;
        height: 13px;
        display: inline-block;
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_fileRemove.png")
          no-repeat;
        background-size: cover;
        cursor: pointer;
      }
      .icon_fileSuccess {
        width: 18px;
        height: 18px;
        display: inline-block;
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_fileSuccess.png")
          no-repeat;
        background-size: cover;
      }
    }
  }

  >>> .timeLine {
    display: inline-block;
    width: 100%;
    margin-top: 20px;
    .el-input__prefix {
      .el-icon-date {
        display: none;
      }
    }
    .el-form-item {
      margin-bottom: 20px;
    }
    .el-date-editor--year,
    .el-date-editor--month,
    .el-date-editor--date {
      .el-input__inner {
        padding-left: 18px;
      }
    }
    .timeLineOptions {
      position: absolute;
      right: 0;
      top: 13px;
      color: #3a61b1;
      font-weight: 500;
      span {
        margin-left: 15px;
      }
    }
    .el-timeline-item__tail {
      position: absolute;
      left: 5px;
      top: 15px;
      height: 100%;
      // border-left: 1px solid rgba(58, 97, 177, 0.33);
      border-left: 0;
    }
    .el-timeline-item__wrapper {
      position: relative;
      padding-left: 18px;
      top: 3px;
    }
    // .el-timeline-item__node {
    //   background-color: #3a61b1;
    // }
    .el-timeline-item__node--normal {
      left: 2px;
      width: 7px;
      height: 7px;
      top: 13px;
      border: 2px solid #3a61b1;
    }
    .dateContent {
      color: #393939;
      font-size: 16px;
      max-width: 500px;
    }
    .timestamp {
      color: #878787;
      font-size: 16px;
    }
    .updatePostForm {
      >>> .el-upload__tip {
        font-size: 14px;
        margin-top: 0;
      }
      .el-upload--text {
        color: #3a61b1;
        text-decoration: underline;
      }
      .btn_submit {
        width: 69px;
        height: 30px;
        background: #3a61b1;
        border-radius: 15px;
        color: #fff;
        border: 0;
        margin-right: 13px;
        cursor: pointer;
      }
      .btn_cancel {
        width: 69px;
        height: 30px;
        background: #e7ecf6;
        border: 1px solid #3a61b1;
        border-radius: 15px;
        color: #3a61b1;
        cursor: pointer;
      }
      .updatePostItem {
        margin-bottom: 20px;
        label {
          width: 92px;
          text-align: left;
        }
        display: flex;
        .datePickerItem {
          display: flex;
          width: 100%;
          .monthPicker {
            &:last-child {
              margin-right: 0;
            }
          }
        }
        .textareaLayout {
          display: inline-block;
        }
      }

      .el-form-item {
        margin-bottom: 20px;

        .el-form-item__label {
          width: 92px;
          text-align: left;
        }
        .el-form-item__content {
          display: flex;
          justify-content: space-between;
        }
      }
    }
    .eventItem {
      flex: 1;
      color: #393939;
      font-size: 16px;
      .details {
        margin-left: 23px;
        line-height: 30px;
      }
      .deleteLine {
        text-decoration: line-through;
      }
      .operations {
        span {
          color: #787878;
          font-size: 16px;
          // margin-left: 13px;
          cursor: pointer;
          font-weight: 500;
        }
      }
      .eventDate {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        top: 3px;
      }
      .eventContent {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        margin-top: 10px;
        margin-bottom: 10px;
        .eContent {
          max-width: 500px;
          word-break: break-all;
        }
      }
      .eventUpdateDate {
        color: #878787;
        font-weight: 500;
        font-size: 14px;
        margin-top: 5px;
      }
      // .eventFile {
      //   display: flex;
      //   background: #d1dbee;
      //   padding: 20px;
      //   line-height: 30px;
      //   margin-top: 20px;
      //   flex-direction: column;
      //   .eventFileLayout {
      //     display: flex;
      //     .eventFileList {
      //       flex: 1;

      //       .eventFileItem {
      //       }
      //     }
      //   }
      // }
    }
  }
  .eventFile {
    display: flex;
    background: #d1dbee;
    padding: 20px;
    line-height: 30px;
    margin-top: 15px;
    flex-direction: column;
    .eventFileLayout {
      display: flex;
      .eventFileList {
        flex: 1;

        .eventFileItem {
          color: #3a5891;
          cursor: pointer;
        }
      }
    }
  }
  .el-checkbox-group {
    font-size: inherit;
  }
  >>> .el-checkbox:last-of-type {
    margin-right: 10px;
  }
  .reportForm {
    border-radius: 20.5px;
    width: 464px;
    background: #fff;
    padding: 25px 60px 55px 60px;
    box-sizing: border-box;
    .title {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #6e6e6e;
      line-height: 41px;
      text-align: center;
    }
    .tip {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      margin-top: 30px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #a3a3a3;
      // line-height: 24px;
    }
    .icon_warning {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_warning.png")
        no-repeat;
      background-size: cover;
      display: inline-block;
      margin-right: 8px;
      width: 16px;
      height: 16px;
      vertical-align: middle;
    }
    .btns {
      text-align: center;
      display: flex;
      justify-content: space-between;
    }
  }
}
.selectTip {
  padding: 23px;
  background: #fffbf9;
  border: 1px solid #ffb3a4;
  box-sizing: border-box;
  margin-bottom: 24px;
  .icon_tip {
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_warning.png")
      no-repeat;
    background-size: cover;
    display: inline-block;
    margin-right: 13px;
    width: 20px;
    height: 20px;
  }
}
#warning {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.warning {
  // height: 60px;
  // background: #f7f9fd;
  // border: 1px solid #ffb3a4;
  // padding-left: 24px;

  display: flex;
  align-items: center;
  margin-bottom: 27px;
  .tipText {
    span {
      color: #ff8d65;
    }
  }
}
.deleteTag {
  background: #fff !important;
  border: 1px solid #f1f1f1 !important;
  .value1 {
    text-decoration: line-through;
  }
  .eduItem_l_t {
    .date {
      text-decoration: line-through;
    }
  }
  .panel_top_left_top {
    .date {
      text-decoration: line-through;
    }
  }
}
.deleteLine {
  text-decoration: line-through;
}
.mw500 {
  max-width: 500px;
}
>>> .el-checkbox__input {
  vertical-align: bottom;
}
>>> .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #2ec99f;
  border-color: #2ec99f;
}
>>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266;
}
>>> .el-checkbox__inner {
  width: 20px;
  height: 20px;
  border: 2px solid #dce0e6;
  border-radius: 4px;
  z-index: 0;
}
>>> .el-checkbox__inner::after {
  height: 9px;
  left: 5px;
  position: absolute;
  top: 1px;
  width: 4px;
  z-index: 0;
}
>>> .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
  content: "";
  position: absolute;
  display: block;
  background-color: #fff;
  height: 2px;
  -webkit-transform: scale(0.5);
  transform: scale(0.5);
  left: 0;
  right: 0;
  top: 7px;
}

.confirmBox {
  background: #fff;
  width: 430px;
  height: 226px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 16px;
  .title {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #393939;
    line-height: 41px;
  }
  .text {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #8d8d8d;
    line-height: 24px;
  }
  .btns {
    margin-top: 31px;
    button {
      &:last-child {
        margin-left: 35px;
      }
    }
  }
}
>>> .el-upload__tip {
  font-size: 14px;
  margin-top: 0;
  color: #6e6e6e;
}
.btn_addEvent {
  color: #3a61b1;
  text-decoration: underline;
  margin-top: 25px;
  margin-bottom: 15px;
  display: inline-block;
  cursor: pointer;
  font-weight: 500;
}
.icon_warning {
  background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_warning.png")
    no-repeat;
  background-size: cover;
  display: inline-block;
  margin-right: 8px;
  width: 16px;
  height: 16px;
  vertical-align: middle;
}
.icon_edit {
  width: 16px;
  height: 16px;
  display: inline-block;
  background: url("../../assets/icon_edit.png");
  background-size: cover;
  margin-right: 10px;
  position: relative;
  top: 2px;
}
.icon_delete {
  width: 15px;
  height: 16px;
  display: inline-block;
  background: url("../../assets/icon_delete.png");
  background-size: cover;
  margin-right: 10px;
  position: relative;
  top: 2px;
}
.icon_corrigendum {
  width: 16px;
  height: 15px;
  display: inline-block;
  background: url("../../assets/icon_corrigendum.png");
  background-size: cover;
  margin-right: 10px;
  position: relative;
  top: 2px;
}
.icon_dataSource {
  width: 15px;
  height: 15px;
  display: inline-block;
  background: url("../../assets/icon_dataSource.png");
  background-size: cover;
  margin-right: 10px;
  position: relative;
  top: 2px;
}
.icon_renzheng {
  width: 15px;
  height: 18px;
  display: inline-block;
  background: url("../../assets/icon_renzheng.png");
  background-size: cover;
  margin-right: 6px;
  position: relative;
  top: 3px;
}
.my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/list.vue